import {
	BsFillAlarmFill,
	BsFillArchiveFill,
	BsFillArrowDownCircleFill,
	BsFillArrowDownLeftCircleFill,
	BsFillArrowDownLeftSquareFill,
	BsFillArrowDownRightCircleFill,
	BsFillArrowDownRightSquareFill,
	BsFillArrowDownSquareFill,
	BsFillArrowLeftCircleFill,
	BsFillArrowLeftSquareFill,
	BsFillArrowRightCircleFill,
	BsFillArrowRightSquareFill,
	BsFillArrowUpCircleFill,
	BsFillArrowUpLeftCircleFill,
	BsFillArrowUpLeftSquareFill,
	BsFillArrowUpRightCircleFill,
	BsFillArrowUpRightSquareFill,
	BsFillArrowUpSquareFill,
	BsFillAspectRatioFill,
	BsFillAwardFill,
	BsFillBackspaceFill,
	BsFillBackspaceReverseFill,
	BsFillBadge3DFill,
	BsFillBadge4KFill,
	BsFillBadge8KFill,
	BsFillBadgeAdFill,
	BsFillBadgeArFill,
	BsFillBadgeCcFill,
	BsFillBadgeHdFill,
	BsFillBadgeTmFill,
	BsFillBadgeVoFill,
	BsFillBadgeVrFill,
	BsFillBadgeWcFill,
	BsFillBagCheckFill,
	BsFillBagDashFill,
	BsFillBagFill,
	BsFillBagPlusFill,
	BsFillBagXFill,
	BsFillBarChartFill,
	BsFillBarChartLineFill,
	BsFillBasketFill,
	BsFillBasket2Fill,
	BsFillBasket3Fill,
	BsFillBellFill,
	BsFillBellSlashFill,
	BsFillBinocularsFill,
	BsFillBookFill,
	BsFillBookmarkCheckFill,
	BsFillBookmarkDashFill,
	BsFillBookmarkFill,
	BsFillBookmarkHeartFill,
	BsFillBookmarkPlusFill,
	BsFillBookmarkStarFill,
	BsFillBookmarkXFill,
	BsFillBookmarksFill,
	BsFillBootstrapFill,
	BsFillBriefcaseFill,
	BsFillBrightnessAltHighFill,
	BsFillBrightnessAltLowFill,
	BsFillBrightnessHighFill,
	BsFillBrightnessLowFill,
	BsFillBrushFill,
	BsFillBucketFill,
	BsFillBugFill,
	BsFillCalculatorFill,
	BsFillCalendarCheckFill,
	BsFillCalendarDateFill,
	BsFillCalendarDayFill,
	BsFillCalendarEventFill,
	BsFillCalendarFill,
	BsFillCalendarMinusFill,
	BsFillCalendarMonthFill,
	BsFillCalendarPlusFill,
	BsFillCalendarRangeFill,
	BsFillCalendarWeekFill,
	BsFillCalendarXFill,
	BsFillCalendar2CheckFill,
	BsFillCalendar2DateFill,
	BsFillCalendar2DayFill,
	BsFillCalendar2EventFill,
	BsFillCalendar2Fill,
	BsFillCalendar2MinusFill,
	BsFillCalendar2MonthFill,
	BsFillCalendar2PlusFill,
	BsFillCalendar2RangeFill,
	BsFillCalendar2WeekFill,
	BsFillCalendar2XFill,
	BsFillCalendar3EventFill,
	BsFillCalendar3Fill,
	BsFillCalendar3RangeFill,
	BsFillCalendar3WeekFill,
	BsFillCameraFill,
	BsFillCameraReelsFill,
	BsFillCameraVideoFill,
	BsFillCameraVideoOffFill,
	BsFillCapslockFill,
	BsFillCaretDownFill,
	BsFillCaretDownSquareFill,
	BsFillCaretLeftFill,
	BsFillCaretLeftSquareFill,
	BsFillCaretRightFill,
	BsFillCaretRightSquareFill,
	BsFillCaretUpFill,
	BsFillCaretUpSquareFill,
	BsFillCartCheckFill,
	BsFillCartDashFill,
	BsFillCartFill,
	BsFillCartPlusFill,
	BsFillCartXFill,
	BsFillChatDotsFill,
	BsFillChatFill,
	BsFillChatLeftDotsFill,
	BsFillChatLeftFill,
	BsFillChatLeftQuoteFill,
	BsFillChatLeftTextFill,
	BsFillChatQuoteFill,
	BsFillChatRightDotsFill,
	BsFillChatRightFill,
	BsFillChatRightQuoteFill,
	BsFillChatRightTextFill,
	BsFillChatSquareDotsFill,
	BsFillChatSquareFill,
	BsFillChatSquareQuoteFill,
	BsFillChatSquareTextFill,
	BsFillChatTextFill,
	BsFillCheckCircleFill,
	BsFillCheckSquareFill,
	BsFillCircleFill,
	BsFillClockFill,
	BsFillCloudArrowDownFill,
	BsFillCloudArrowUpFill,
	BsFillCloudCheckFill,
	BsFillCloudDownloadFill,
	BsFillCloudDrizzleFill,
	BsFillCloudFill,
	BsFillCloudFogFill,
	BsFillCloudFog2Fill,
	BsFillCloudHailFill,
	BsFillCloudHazeFill,
	BsFillCloudHaze2Fill,
	BsFillCloudLightningFill,
	BsFillCloudLightningRainFill,
	BsFillCloudMinusFill,
	BsFillCloudMoonFill,
	BsFillCloudPlusFill,
	BsFillCloudRainFill,
	BsFillCloudRainHeavyFill,
	BsFillCloudSlashFill,
	BsFillCloudSleetFill,
	BsFillCloudSnowFill,
	BsFillCloudSunFill,
	BsFillCloudUploadFill,
	BsFillCloudsFill,
	BsFillCloudyFill,
	BsFillCollectionFill,
	BsFillCollectionPlayFill,
	BsFillCompassFill,
	BsFillCpuFill,
	BsFillCreditCard2BackFill,
	BsFillCreditCard2FrontFill,
	BsFillCreditCardFill,
	BsFillCupFill,
	BsFillCursorFill,
	BsFillDashCircleFill,
	BsFillDashSquareFill,
	BsFillDiagram2Fill,
	BsFillDiagram3Fill,
	BsFillDiamondFill,
	BsFillDice1Fill,
	BsFillDice2Fill,
	BsFillDice3Fill,
	BsFillDice4Fill,
	BsFillDice5Fill,
	BsFillDice6Fill,
	BsFillDiscFill,
	BsFillDisplayFill,
	BsFillDoorClosedFill,
	BsFillDoorOpenFill,
	BsFillDropletFill,
	BsFillEaselFill,
	BsFillEggFill,
	BsFillEjectFill,
	BsFillEmojiAngryFill,
	BsFillEmojiDizzyFill,
	BsFillEmojiExpressionlessFill,
	BsFillEmojiFrownFill,
	BsFillEmojiHeartEyesFill,
	BsFillEmojiLaughingFill,
	BsFillEmojiNeutralFill,
	BsFillEmojiSmileFill,
	BsFillEmojiSmileUpsideDownFill,
	BsFillEmojiSunglassesFill,
	BsFillEmojiWinkFill,
	BsFillEnvelopeFill,
	BsFillEnvelopeOpenFill,
	BsFillEraserFill,
	BsFillExclamationCircleFill,
	BsFillExclamationDiamondFill,
	BsFillExclamationOctagonFill,
	BsFillExclamationSquareFill,
	BsFillExclamationTriangleFill,
	BsFillEyeFill,
	BsFillEyeSlashFill,
	BsFillFileArrowDownFill,
	BsFillFileArrowUpFill,
	BsFillFileBarGraphFill,
	BsFillFileBinaryFill,
	BsFillFileBreakFill,
	BsFillFileCheckFill,
	BsFillFileCodeFill,
	BsFillFileDiffFill,
	BsFillFileEarmarkArrowDownFill,
	BsFillFileEarmarkArrowUpFill,
	BsFillFileEarmarkBarGraphFill,
	BsFillFileEarmarkBinaryFill,
	BsFillFileEarmarkBreakFill,
	BsFillFileEarmarkCheckFill,
	BsFillFileEarmarkCodeFill,
	BsFillFileEarmarkDiffFill,
	BsFillFileEarmarkEaselFill,
	BsFillFileEarmarkExcelFill,
	BsFillFileEarmarkFill,
	BsFillFileEarmarkFontFill,
	BsFillFileEarmarkImageFill,
	BsFillFileEarmarkLockFill,
	BsFillFileEarmarkLock2Fill,
	BsFillFileEarmarkMedicalFill,
	BsFillFileEarmarkMinusFill,
	BsFillFileEarmarkMusicFill,
	BsFillFileEarmarkPdfFill,
	BsFillFileEarmarkPersonFill,
	BsFillFileEarmarkPlayFill,
	BsFillFileEarmarkPlusFill,
	BsFillFileEarmarkPostFill,
	BsFillFileEarmarkPptFill,
	BsFillFileEarmarkRichtextFill,
	BsFillFileEarmarkRuledFill,
	BsFillFileEarmarkSlidesFill,
	BsFillFileEarmarkSpreadsheetFill,
	BsFillFileEarmarkTextFill,
	BsFillFileEarmarkWordFill,
	BsFillFileEarmarkXFill,
	BsFillFileEarmarkZipFill,
	BsFillFileEaselFill,
	BsFillFileExcelFill,
	BsFillFileFill,
	BsFillFileFontFill,
	BsFillFileImageFill,
	BsFillFileLockFill,
	BsFillFileLock2Fill,
	BsFillFileMedicalFill,
	BsFillFileMinusFill,
	BsFillFileMusicFill,
	BsFillFilePdfFill,
	BsFillFilePersonFill,
	BsFillFilePlayFill,
	BsFillFilePlusFill,
	BsFillFilePostFill,
	BsFillFilePptFill,
	BsFillFileRichtextFill,
	BsFillFileRuledFill,
	BsFillFileSlidesFill,
	BsFillFileSpreadsheetFill,
	BsFillFileTextFill,
	BsFillFileWordFill,
	BsFillFileXFill,
	BsFillFileZipFill,
	BsFillFilterCircleFill,
	BsFillFilterSquareFill,
	BsFillFlagFill,
	BsFillFolderFill,
	BsFillFolderSymlinkFill,
	BsFillForwardFill,
	BsFillFunnelFill,
	BsFillGearFill,
	BsFillGeoAltFill,
	BsFillGeoFill,
	BsFillGiftFill,
	BsFillGrid1X2Fill,
	BsFillGrid3X2GapFill,
	BsFillGrid3X3GapFill,
	BsFillGridFill,
	BsFillHandIndexFill,
	BsFillHandIndexThumbFill,
	BsFillHandThumbsDownFill,
	BsFillHandThumbsUpFill,
	BsFillHandbagFill,
	BsFillHddFill,
	BsFillHddNetworkFill,
	BsFillHddRackFill,
	BsFillHddStackFill,
	BsFillHeartFill,
	BsFillHeptagonFill,
	BsFillHexagonFill,
	BsFillHouseDoorFill,
	BsFillHouseFill,
	BsFillImageFill,
	BsFillInboxFill,
	BsFillInboxesFill,
	BsFillInfoCircleFill,
	BsFillInfoSquareFill,
	BsFillJournalBookmarkFill,
	BsFillKanbanFill,
	BsFillKeyFill,
	BsFillKeyboardFill,
	BsFillLampFill,
	BsFillLaptopFill,
	BsFillLayersFill,
	BsFillLightbulbFill,
	BsFillLightbulbOffFill,
	BsFillLightningChargeFill,
	BsFillLightningFill,
	BsFillLockFill,
	BsFillMapFill,
	BsFillMarkdownFill,
	BsFillMegaphoneFill,
	BsFillMenuAppFill,
	BsFillMenuButtonFill,
	BsFillMenuButtonWideFill,
	BsFillMicFill,
	BsFillMicMuteFill,
	BsFillMoonFill,
	BsFillMoonStarsFill,
	BsFillMouseFill,
	BsFillMouse2Fill,
	BsFillMouse3Fill,
	BsFillMusicPlayerFill,
	BsFillNodeMinusFill,
	BsFillNodePlusFill,
	BsFillNutFill,
	BsFillOctagonFill,
	BsFillPaletteFill,
	BsFillPatchCheckFill,
	BsFillPatchExclamationFill,
	BsFillPatchMinusFill,
	BsFillPatchPlusFill,
	BsFillPatchQuestionFill,
	BsFillPauseBtnFill,
	BsFillPauseCircleFill,
	BsFillPauseFill,
	BsFillPeaceFill,
	BsFillPenFill,
	BsFillPencilFill,
	BsFillPentagonFill,
	BsFillPeopleFill,
	BsFillPersonBadgeFill,
	BsFillPersonCheckFill,
	BsFillPersonDashFill,
	BsFillPersonFill,
	BsFillPersonLinesFill,
	BsFillPersonPlusFill,
	BsFillPersonXFill,
	BsFillPhoneFill,
	BsFillPhoneLandscapeFill,
	BsFillPhoneVibrateFill,
	BsFillPieChartFill,
	BsFillPiggyBankFill,
	BsFillPinAngleFill,
	BsFillPinFill,
	BsFillPinMapFill,
	BsFillPipFill,
	BsFillPlayBtnFill,
	BsFillPlayCircleFill,
	BsFillPlayFill,
	BsFillPlugFill,
	BsFillPlusCircleFill,
	BsFillPlusSquareFill,
	BsFillPrinterFill,
	BsFillPuzzleFill,
	BsFillQuestionCircleFill,
	BsFillQuestionDiamondFill,
	BsFillQuestionOctagonFill,
	BsFillQuestionSquareFill,
	BsFillRecordBtnFill,
	BsFillRecordCircleFill,
	BsFillRecordFill,
	BsFillRecord2Fill,
	BsFillReplyAllFill,
	BsFillReplyFill,
	BsFillRssFill,
	BsFillSafeFill,
	BsFillSafe2Fill,
	BsFillSaveFill,
	BsFillSave2Fill,
	BsFillSdCardFill,
	BsFillShareFill,
	BsFillShieldFill,
	BsFillShieldLockFill,
	BsFillShieldSlashFill,
	BsFillShiftFill,
	BsFillSignpost2Fill,
	BsFillSignpostFill,
	BsFillSignpostSplitFill,
	BsFillSimFill,
	BsFillSkipBackwardBtnFill,
	BsFillSkipBackwardCircleFill,
	BsFillSkipBackwardFill,
	BsFillSkipEndBtnFill,
	BsFillSkipEndCircleFill,
	BsFillSkipEndFill,
	BsFillSkipForwardBtnFill,
	BsFillSkipForwardCircleFill,
	BsFillSkipForwardFill,
	BsFillSkipStartBtnFill,
	BsFillSkipStartCircleFill,
	BsFillSkipStartFill,
	BsFillSlashCircleFill,
	BsFillSlashSquareFill,
	BsFillSpeakerFill,
	BsFillSquareFill,
	BsFillStarFill,
	BsFillStickiesFill,
	BsFillStickyFill,
	BsFillStopBtnFill,
	BsFillStopCircleFill,
	BsFillStopFill,
	BsFillStoplightsFill,
	BsFillStopwatchFill,
	BsFillSuitClubFill,
	BsFillSuitDiamondFill,
	BsFillSuitHeartFill,
	BsFillSuitSpadeFill,
	BsFillSunFill,
	BsFillSunriseFill,
	BsFillSunsetFill,
	BsFillTabletFill,
	BsFillTabletLandscapeFill,
	BsFillTagFill,
	BsFillTagsFill,
	BsFillTelephoneFill,
	BsFillTelephoneForwardFill,
	BsFillTelephoneInboundFill,
	BsFillTelephoneMinusFill,
	BsFillTelephoneOutboundFill,
	BsFillTelephonePlusFill,
	BsFillTelephoneXFill,
	BsFillTerminalFill,
	BsFillTrashFill,
	BsFillTrash2Fill,
	BsFillTreeFill,
	BsFillTriangleFill,
	BsFillTrophyFill,
	BsFillTvFill,
	BsFillUmbrellaFill,
	BsFillUnlockFill,
	BsFillVinylFill,
	BsFillVolumeDownFill,
	BsFillVolumeMuteFill,
	BsFillVolumeOffFill,
	BsFillVolumeUpFill,
	BsFillWalletFill,
	BsFillXCircleFill,
	BsFillXDiamondFill,
	BsFillXOctagonFill,
	BsFillXSquareFill,
	BsReverseBackspaceReverse,
	BsReverseLayoutSidebarInsetReverse,
	BsReverseLayoutSidebarReverse,
	BsReverseLayoutTextSidebarReverse,
	BsReverseLayoutTextWindowReverse,
	BsAlarmFill,
	BsAlarm,
	BsAlignBottom,
	BsAlignCenter,
	BsAlignEnd,
	BsAlignMiddle,
	BsAlignStart,
	BsAlignTop,
	BsAlt,
	BsAppIndicator,
	BsApp,
	BsApple,
	BsArchiveFill,
	BsArchive,
	BsArrow90DegDown,
	BsArrow90DegLeft,
	BsArrow90DegRight,
	BsArrow90DegUp,
	BsArrowBarDown,
	BsArrowBarLeft,
	BsArrowBarRight,
	BsArrowBarUp,
	BsArrowClockwise,
	BsArrowCounterclockwise,
	BsArrowDownCircleFill,
	BsArrowDownCircle,
	BsArrowDownLeftCircleFill,
	BsArrowDownLeftCircle,
	BsArrowDownLeftSquareFill,
	BsArrowDownLeftSquare,
	BsArrowDownLeft,
	BsArrowDownRightCircleFill,
	BsArrowDownRightCircle,
	BsArrowDownRightSquareFill,
	BsArrowDownRightSquare,
	BsArrowDownRight,
	BsArrowDownShort,
	BsArrowDownSquareFill,
	BsArrowDownSquare,
	BsArrowDownUp,
	BsArrowDown,
	BsArrowLeftCircleFill,
	BsArrowLeftCircle,
	BsArrowLeftRight,
	BsArrowLeftShort,
	BsArrowLeftSquareFill,
	BsArrowLeftSquare,
	BsArrowLeft,
	BsArrowRepeat,
	BsArrowReturnLeft,
	BsArrowReturnRight,
	BsArrowRightCircleFill,
	BsArrowRightCircle,
	BsArrowRightShort,
	BsArrowRightSquareFill,
	BsArrowRightSquare,
	BsArrowRight,
	BsArrowUpCircleFill,
	BsArrowUpCircle,
	BsArrowUpLeftCircleFill,
	BsArrowUpLeftCircle,
	BsArrowUpLeftSquareFill,
	BsArrowUpLeftSquare,
	BsArrowUpLeft,
	BsArrowUpRightCircleFill,
	BsArrowUpRightCircle,
	BsArrowUpRightSquareFill,
	BsArrowUpRightSquare,
	BsArrowUpRight,
	BsArrowUpShort,
	BsArrowUpSquareFill,
	BsArrowUpSquare,
	BsArrowUp,
	BsArrowsAngleContract,
	BsArrowsAngleExpand,
	BsArrowsCollapse,
	BsArrowsExpand,
	BsArrowsFullscreen,
	BsArrowsMove,
	BsAspectRatioFill,
	BsAspectRatio,
	BsAsterisk,
	BsAt,
	BsAwardFill,
	BsAward,
	BsBack,
	BsBackspaceFill,
	BsBackspaceReverseFill,
	BsBackspaceReverse,
	BsBackspace,
	BsBadge3DFill,
	BsBadge3D,
	BsBadge4KFill,
	BsBadge4K,
	BsBadge8KFill,
	BsBadge8K,
	BsBadgeAdFill,
	BsBadgeAd,
	BsBadgeArFill,
	BsBadgeAr,
	BsBadgeCcFill,
	BsBadgeCc,
	BsBadgeHdFill,
	BsBadgeHd,
	BsBadgeTmFill,
	BsBadgeTm,
	BsBadgeVoFill,
	BsBadgeVo,
	BsBadgeVrFill,
	BsBadgeVr,
	BsBadgeWcFill,
	BsBadgeWc,
	BsBagCheckFill,
	BsBagCheck,
	BsBagDashFill,
	BsBagDash,
	BsBagFill,
	BsBagPlusFill,
	BsBagPlus,
	BsBagXFill,
	BsBagX,
	BsBag,
	BsBank,
	BsBank2,
	BsBarChartFill,
	BsBarChartLineFill,
	BsBarChartLine,
	BsBarChartSteps,
	BsBarChart,
	BsBasketFill,
	BsBasket,
	BsBasket2Fill,
	BsBasket2,
	BsBasket3Fill,
	BsBasket3,
	BsBatteryCharging,
	BsBatteryFull,
	BsBatteryHalf,
	BsBattery,
	BsBehance,
	BsBellFill,
	BsBellSlashFill,
	BsBellSlash,
	BsBell,
	BsBezier,
	BsBezier2,
	BsBicycle,
	BsBinocularsFill,
	BsBinoculars,
	BsBlockquoteLeft,
	BsBlockquoteRight,
	BsBookFill,
	BsBookHalf,
	BsBook,
	BsBookmarkCheckFill,
	BsBookmarkCheck,
	BsBookmarkDashFill,
	BsBookmarkDash,
	BsBookmarkFill,
	BsBookmarkHeartFill,
	BsBookmarkHeart,
	BsBookmarkPlusFill,
	BsBookmarkPlus,
	BsBookmarkStarFill,
	BsBookmarkStar,
	BsBookmarkXFill,
	BsBookmarkX,
	BsBookmark,
	BsBookmarksFill,
	BsBookmarks,
	BsBookshelf,
	BsBootstrapFill,
	BsBootstrapReboot,
	BsBootstrap,
	BsBorderAll,
	BsBorderBottom,
	BsBorderCenter,
	BsBorderInner,
	BsBorderLeft,
	BsBorderMiddle,
	BsBorderOuter,
	BsBorderRight,
	BsBorderStyle,
	BsBorderTop,
	BsBorderWidth,
	BsBorder,
	BsBoundingBoxCircles,
	BsBoundingBox,
	BsBoxArrowDownLeft,
	BsBoxArrowDownRight,
	BsBoxArrowDown,
	BsBoxArrowInDownLeft,
	BsBoxArrowInDownRight,
	BsBoxArrowInDown,
	BsBoxArrowInLeft,
	BsBoxArrowInRight,
	BsBoxArrowInUpLeft,
	BsBoxArrowInUpRight,
	BsBoxArrowInUp,
	BsBoxArrowLeft,
	BsBoxArrowRight,
	BsBoxArrowUpLeft,
	BsBoxArrowUpRight,
	BsBoxArrowUp,
	BsBoxSeam,
	BsBox,
	BsBraces,
	BsBricks,
	BsBriefcaseFill,
	BsBriefcase,
	BsBrightnessAltHighFill,
	BsBrightnessAltHigh,
	BsBrightnessAltLowFill,
	BsBrightnessAltLow,
	BsBrightnessHighFill,
	BsBrightnessHigh,
	BsBrightnessLowFill,
	BsBrightnessLow,
	BsBroadcastPin,
	BsBroadcast,
	BsBrushFill,
	BsBrush,
	BsBucketFill,
	BsBucket,
	BsBugFill,
	BsBug,
	BsBuilding,
	BsBullseye,
	BsCalculatorFill,
	BsCalculator,
	BsCalendarCheckFill,
	BsCalendarCheck,
	BsCalendarDateFill,
	BsCalendarDate,
	BsCalendarDayFill,
	BsCalendarDay,
	BsCalendarEventFill,
	BsCalendarEvent,
	BsCalendarFill,
	BsCalendarMinusFill,
	BsCalendarMinus,
	BsCalendarMonthFill,
	BsCalendarMonth,
	BsCalendarPlusFill,
	BsCalendarPlus,
	BsCalendarRangeFill,
	BsCalendarRange,
	BsCalendarWeekFill,
	BsCalendarWeek,
	BsCalendarXFill,
	BsCalendarX,
	BsCalendar,
	BsCalendar2CheckFill,
	BsCalendar2Check,
	BsCalendar2DateFill,
	BsCalendar2Date,
	BsCalendar2DayFill,
	BsCalendar2Day,
	BsCalendar2EventFill,
	BsCalendar2Event,
	BsCalendar2Fill,
	BsCalendar2MinusFill,
	BsCalendar2Minus,
	BsCalendar2MonthFill,
	BsCalendar2Month,
	BsCalendar2PlusFill,
	BsCalendar2Plus,
	BsCalendar2RangeFill,
	BsCalendar2Range,
	BsCalendar2WeekFill,
	BsCalendar2Week,
	BsCalendar2XFill,
	BsCalendar2X,
	BsCalendar2,
	BsCalendar3EventFill,
	BsCalendar3Event,
	BsCalendar3Fill,
	BsCalendar3RangeFill,
	BsCalendar3Range,
	BsCalendar3WeekFill,
	BsCalendar3Week,
	BsCalendar3,
	BsCalendar4Event,
	BsCalendar4Range,
	BsCalendar4Week,
	BsCalendar4,
	BsCameraFill,
	BsCameraReelsFill,
	BsCameraReels,
	BsCameraVideoFill,
	BsCameraVideoOffFill,
	BsCameraVideoOff,
	BsCameraVideo,
	BsCamera,
	BsCamera2,
	BsCapslockFill,
	BsCapslock,
	BsCardChecklist,
	BsCardHeading,
	BsCardImage,
	BsCardList,
	BsCardText,
	BsCaretDownFill,
	BsCaretDownSquareFill,
	BsCaretDownSquare,
	BsCaretDown,
	BsCaretLeftFill,
	BsCaretLeftSquareFill,
	BsCaretLeftSquare,
	BsCaretLeft,
	BsCaretRightFill,
	BsCaretRightSquareFill,
	BsCaretRightSquare,
	BsCaretRight,
	BsCaretUpFill,
	BsCaretUpSquareFill,
	BsCaretUpSquare,
	BsCaretUp,
	BsCartCheckFill,
	BsCartCheck,
	BsCartDashFill,
	BsCartDash,
	BsCartFill,
	BsCartPlusFill,
	BsCartPlus,
	BsCartXFill,
	BsCartX,
	BsCart,
	BsCart2,
	BsCart3,
	BsCart4,
	BsCashCoin,
	BsCashStack,
	BsCash,
	BsCast,
	BsChatDotsFill,
	BsChatDots,
	BsChatFill,
	BsChatLeftDotsFill,
	BsChatLeftDots,
	BsChatLeftFill,
	BsChatLeftQuoteFill,
	BsChatLeftQuote,
	BsChatLeftTextFill,
	BsChatLeftText,
	BsChatLeft,
	BsChatQuoteFill,
	BsChatQuote,
	BsChatRightDotsFill,
	BsChatRightDots,
	BsChatRightFill,
	BsChatRightQuoteFill,
	BsChatRightQuote,
	BsChatRightTextFill,
	BsChatRightText,
	BsChatRight,
	BsChatSquareDotsFill,
	BsChatSquareDots,
	BsChatSquareFill,
	BsChatSquareQuoteFill,
	BsChatSquareQuote,
	BsChatSquareTextFill,
	BsChatSquareText,
	BsChatSquare,
	BsChatTextFill,
	BsChatText,
	BsChat,
	BsCheckAll,
	BsCheckCircleFill,
	BsCheckCircle,
	BsCheckLg,
	BsCheckSquareFill,
	BsCheckSquare,
	BsCheck,
	BsCheck2All,
	BsCheck2Circle,
	BsCheck2Square,
	BsCheck2,
	BsChevronBarContract,
	BsChevronBarDown,
	BsChevronBarExpand,
	BsChevronBarLeft,
	BsChevronBarRight,
	BsChevronBarUp,
	BsChevronCompactDown,
	BsChevronCompactLeft,
	BsChevronCompactRight,
	BsChevronCompactUp,
	BsChevronContract,
	BsChevronDoubleDown,
	BsChevronDoubleLeft,
	BsChevronDoubleRight,
	BsChevronDoubleUp,
	BsChevronDown,
	BsChevronExpand,
	BsChevronLeft,
	BsChevronRight,
	BsChevronUp,
	BsCircleFill,
	BsCircleHalf,
	BsCircleSquare,
	BsCircle,
	BsClipboardCheck,
	BsClipboardData,
	BsClipboardMinus,
	BsClipboardPlus,
	BsClipboardX,
	BsClipboard,
	BsClockFill,
	BsClockHistory,
	BsClock,
	BsCloudArrowDownFill,
	BsCloudArrowDown,
	BsCloudArrowUpFill,
	BsCloudArrowUp,
	BsCloudCheckFill,
	BsCloudCheck,
	BsCloudDownloadFill,
	BsCloudDownload,
	BsCloudDrizzleFill,
	BsCloudDrizzle,
	BsCloudFill,
	BsCloudFogFill,
	BsCloudFog,
	BsCloudFog2Fill,
	BsCloudFog2,
	BsCloudHailFill,
	BsCloudHail,
	BsCloudHaze1,
	BsCloudHazeFill,
	BsCloudHaze,
	BsCloudHaze2Fill,
	BsCloudLightningFill,
	BsCloudLightningRainFill,
	BsCloudLightningRain,
	BsCloudLightning,
	BsCloudMinusFill,
	BsCloudMinus,
	BsCloudMoonFill,
	BsCloudMoon,
	BsCloudPlusFill,
	BsCloudPlus,
	BsCloudRainFill,
	BsCloudRainHeavyFill,
	BsCloudRainHeavy,
	BsCloudRain,
	BsCloudSlashFill,
	BsCloudSlash,
	BsCloudSleetFill,
	BsCloudSleet,
	BsCloudSnowFill,
	BsCloudSnow,
	BsCloudSunFill,
	BsCloudSun,
	BsCloudUploadFill,
	BsCloudUpload,
	BsCloud,
	BsCloudsFill,
	BsClouds,
	BsCloudyFill,
	BsCloudy,
	BsCodeSlash,
	BsCodeSquare,
	BsCode,
	BsCoin,
	BsCollectionFill,
	BsCollectionPlayFill,
	BsCollectionPlay,
	BsCollection,
	BsColumnsGap,
	BsColumns,
	BsCommand,
	BsCompassFill,
	BsCompass,
	BsConeStriped,
	BsCone,
	BsController,
	BsCpuFill,
	BsCpu,
	BsCreditCard2BackFill,
	BsCreditCard2Back,
	BsCreditCard2FrontFill,
	BsCreditCard2Front,
	BsCreditCardFill,
	BsCreditCard,
	BsCrop,
	BsCupFill,
	BsCupStraw,
	BsCup,
	BsCurrencyBitcoin,
	BsCurrencyDollar,
	BsCurrencyEuro,
	BsCurrencyExchange,
	BsCurrencyPound,
	BsCurrencyYen,
	BsCursorFill,
	BsCursorText,
	BsCursor,
	BsDashCircleDotted,
	BsDashCircleFill,
	BsDashCircle,
	BsDashLg,
	BsDashSquareDotted,
	BsDashSquareFill,
	BsDashSquare,
	BsDash,
	BsDiagram2Fill,
	BsDiagram2,
	BsDiagram3Fill,
	BsDiagram3,
	BsDiamondFill,
	BsDiamondHalf,
	BsDiamond,
	BsDice1Fill,
	BsDice1,
	BsDice2Fill,
	BsDice2,
	BsDice3Fill,
	BsDice3,
	BsDice4Fill,
	BsDice4,
	BsDice5Fill,
	BsDice5,
	BsDice6Fill,
	BsDice6,
	BsDiscFill,
	BsDisc,
	BsDiscord,
	BsDisplayFill,
	BsDisplay,
	BsDistributeHorizontal,
	BsDistributeVertical,
	BsDoorClosedFill,
	BsDoorClosed,
	BsDoorOpenFill,
	BsDoorOpen,
	BsDot,
	BsDownload,
	BsDribbble,
	BsDropletFill,
	BsDropletHalf,
	BsDroplet,
	BsEarbuds,
	BsEaselFill,
	BsEasel,
	BsEggFill,
	BsEggFried,
	BsEgg,
	BsEjectFill,
	BsEject,
	BsEmojiAngryFill,
	BsEmojiAngry,
	BsEmojiDizzyFill,
	BsEmojiDizzy,
	BsEmojiExpressionlessFill,
	BsEmojiExpressionless,
	BsEmojiFrownFill,
	BsEmojiFrown,
	BsEmojiHeartEyesFill,
	BsEmojiHeartEyes,
	BsEmojiLaughingFill,
	BsEmojiLaughing,
	BsEmojiNeutralFill,
	BsEmojiNeutral,
	BsEmojiSmileFill,
	BsEmojiSmileUpsideDownFill,
	BsEmojiSmileUpsideDown,
	BsEmojiSmile,
	BsEmojiSunglassesFill,
	BsEmojiSunglasses,
	BsEmojiWinkFill,
	BsEmojiWink,
	BsEnvelopeFill,
	BsEnvelopeOpenFill,
	BsEnvelopeOpen,
	BsEnvelope,
	BsEraserFill,
	BsEraser,
	BsExclamationCircleFill,
	BsExclamationCircle,
	BsExclamationDiamondFill,
	BsExclamationDiamond,
	BsExclamationLg,
	BsExclamationOctagonFill,
	BsExclamationOctagon,
	BsExclamationSquareFill,
	BsExclamationSquare,
	BsExclamationTriangleFill,
	BsExclamationTriangle,
	BsExclamation,
	BsExclude,
	BsEyeFill,
	BsEyeSlashFill,
	BsEyeSlash,
	BsEye,
	BsEyedropper,
	BsEyeglasses,
	BsFacebook,
	BsFileArrowDownFill,
	BsFileArrowDown,
	BsFileArrowUpFill,
	BsFileArrowUp,
	BsFileBarGraphFill,
	BsFileBarGraph,
	BsFileBinaryFill,
	BsFileBinary,
	BsFileBreakFill,
	BsFileBreak,
	BsFileCheckFill,
	BsFileCheck,
	BsFileCodeFill,
	BsFileCode,
	BsFileDiffFill,
	BsFileDiff,
	BsFileEarmarkArrowDownFill,
	BsFileEarmarkArrowDown,
	BsFileEarmarkArrowUpFill,
	BsFileEarmarkArrowUp,
	BsFileEarmarkBarGraphFill,
	BsFileEarmarkBarGraph,
	BsFileEarmarkBinaryFill,
	BsFileEarmarkBinary,
	BsFileEarmarkBreakFill,
	BsFileEarmarkBreak,
	BsFileEarmarkCheckFill,
	BsFileEarmarkCheck,
	BsFileEarmarkCodeFill,
	BsFileEarmarkCode,
	BsFileEarmarkDiffFill,
	BsFileEarmarkDiff,
	BsFileEarmarkEaselFill,
	BsFileEarmarkEasel,
	BsFileEarmarkExcelFill,
	BsFileEarmarkExcel,
	BsFileEarmarkFill,
	BsFileEarmarkFontFill,
	BsFileEarmarkFont,
	BsFileEarmarkImageFill,
	BsFileEarmarkImage,
	BsFileEarmarkLockFill,
	BsFileEarmarkLock,
	BsFileEarmarkLock2Fill,
	BsFileEarmarkLock2,
	BsFileEarmarkMedicalFill,
	BsFileEarmarkMedical,
	BsFileEarmarkMinusFill,
	BsFileEarmarkMinus,
	BsFileEarmarkMusicFill,
	BsFileEarmarkMusic,
	BsFileEarmarkPdfFill,
	BsFileEarmarkPdf,
	BsFileEarmarkPersonFill,
	BsFileEarmarkPerson,
	BsFileEarmarkPlayFill,
	BsFileEarmarkPlay,
	BsFileEarmarkPlusFill,
	BsFileEarmarkPlus,
	BsFileEarmarkPostFill,
	BsFileEarmarkPost,
	BsFileEarmarkPptFill,
	BsFileEarmarkPpt,
	BsFileEarmarkRichtextFill,
	BsFileEarmarkRichtext,
	BsFileEarmarkRuledFill,
	BsFileEarmarkRuled,
	BsFileEarmarkSlidesFill,
	BsFileEarmarkSlides,
	BsFileEarmarkSpreadsheetFill,
	BsFileEarmarkSpreadsheet,
	BsFileEarmarkTextFill,
	BsFileEarmarkText,
	BsFileEarmarkWordFill,
	BsFileEarmarkWord,
	BsFileEarmarkXFill,
	BsFileEarmarkX,
	BsFileEarmarkZipFill,
	BsFileEarmarkZip,
	BsFileEarmark,
	BsFileEaselFill,
	BsFileEasel,
	BsFileExcelFill,
	BsFileExcel,
	BsFileFill,
	BsFileFontFill,
	BsFileFont,
	BsFileImageFill,
	BsFileImage,
	BsFileLockFill,
	BsFileLock,
	BsFileLock2Fill,
	BsFileLock2,
	BsFileMedicalFill,
	BsFileMedical,
	BsFileMinusFill,
	BsFileMinus,
	BsFileMusicFill,
	BsFileMusic,
	BsFilePdfFill,
	BsFilePdf,
	BsFilePersonFill,
	BsFilePerson,
	BsFilePlayFill,
	BsFilePlay,
	BsFilePlusFill,
	BsFilePlus,
	BsFilePostFill,
	BsFilePost,
	BsFilePptFill,
	BsFilePpt,
	BsFileRichtextFill,
	BsFileRichtext,
	BsFileRuledFill,
	BsFileRuled,
	BsFileSlidesFill,
	BsFileSlides,
	BsFileSpreadsheetFill,
	BsFileSpreadsheet,
	BsFileTextFill,
	BsFileText,
	BsFileWordFill,
	BsFileWord,
	BsFileXFill,
	BsFileX,
	BsFileZipFill,
	BsFileZip,
	BsFile,
	BsFilesAlt,
	BsFiles,
	BsFilm,
	BsFilterCircleFill,
	BsFilterCircle,
	BsFilterLeft,
	BsFilterRight,
	BsFilterSquareFill,
	BsFilterSquare,
	BsFilter,
	BsFlagFill,
	BsFlag,
	BsFlower1,
	BsFlower2,
	BsFlower3,
	BsFolderCheck,
	BsFolderFill,
	BsFolderMinus,
	BsFolderPlus,
	BsFolderSymlinkFill,
	BsFolderSymlink,
	BsFolderX,
	BsFolder,
	BsFolder2Open,
	BsFolder2,
	BsFonts,
	BsForwardFill,
	BsForward,
	BsFront,
	BsFullscreenExit,
	BsFullscreen,
	BsFunnelFill,
	BsFunnel,
	BsGearFill,
	BsGearWideConnected,
	BsGearWide,
	BsGear,
	BsGem,
	BsGenderAmbiguous,
	BsGenderFemale,
	BsGenderMale,
	BsGenderTrans,
	BsGeoAltFill,
	BsGeoAlt,
	BsGeoFill,
	BsGeo,
	BsGiftFill,
	BsGift,
	BsGithub,
	BsGlobe,
	BsGlobe2,
	BsGoogle,
	BsGraphDown,
	BsGraphUp,
	BsGrid1X2Fill,
	BsGrid1X2,
	BsGrid3X2GapFill,
	BsGrid3X2Gap,
	BsGrid3X2,
	BsGrid3X3GapFill,
	BsGrid3X3Gap,
	BsGrid3X3,
	BsGridFill,
	BsGrid,
	BsGripHorizontal,
	BsGripVertical,
	BsHammer,
	BsHandIndexFill,
	BsHandIndexThumbFill,
	BsHandIndexThumb,
	BsHandIndex,
	BsHandThumbsDownFill,
	BsHandThumbsDown,
	BsHandThumbsUpFill,
	BsHandThumbsUp,
	BsHandbagFill,
	BsHandbag,
	BsHash,
	BsHddFill,
	BsHddNetworkFill,
	BsHddNetwork,
	BsHddRackFill,
	BsHddRack,
	BsHddStackFill,
	BsHddStack,
	BsHdd,
	BsHeadphones,
	BsHeadsetVr,
	BsHeadset,
	BsHeartFill,
	BsHeartHalf,
	BsHeart,
	BsHeptagonFill,
	BsHeptagonHalf,
	BsHeptagon,
	BsHexagonFill,
	BsHexagonHalf,
	BsHexagon,
	BsHourglassBottom,
	BsHourglassSplit,
	BsHourglassTop,
	BsHourglass,
	BsHouseDoorFill,
	BsHouseDoor,
	BsHouseFill,
	BsHouse,
	BsHr,
	BsHurricane,
	BsImageAlt,
	BsImageFill,
	BsImage,
	BsImages,
	BsInboxFill,
	BsInbox,
	BsInboxesFill,
	BsInboxes,
	BsInfoCircleFill,
	BsInfoCircle,
	BsInfoLg,
	BsInfoSquareFill,
	BsInfoSquare,
	BsInfo,
	BsInputCursorText,
	BsInputCursor,
	BsInstagram,
	BsIntersect,
	BsJournalAlbum,
	BsJournalArrowDown,
	BsJournalArrowUp,
	BsJournalBookmarkFill,
	BsJournalBookmark,
	BsJournalCheck,
	BsJournalCode,
	BsJournalMedical,
	BsJournalMinus,
	BsJournalPlus,
	BsJournalRichtext,
	BsJournalText,
	BsJournalX,
	BsJournal,
	BsJournals,
	BsJoystick,
	BsJustifyLeft,
	BsJustifyRight,
	BsJustify,
	BsKanbanFill,
	BsKanban,
	BsKeyFill,
	BsKey,
	BsKeyboardFill,
	BsKeyboard,
	BsLadder,
	BsLampFill,
	BsLamp,
	BsLaptopFill,
	BsLaptop,
	BsLayerBackward,
	BsLayerForward,
	BsLayersFill,
	BsLayersHalf,
	BsLayers,
	BsLayoutSidebarInsetReverse,
	BsLayoutSidebarInset,
	BsLayoutSidebarReverse,
	BsLayoutSidebar,
	BsLayoutSplit,
	BsLayoutTextSidebarReverse,
	BsLayoutTextSidebar,
	BsLayoutTextWindowReverse,
	BsLayoutTextWindow,
	BsLayoutThreeColumns,
	BsLayoutWtf,
	BsLifePreserver,
	BsLightbulbFill,
	BsLightbulbOffFill,
	BsLightbulbOff,
	BsLightbulb,
	BsLightningChargeFill,
	BsLightningCharge,
	BsLightningFill,
	BsLightning,
	BsLine,
	BsLink45Deg,
	BsLink,
	BsLinkedin,
	BsListCheck,
	BsListNested,
	BsListOl,
	BsListStars,
	BsListTask,
	BsListUl,
	BsList,
	BsLockFill,
	BsLock,
	BsMailbox,
	BsMailbox2,
	BsMapFill,
	BsMap,
	BsMarkdownFill,
	BsMarkdown,
	BsMask,
	BsMastodon,
	BsMedium,
	BsMegaphoneFill,
	BsMegaphone,
	BsMenuAppFill,
	BsMenuApp,
	BsMenuButtonFill,
	BsMenuButtonWideFill,
	BsMenuButtonWide,
	BsMenuButton,
	BsMenuDown,
	BsMenuUp,
	BsMessenger,
	BsMicFill,
	BsMicMuteFill,
	BsMicMute,
	BsMic,
	BsMicrosoft,
	BsMinecartLoaded,
	BsMinecart,
	BsMoisture,
	BsMoonFill,
	BsMoonStarsFill,
	BsMoonStars,
	BsMoon,
	BsMouseFill,
	BsMouse,
	BsMouse2Fill,
	BsMouse2,
	BsMouse3Fill,
	BsMouse3,
	BsMusicNoteBeamed,
	BsMusicNoteList,
	BsMusicNote,
	BsMusicPlayerFill,
	BsMusicPlayer,
	BsNewspaper,
	BsNodeMinusFill,
	BsNodeMinus,
	BsNodePlusFill,
	BsNodePlus,
	BsNutFill,
	BsNut,
	BsOctagonFill,
	BsOctagonHalf,
	BsOctagon,
	BsOption,
	BsOutlet,
	BsPaintBucket,
	BsPaletteFill,
	BsPalette,
	BsPalette2,
	BsPaperclip,
	BsParagraph,
	BsPatchCheckFill,
	BsPatchCheck,
	BsPatchExclamationFill,
	BsPatchExclamation,
	BsPatchMinusFill,
	BsPatchMinus,
	BsPatchPlusFill,
	BsPatchPlus,
	BsPatchQuestionFill,
	BsPatchQuestion,
	BsPauseBtnFill,
	BsPauseBtn,
	BsPauseCircleFill,
	BsPauseCircle,
	BsPauseFill,
	BsPause,
	BsPaypal,
	BsPeaceFill,
	BsPeace,
	BsPenFill,
	BsPen,
	BsPencilFill,
	BsPencilSquare,
	BsPencil,
	BsPentagonFill,
	BsPentagonHalf,
	BsPentagon,
	BsPeopleFill,
	BsPeople,
	BsPercent,
	BsPersonBadgeFill,
	BsPersonBadge,
	BsPersonBoundingBox,
	BsPersonCheckFill,
	BsPersonCheck,
	BsPersonCircle,
	BsPersonDashFill,
	BsPersonDash,
	BsPersonFill,
	BsPersonLinesFill,
	BsPersonPlusFill,
	BsPersonPlus,
	BsPersonSquare,
	BsPersonXFill,
	BsPersonX,
	BsPerson,
	BsPhoneFill,
	BsPhoneLandscapeFill,
	BsPhoneLandscape,
	BsPhoneVibrateFill,
	BsPhoneVibrate,
	BsPhone,
	BsPieChartFill,
	BsPieChart,
	BsPiggyBankFill,
	BsPiggyBank,
	BsPinAngleFill,
	BsPinAngle,
	BsPinFill,
	BsPinMapFill,
	BsPinMap,
	BsPin,
	BsPinterest,
	BsPipFill,
	BsPip,
	BsPlayBtnFill,
	BsPlayBtn,
	BsPlayCircleFill,
	BsPlayCircle,
	BsPlayFill,
	BsPlay,
	BsPlugFill,
	BsPlug,
	BsPlusCircleDotted,
	BsPlusCircleFill,
	BsPlusCircle,
	BsPlusLg,
	BsPlusSquareDotted,
	BsPlusSquareFill,
	BsPlusSquare,
	BsPlus,
	BsPower,
	BsPrinterFill,
	BsPrinter,
	BsPuzzleFill,
	BsPuzzle,
	BsQuestionCircleFill,
	BsQuestionCircle,
	BsQuestionDiamondFill,
	BsQuestionDiamond,
	BsQuestionLg,
	BsQuestionOctagonFill,
	BsQuestionOctagon,
	BsQuestionSquareFill,
	BsQuestionSquare,
	BsQuestion,
	BsRainbow,
	BsReceiptCutoff,
	BsReceipt,
	BsReception0,
	BsReception1,
	BsReception2,
	BsReception3,
	BsReception4,
	BsRecordBtnFill,
	BsRecordBtn,
	BsRecordCircleFill,
	BsRecordCircle,
	BsRecordFill,
	BsRecord,
	BsRecord2Fill,
	BsRecord2,
	BsRecycle,
	BsReddit,
	BsReplyAllFill,
	BsReplyAll,
	BsReplyFill,
	BsReply,
	BsRssFill,
	BsRss,
	BsRulers,
	BsSafeFill,
	BsSafe,
	BsSafe2Fill,
	BsSafe2,
	BsSaveFill,
	BsSave,
	BsSave2Fill,
	BsSave2,
	BsScissors,
	BsScrewdriver,
	BsSdCardFill,
	BsSdCard,
	BsSearch,
	BsSegmentedNav,
	BsServer,
	BsShareFill,
	BsShare,
	BsShieldCheck,
	BsShieldExclamation,
	BsShieldFillCheck,
	BsShieldFillExclamation,
	BsShieldFillMinus,
	BsShieldFillPlus,
	BsShieldFillX,
	BsShieldFill,
	BsShieldLockFill,
	BsShieldLock,
	BsShieldMinus,
	BsShieldPlus,
	BsShieldShaded,
	BsShieldSlashFill,
	BsShieldSlash,
	BsShieldX,
	BsShield,
	BsShiftFill,
	BsShift,
	BsShopWindow,
	BsShop,
	BsShuffle,
	BsSignal,
	BsSignpost2Fill,
	BsSignpost2,
	BsSignpostFill,
	BsSignpostSplitFill,
	BsSignpostSplit,
	BsSignpost,
	BsSimFill,
	BsSim,
	BsSkipBackwardBtnFill,
	BsSkipBackwardBtn,
	BsSkipBackwardCircleFill,
	BsSkipBackwardCircle,
	BsSkipBackwardFill,
	BsSkipBackward,
	BsSkipEndBtnFill,
	BsSkipEndBtn,
	BsSkipEndCircleFill,
	BsSkipEndCircle,
	BsSkipEndFill,
	BsSkipEnd,
	BsSkipForwardBtnFill,
	BsSkipForwardBtn,
	BsSkipForwardCircleFill,
	BsSkipForwardCircle,
	BsSkipForwardFill,
	BsSkipForward,
	BsSkipStartBtnFill,
	BsSkipStartBtn,
	BsSkipStartCircleFill,
	BsSkipStartCircle,
	BsSkipStartFill,
	BsSkipStart,
	BsSkype,
	BsSlack,
	BsSlashCircleFill,
	BsSlashCircle,
	BsSlashLg,
	BsSlashSquareFill,
	BsSlashSquare,
	BsSlash,
	BsSliders,
	BsSmartwatch,
	BsSnapchat,
	BsSnow,
	BsSnow2,
	BsSnow3,
	BsSortAlphaDownAlt,
	BsSortAlphaDown,
	BsSortAlphaUpAlt,
	BsSortAlphaUp,
	BsSortDownAlt,
	BsSortDown,
	BsSortNumericDownAlt,
	BsSortNumericDown,
	BsSortNumericUpAlt,
	BsSortNumericUp,
	BsSortUpAlt,
	BsSortUp,
	BsSoundwave,
	BsSpeakerFill,
	BsSpeaker,
	BsSpeedometer,
	BsSpeedometer2,
	BsSpellcheck,
	BsSpotify,
	BsSquareFill,
	BsSquareHalf,
	BsSquare,
	BsStackOverflow,
	BsStack,
	BsStarFill,
	BsStarHalf,
	BsStar,
	BsStars,
	BsStickiesFill,
	BsStickies,
	BsStickyFill,
	BsSticky,
	BsStopBtnFill,
	BsStopBtn,
	BsStopCircleFill,
	BsStopCircle,
	BsStopFill,
	BsStop,
	BsStoplightsFill,
	BsStoplights,
	BsStopwatchFill,
	BsStopwatch,
	BsStrava,
	BsSubtract,
	BsSuitClubFill,
	BsSuitClub,
	BsSuitDiamondFill,
	BsSuitDiamond,
	BsSuitHeartFill,
	BsSuitHeart,
	BsSuitSpadeFill,
	BsSuitSpade,
	BsSunFill,
	BsSun,
	BsSunglasses,
	BsSunriseFill,
	BsSunrise,
	BsSunsetFill,
	BsSunset,
	BsSymmetryHorizontal,
	BsSymmetryVertical,
	BsTable,
	BsTabletFill,
	BsTabletLandscapeFill,
	BsTabletLandscape,
	BsTablet,
	BsTagFill,
	BsTag,
	BsTagsFill,
	BsTags,
	BsTelegram,
	BsTelephoneFill,
	BsTelephoneForwardFill,
	BsTelephoneForward,
	BsTelephoneInboundFill,
	BsTelephoneInbound,
	BsTelephoneMinusFill,
	BsTelephoneMinus,
	BsTelephoneOutboundFill,
	BsTelephoneOutbound,
	BsTelephonePlusFill,
	BsTelephonePlus,
	BsTelephoneXFill,
	BsTelephoneX,
	BsTelephone,
	BsTerminalFill,
	BsTerminal,
	BsTextCenter,
	BsTextIndentLeft,
	BsTextIndentRight,
	BsTextLeft,
	BsTextParagraph,
	BsTextRight,
	BsTextareaResize,
	BsTextareaT,
	BsTextarea,
	BsThermometerHalf,
	BsThermometerHigh,
	BsThermometerLow,
	BsThermometerSnow,
	BsThermometerSun,
	BsThermometer,
	BsThreeDotsVertical,
	BsThreeDots,
	BsToggleOff,
	BsToggleOn,
	BsToggle2Off,
	BsToggle2On,
	BsToggles,
	BsToggles2,
	BsTools,
	BsTornado,
	BsTranslate,
	BsTrashFill,
	BsTrash,
	BsTrash2Fill,
	BsTrash2,
	BsTreeFill,
	BsTree,
	BsTriangleFill,
	BsTriangleHalf,
	BsTriangle,
	BsTrophyFill,
	BsTrophy,
	BsTropicalStorm,
	BsTruckFlatbed,
	BsTruck,
	BsTsunami,
	BsTvFill,
	BsTv,
	BsTwitch,
	BsTwitter,
	BsTypeBold,
	BsTypeH1,
	BsTypeH2,
	BsTypeH3,
	BsTypeItalic,
	BsTypeStrikethrough,
	BsTypeUnderline,
	BsType,
	BsUiChecksGrid,
	BsUiChecks,
	BsUiRadiosGrid,
	BsUiRadios,
	BsUmbrellaFill,
	BsUmbrella,
	BsUnion,
	BsUnlockFill,
	BsUnlock,
	BsUpcScan,
	BsUpc,
	BsUpload,
	BsVectorPen,
	BsViewList,
	BsViewStacked,
	BsVimeo,
	BsVinylFill,
	BsVinyl,
	BsVoicemail,
	BsVolumeDownFill,
	BsVolumeDown,
	BsVolumeMuteFill,
	BsVolumeMute,
	BsVolumeOffFill,
	BsVolumeOff,
	BsVolumeUpFill,
	BsVolumeUp,
	BsVr,
	BsWalletFill,
	BsWallet,
	BsWallet2,
	BsWatch,
	BsWater,
	BsWhatsapp,
	BsWifi1,
	BsWifi2,
	BsWifiOff,
	BsWifi,
	BsWind,
	BsWindowDock,
	BsWindowSidebar,
	BsWindow,
	BsWindows,
	BsWordpress,
	BsWrench,
	BsXCircleFill,
	BsXCircle,
	BsXDiamondFill,
	BsXDiamond,
	BsXLg,
	BsXOctagonFill,
	BsXOctagon,
	BsXSquareFill,
	BsXSquare,
	BsX,
	BsYoutube,
	BsZoomIn,
	BsZoomOut,
} from "react-icons/bs";

const result = [
	{ icon: BsFillAlarmFill, name: "BsFillAlarmFill", library: "bs" },
	{ icon: BsFillArchiveFill, name: "BsFillArchiveFill", library: "bs" },
	{ icon: BsFillArrowDownCircleFill, name: "BsFillArrowDownCircleFill", library: "bs" },
	{
		icon: BsFillArrowDownLeftCircleFill,
		name: "BsFillArrowDownLeftCircleFill",
		library: "bs",
	},
	{
		icon: BsFillArrowDownLeftSquareFill,
		name: "BsFillArrowDownLeftSquareFill",
		library: "bs",
	},
	{
		icon: BsFillArrowDownRightCircleFill,
		name: "BsFillArrowDownRightCircleFill",
		library: "bs",
	},
	{
		icon: BsFillArrowDownRightSquareFill,
		name: "BsFillArrowDownRightSquareFill",
		library: "bs",
	},
	{ icon: BsFillArrowDownSquareFill, name: "BsFillArrowDownSquareFill", library: "bs" },
	{ icon: BsFillArrowLeftCircleFill, name: "BsFillArrowLeftCircleFill", library: "bs" },
	{ icon: BsFillArrowLeftSquareFill, name: "BsFillArrowLeftSquareFill", library: "bs" },
	{
		icon: BsFillArrowRightCircleFill,
		name: "BsFillArrowRightCircleFill",
		library: "bs",
	},
	{
		icon: BsFillArrowRightSquareFill,
		name: "BsFillArrowRightSquareFill",
		library: "bs",
	},
	{ icon: BsFillArrowUpCircleFill, name: "BsFillArrowUpCircleFill", library: "bs" },
	{
		icon: BsFillArrowUpLeftCircleFill,
		name: "BsFillArrowUpLeftCircleFill",
		library: "bs",
	},
	{
		icon: BsFillArrowUpLeftSquareFill,
		name: "BsFillArrowUpLeftSquareFill",
		library: "bs",
	},
	{
		icon: BsFillArrowUpRightCircleFill,
		name: "BsFillArrowUpRightCircleFill",
		library: "bs",
	},
	{
		icon: BsFillArrowUpRightSquareFill,
		name: "BsFillArrowUpRightSquareFill",
		library: "bs",
	},
	{ icon: BsFillArrowUpSquareFill, name: "BsFillArrowUpSquareFill", library: "bs" },
	{ icon: BsFillAspectRatioFill, name: "BsFillAspectRatioFill", library: "bs" },
	{ icon: BsFillAwardFill, name: "BsFillAwardFill", library: "bs" },
	{ icon: BsFillBackspaceFill, name: "BsFillBackspaceFill", library: "bs" },
	{
		icon: BsFillBackspaceReverseFill,
		name: "BsFillBackspaceReverseFill",
		library: "bs",
	},
	{ icon: BsFillBadge3DFill, name: "BsFillBadge3DFill", library: "bs" },
	{ icon: BsFillBadge4KFill, name: "BsFillBadge4KFill", library: "bs" },
	{ icon: BsFillBadge8KFill, name: "BsFillBadge8KFill", library: "bs" },
	{ icon: BsFillBadgeAdFill, name: "BsFillBadgeAdFill", library: "bs" },
	{ icon: BsFillBadgeArFill, name: "BsFillBadgeArFill", library: "bs" },
	{ icon: BsFillBadgeCcFill, name: "BsFillBadgeCcFill", library: "bs" },
	{ icon: BsFillBadgeHdFill, name: "BsFillBadgeHdFill", library: "bs" },
	{ icon: BsFillBadgeTmFill, name: "BsFillBadgeTmFill", library: "bs" },
	{ icon: BsFillBadgeVoFill, name: "BsFillBadgeVoFill", library: "bs" },
	{ icon: BsFillBadgeVrFill, name: "BsFillBadgeVrFill", library: "bs" },
	{ icon: BsFillBadgeWcFill, name: "BsFillBadgeWcFill", library: "bs" },
	{ icon: BsFillBagCheckFill, name: "BsFillBagCheckFill", library: "bs" },
	{ icon: BsFillBagDashFill, name: "BsFillBagDashFill", library: "bs" },
	{ icon: BsFillBagFill, name: "BsFillBagFill", library: "bs" },
	{ icon: BsFillBagPlusFill, name: "BsFillBagPlusFill", library: "bs" },
	{ icon: BsFillBagXFill, name: "BsFillBagXFill", library: "bs" },
	{ icon: BsFillBarChartFill, name: "BsFillBarChartFill", library: "bs" },
	{ icon: BsFillBarChartLineFill, name: "BsFillBarChartLineFill", library: "bs" },
	{ icon: BsFillBasketFill, name: "BsFillBasketFill", library: "bs" },
	{ icon: BsFillBasket2Fill, name: "BsFillBasket2Fill", library: "bs" },
	{ icon: BsFillBasket3Fill, name: "BsFillBasket3Fill", library: "bs" },
	{ icon: BsFillBellFill, name: "BsFillBellFill", library: "bs" },
	{ icon: BsFillBellSlashFill, name: "BsFillBellSlashFill", library: "bs" },
	{ icon: BsFillBinocularsFill, name: "BsFillBinocularsFill", library: "bs" },
	{ icon: BsFillBookFill, name: "BsFillBookFill", library: "bs" },
	{ icon: BsFillBookmarkCheckFill, name: "BsFillBookmarkCheckFill", library: "bs" },
	{ icon: BsFillBookmarkDashFill, name: "BsFillBookmarkDashFill", library: "bs" },
	{ icon: BsFillBookmarkFill, name: "BsFillBookmarkFill", library: "bs" },
	{ icon: BsFillBookmarkHeartFill, name: "BsFillBookmarkHeartFill", library: "bs" },
	{ icon: BsFillBookmarkPlusFill, name: "BsFillBookmarkPlusFill", library: "bs" },
	{ icon: BsFillBookmarkStarFill, name: "BsFillBookmarkStarFill", library: "bs" },
	{ icon: BsFillBookmarkXFill, name: "BsFillBookmarkXFill", library: "bs" },
	{ icon: BsFillBookmarksFill, name: "BsFillBookmarksFill", library: "bs" },
	{ icon: BsFillBootstrapFill, name: "BsFillBootstrapFill", library: "bs" },
	{ icon: BsFillBriefcaseFill, name: "BsFillBriefcaseFill", library: "bs" },
	{
		icon: BsFillBrightnessAltHighFill,
		name: "BsFillBrightnessAltHighFill",
		library: "bs",
	},
	{
		icon: BsFillBrightnessAltLowFill,
		name: "BsFillBrightnessAltLowFill",
		library: "bs",
	},
	{ icon: BsFillBrightnessHighFill, name: "BsFillBrightnessHighFill", library: "bs" },
	{ icon: BsFillBrightnessLowFill, name: "BsFillBrightnessLowFill", library: "bs" },
	{ icon: BsFillBrushFill, name: "BsFillBrushFill", library: "bs" },
	{ icon: BsFillBucketFill, name: "BsFillBucketFill", library: "bs" },
	{ icon: BsFillBugFill, name: "BsFillBugFill", library: "bs" },
	{ icon: BsFillCalculatorFill, name: "BsFillCalculatorFill", library: "bs" },
	{ icon: BsFillCalendarCheckFill, name: "BsFillCalendarCheckFill", library: "bs" },
	{ icon: BsFillCalendarDateFill, name: "BsFillCalendarDateFill", library: "bs" },
	{ icon: BsFillCalendarDayFill, name: "BsFillCalendarDayFill", library: "bs" },
	{ icon: BsFillCalendarEventFill, name: "BsFillCalendarEventFill", library: "bs" },
	{ icon: BsFillCalendarFill, name: "BsFillCalendarFill", library: "bs" },
	{ icon: BsFillCalendarMinusFill, name: "BsFillCalendarMinusFill", library: "bs" },
	{ icon: BsFillCalendarMonthFill, name: "BsFillCalendarMonthFill", library: "bs" },
	{ icon: BsFillCalendarPlusFill, name: "BsFillCalendarPlusFill", library: "bs" },
	{ icon: BsFillCalendarRangeFill, name: "BsFillCalendarRangeFill", library: "bs" },
	{ icon: BsFillCalendarWeekFill, name: "BsFillCalendarWeekFill", library: "bs" },
	{ icon: BsFillCalendarXFill, name: "BsFillCalendarXFill", library: "bs" },
	{ icon: BsFillCalendar2CheckFill, name: "BsFillCalendar2CheckFill", library: "bs" },
	{ icon: BsFillCalendar2DateFill, name: "BsFillCalendar2DateFill", library: "bs" },
	{ icon: BsFillCalendar2DayFill, name: "BsFillCalendar2DayFill", library: "bs" },
	{ icon: BsFillCalendar2EventFill, name: "BsFillCalendar2EventFill", library: "bs" },
	{ icon: BsFillCalendar2Fill, name: "BsFillCalendar2Fill", library: "bs" },
	{ icon: BsFillCalendar2MinusFill, name: "BsFillCalendar2MinusFill", library: "bs" },
	{ icon: BsFillCalendar2MonthFill, name: "BsFillCalendar2MonthFill", library: "bs" },
	{ icon: BsFillCalendar2PlusFill, name: "BsFillCalendar2PlusFill", library: "bs" },
	{ icon: BsFillCalendar2RangeFill, name: "BsFillCalendar2RangeFill", library: "bs" },
	{ icon: BsFillCalendar2WeekFill, name: "BsFillCalendar2WeekFill", library: "bs" },
	{ icon: BsFillCalendar2XFill, name: "BsFillCalendar2XFill", library: "bs" },
	{ icon: BsFillCalendar3EventFill, name: "BsFillCalendar3EventFill", library: "bs" },
	{ icon: BsFillCalendar3Fill, name: "BsFillCalendar3Fill", library: "bs" },
	{ icon: BsFillCalendar3RangeFill, name: "BsFillCalendar3RangeFill", library: "bs" },
	{ icon: BsFillCalendar3WeekFill, name: "BsFillCalendar3WeekFill", library: "bs" },
	{ icon: BsFillCameraFill, name: "BsFillCameraFill", library: "bs" },
	{ icon: BsFillCameraReelsFill, name: "BsFillCameraReelsFill", library: "bs" },
	{ icon: BsFillCameraVideoFill, name: "BsFillCameraVideoFill", library: "bs" },
	{ icon: BsFillCameraVideoOffFill, name: "BsFillCameraVideoOffFill", library: "bs" },
	{ icon: BsFillCapslockFill, name: "BsFillCapslockFill", library: "bs" },
	{ icon: BsFillCaretDownFill, name: "BsFillCaretDownFill", library: "bs" },
	{ icon: BsFillCaretDownSquareFill, name: "BsFillCaretDownSquareFill", library: "bs" },
	{ icon: BsFillCaretLeftFill, name: "BsFillCaretLeftFill", library: "bs" },
	{ icon: BsFillCaretLeftSquareFill, name: "BsFillCaretLeftSquareFill", library: "bs" },
	{ icon: BsFillCaretRightFill, name: "BsFillCaretRightFill", library: "bs" },
	{
		icon: BsFillCaretRightSquareFill,
		name: "BsFillCaretRightSquareFill",
		library: "bs",
	},
	{ icon: BsFillCaretUpFill, name: "BsFillCaretUpFill", library: "bs" },
	{ icon: BsFillCaretUpSquareFill, name: "BsFillCaretUpSquareFill", library: "bs" },
	{ icon: BsFillCartCheckFill, name: "BsFillCartCheckFill", library: "bs" },
	{ icon: BsFillCartDashFill, name: "BsFillCartDashFill", library: "bs" },
	{ icon: BsFillCartFill, name: "BsFillCartFill", library: "bs" },
	{ icon: BsFillCartPlusFill, name: "BsFillCartPlusFill", library: "bs" },
	{ icon: BsFillCartXFill, name: "BsFillCartXFill", library: "bs" },
	{ icon: BsFillChatDotsFill, name: "BsFillChatDotsFill", library: "bs" },
	{ icon: BsFillChatFill, name: "BsFillChatFill", library: "bs" },
	{ icon: BsFillChatLeftDotsFill, name: "BsFillChatLeftDotsFill", library: "bs" },
	{ icon: BsFillChatLeftFill, name: "BsFillChatLeftFill", library: "bs" },
	{ icon: BsFillChatLeftQuoteFill, name: "BsFillChatLeftQuoteFill", library: "bs" },
	{ icon: BsFillChatLeftTextFill, name: "BsFillChatLeftTextFill", library: "bs" },
	{ icon: BsFillChatQuoteFill, name: "BsFillChatQuoteFill", library: "bs" },
	{ icon: BsFillChatRightDotsFill, name: "BsFillChatRightDotsFill", library: "bs" },
	{ icon: BsFillChatRightFill, name: "BsFillChatRightFill", library: "bs" },
	{ icon: BsFillChatRightQuoteFill, name: "BsFillChatRightQuoteFill", library: "bs" },
	{ icon: BsFillChatRightTextFill, name: "BsFillChatRightTextFill", library: "bs" },
	{ icon: BsFillChatSquareDotsFill, name: "BsFillChatSquareDotsFill", library: "bs" },
	{ icon: BsFillChatSquareFill, name: "BsFillChatSquareFill", library: "bs" },
	{ icon: BsFillChatSquareQuoteFill, name: "BsFillChatSquareQuoteFill", library: "bs" },
	{ icon: BsFillChatSquareTextFill, name: "BsFillChatSquareTextFill", library: "bs" },
	{ icon: BsFillChatTextFill, name: "BsFillChatTextFill", library: "bs" },
	{ icon: BsFillCheckCircleFill, name: "BsFillCheckCircleFill", library: "bs" },
	{ icon: BsFillCheckSquareFill, name: "BsFillCheckSquareFill", library: "bs" },
	{ icon: BsFillCircleFill, name: "BsFillCircleFill", library: "bs" },
	{ icon: BsFillClockFill, name: "BsFillClockFill", library: "bs" },
	{ icon: BsFillCloudArrowDownFill, name: "BsFillCloudArrowDownFill", library: "bs" },
	{ icon: BsFillCloudArrowUpFill, name: "BsFillCloudArrowUpFill", library: "bs" },
	{ icon: BsFillCloudCheckFill, name: "BsFillCloudCheckFill", library: "bs" },
	{ icon: BsFillCloudDownloadFill, name: "BsFillCloudDownloadFill", library: "bs" },
	{ icon: BsFillCloudDrizzleFill, name: "BsFillCloudDrizzleFill", library: "bs" },
	{ icon: BsFillCloudFill, name: "BsFillCloudFill", library: "bs" },
	{ icon: BsFillCloudFogFill, name: "BsFillCloudFogFill", library: "bs" },
	{ icon: BsFillCloudFog2Fill, name: "BsFillCloudFog2Fill", library: "bs" },
	{ icon: BsFillCloudHailFill, name: "BsFillCloudHailFill", library: "bs" },
	{ icon: BsFillCloudHazeFill, name: "BsFillCloudHazeFill", library: "bs" },
	{ icon: BsFillCloudHaze2Fill, name: "BsFillCloudHaze2Fill", library: "bs" },
	{ icon: BsFillCloudLightningFill, name: "BsFillCloudLightningFill", library: "bs" },
	{
		icon: BsFillCloudLightningRainFill,
		name: "BsFillCloudLightningRainFill",
		library: "bs",
	},
	{ icon: BsFillCloudMinusFill, name: "BsFillCloudMinusFill", library: "bs" },
	{ icon: BsFillCloudMoonFill, name: "BsFillCloudMoonFill", library: "bs" },
	{ icon: BsFillCloudPlusFill, name: "BsFillCloudPlusFill", library: "bs" },
	{ icon: BsFillCloudRainFill, name: "BsFillCloudRainFill", library: "bs" },
	{ icon: BsFillCloudRainHeavyFill, name: "BsFillCloudRainHeavyFill", library: "bs" },
	{ icon: BsFillCloudSlashFill, name: "BsFillCloudSlashFill", library: "bs" },
	{ icon: BsFillCloudSleetFill, name: "BsFillCloudSleetFill", library: "bs" },
	{ icon: BsFillCloudSnowFill, name: "BsFillCloudSnowFill", library: "bs" },
	{ icon: BsFillCloudSunFill, name: "BsFillCloudSunFill", library: "bs" },
	{ icon: BsFillCloudUploadFill, name: "BsFillCloudUploadFill", library: "bs" },
	{ icon: BsFillCloudsFill, name: "BsFillCloudsFill", library: "bs" },
	{ icon: BsFillCloudyFill, name: "BsFillCloudyFill", library: "bs" },
	{ icon: BsFillCollectionFill, name: "BsFillCollectionFill", library: "bs" },
	{ icon: BsFillCollectionPlayFill, name: "BsFillCollectionPlayFill", library: "bs" },
	{ icon: BsFillCompassFill, name: "BsFillCompassFill", library: "bs" },
	{ icon: BsFillCpuFill, name: "BsFillCpuFill", library: "bs" },
	{ icon: BsFillCreditCard2BackFill, name: "BsFillCreditCard2BackFill", library: "bs" },
	{
		icon: BsFillCreditCard2FrontFill,
		name: "BsFillCreditCard2FrontFill",
		library: "bs",
	},
	{ icon: BsFillCreditCardFill, name: "BsFillCreditCardFill", library: "bs" },
	{ icon: BsFillCupFill, name: "BsFillCupFill", library: "bs" },
	{ icon: BsFillCursorFill, name: "BsFillCursorFill", library: "bs" },
	{ icon: BsFillDashCircleFill, name: "BsFillDashCircleFill", library: "bs" },
	{ icon: BsFillDashSquareFill, name: "BsFillDashSquareFill", library: "bs" },
	{ icon: BsFillDiagram2Fill, name: "BsFillDiagram2Fill", library: "bs" },
	{ icon: BsFillDiagram3Fill, name: "BsFillDiagram3Fill", library: "bs" },
	{ icon: BsFillDiamondFill, name: "BsFillDiamondFill", library: "bs" },
	{ icon: BsFillDice1Fill, name: "BsFillDice1Fill", library: "bs" },
	{ icon: BsFillDice2Fill, name: "BsFillDice2Fill", library: "bs" },
	{ icon: BsFillDice3Fill, name: "BsFillDice3Fill", library: "bs" },
	{ icon: BsFillDice4Fill, name: "BsFillDice4Fill", library: "bs" },
	{ icon: BsFillDice5Fill, name: "BsFillDice5Fill", library: "bs" },
	{ icon: BsFillDice6Fill, name: "BsFillDice6Fill", library: "bs" },
	{ icon: BsFillDiscFill, name: "BsFillDiscFill", library: "bs" },
	{ icon: BsFillDisplayFill, name: "BsFillDisplayFill", library: "bs" },
	{ icon: BsFillDoorClosedFill, name: "BsFillDoorClosedFill", library: "bs" },
	{ icon: BsFillDoorOpenFill, name: "BsFillDoorOpenFill", library: "bs" },
	{ icon: BsFillDropletFill, name: "BsFillDropletFill", library: "bs" },
	{ icon: BsFillEaselFill, name: "BsFillEaselFill", library: "bs" },
	{ icon: BsFillEggFill, name: "BsFillEggFill", library: "bs" },
	{ icon: BsFillEjectFill, name: "BsFillEjectFill", library: "bs" },
	{ icon: BsFillEmojiAngryFill, name: "BsFillEmojiAngryFill", library: "bs" },
	{ icon: BsFillEmojiDizzyFill, name: "BsFillEmojiDizzyFill", library: "bs" },
	{
		icon: BsFillEmojiExpressionlessFill,
		name: "BsFillEmojiExpressionlessFill",
		library: "bs",
	},
	{ icon: BsFillEmojiFrownFill, name: "BsFillEmojiFrownFill", library: "bs" },
	{ icon: BsFillEmojiHeartEyesFill, name: "BsFillEmojiHeartEyesFill", library: "bs" },
	{ icon: BsFillEmojiLaughingFill, name: "BsFillEmojiLaughingFill", library: "bs" },
	{ icon: BsFillEmojiNeutralFill, name: "BsFillEmojiNeutralFill", library: "bs" },
	{ icon: BsFillEmojiSmileFill, name: "BsFillEmojiSmileFill", library: "bs" },
	{
		icon: BsFillEmojiSmileUpsideDownFill,
		name: "BsFillEmojiSmileUpsideDownFill",
		library: "bs",
	},
	{ icon: BsFillEmojiSunglassesFill, name: "BsFillEmojiSunglassesFill", library: "bs" },
	{ icon: BsFillEmojiWinkFill, name: "BsFillEmojiWinkFill", library: "bs" },
	{ icon: BsFillEnvelopeFill, name: "BsFillEnvelopeFill", library: "bs" },
	{ icon: BsFillEnvelopeOpenFill, name: "BsFillEnvelopeOpenFill", library: "bs" },
	{ icon: BsFillEraserFill, name: "BsFillEraserFill", library: "bs" },
	{
		icon: BsFillExclamationCircleFill,
		name: "BsFillExclamationCircleFill",
		library: "bs",
	},
	{
		icon: BsFillExclamationDiamondFill,
		name: "BsFillExclamationDiamondFill",
		library: "bs",
	},
	{
		icon: BsFillExclamationOctagonFill,
		name: "BsFillExclamationOctagonFill",
		library: "bs",
	},
	{
		icon: BsFillExclamationSquareFill,
		name: "BsFillExclamationSquareFill",
		library: "bs",
	},
	{
		icon: BsFillExclamationTriangleFill,
		name: "BsFillExclamationTriangleFill",
		library: "bs",
	},
	{ icon: BsFillEyeFill, name: "BsFillEyeFill", library: "bs" },
	{ icon: BsFillEyeSlashFill, name: "BsFillEyeSlashFill", library: "bs" },
	{ icon: BsFillFileArrowDownFill, name: "BsFillFileArrowDownFill", library: "bs" },
	{ icon: BsFillFileArrowUpFill, name: "BsFillFileArrowUpFill", library: "bs" },
	{ icon: BsFillFileBarGraphFill, name: "BsFillFileBarGraphFill", library: "bs" },
	{ icon: BsFillFileBinaryFill, name: "BsFillFileBinaryFill", library: "bs" },
	{ icon: BsFillFileBreakFill, name: "BsFillFileBreakFill", library: "bs" },
	{ icon: BsFillFileCheckFill, name: "BsFillFileCheckFill", library: "bs" },
	{ icon: BsFillFileCodeFill, name: "BsFillFileCodeFill", library: "bs" },
	{ icon: BsFillFileDiffFill, name: "BsFillFileDiffFill", library: "bs" },
	{
		icon: BsFillFileEarmarkArrowDownFill,
		name: "BsFillFileEarmarkArrowDownFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkArrowUpFill,
		name: "BsFillFileEarmarkArrowUpFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkBarGraphFill,
		name: "BsFillFileEarmarkBarGraphFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkBinaryFill,
		name: "BsFillFileEarmarkBinaryFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkBreakFill,
		name: "BsFillFileEarmarkBreakFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkCheckFill,
		name: "BsFillFileEarmarkCheckFill",
		library: "bs",
	},
	{ icon: BsFillFileEarmarkCodeFill, name: "BsFillFileEarmarkCodeFill", library: "bs" },
	{ icon: BsFillFileEarmarkDiffFill, name: "BsFillFileEarmarkDiffFill", library: "bs" },
	{
		icon: BsFillFileEarmarkEaselFill,
		name: "BsFillFileEarmarkEaselFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkExcelFill,
		name: "BsFillFileEarmarkExcelFill",
		library: "bs",
	},
	{ icon: BsFillFileEarmarkFill, name: "BsFillFileEarmarkFill", library: "bs" },
	{ icon: BsFillFileEarmarkFontFill, name: "BsFillFileEarmarkFontFill", library: "bs" },
	{
		icon: BsFillFileEarmarkImageFill,
		name: "BsFillFileEarmarkImageFill",
		library: "bs",
	},
	{ icon: BsFillFileEarmarkLockFill, name: "BsFillFileEarmarkLockFill", library: "bs" },
	{
		icon: BsFillFileEarmarkLock2Fill,
		name: "BsFillFileEarmarkLock2Fill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkMedicalFill,
		name: "BsFillFileEarmarkMedicalFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkMinusFill,
		name: "BsFillFileEarmarkMinusFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkMusicFill,
		name: "BsFillFileEarmarkMusicFill",
		library: "bs",
	},
	{ icon: BsFillFileEarmarkPdfFill, name: "BsFillFileEarmarkPdfFill", library: "bs" },
	{
		icon: BsFillFileEarmarkPersonFill,
		name: "BsFillFileEarmarkPersonFill",
		library: "bs",
	},
	{ icon: BsFillFileEarmarkPlayFill, name: "BsFillFileEarmarkPlayFill", library: "bs" },
	{ icon: BsFillFileEarmarkPlusFill, name: "BsFillFileEarmarkPlusFill", library: "bs" },
	{ icon: BsFillFileEarmarkPostFill, name: "BsFillFileEarmarkPostFill", library: "bs" },
	{ icon: BsFillFileEarmarkPptFill, name: "BsFillFileEarmarkPptFill", library: "bs" },
	{
		icon: BsFillFileEarmarkRichtextFill,
		name: "BsFillFileEarmarkRichtextFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkRuledFill,
		name: "BsFillFileEarmarkRuledFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkSlidesFill,
		name: "BsFillFileEarmarkSlidesFill",
		library: "bs",
	},
	{
		icon: BsFillFileEarmarkSpreadsheetFill,
		name: "BsFillFileEarmarkSpreadsheetFill",
		library: "bs",
	},
	{ icon: BsFillFileEarmarkTextFill, name: "BsFillFileEarmarkTextFill", library: "bs" },
	{ icon: BsFillFileEarmarkWordFill, name: "BsFillFileEarmarkWordFill", library: "bs" },
	{ icon: BsFillFileEarmarkXFill, name: "BsFillFileEarmarkXFill", library: "bs" },
	{ icon: BsFillFileEarmarkZipFill, name: "BsFillFileEarmarkZipFill", library: "bs" },
	{ icon: BsFillFileEaselFill, name: "BsFillFileEaselFill", library: "bs" },
	{ icon: BsFillFileExcelFill, name: "BsFillFileExcelFill", library: "bs" },
	{ icon: BsFillFileFill, name: "BsFillFileFill", library: "bs" },
	{ icon: BsFillFileFontFill, name: "BsFillFileFontFill", library: "bs" },
	{ icon: BsFillFileImageFill, name: "BsFillFileImageFill", library: "bs" },
	{ icon: BsFillFileLockFill, name: "BsFillFileLockFill", library: "bs" },
	{ icon: BsFillFileLock2Fill, name: "BsFillFileLock2Fill", library: "bs" },
	{ icon: BsFillFileMedicalFill, name: "BsFillFileMedicalFill", library: "bs" },
	{ icon: BsFillFileMinusFill, name: "BsFillFileMinusFill", library: "bs" },
	{ icon: BsFillFileMusicFill, name: "BsFillFileMusicFill", library: "bs" },
	{ icon: BsFillFilePdfFill, name: "BsFillFilePdfFill", library: "bs" },
	{ icon: BsFillFilePersonFill, name: "BsFillFilePersonFill", library: "bs" },
	{ icon: BsFillFilePlayFill, name: "BsFillFilePlayFill", library: "bs" },
	{ icon: BsFillFilePlusFill, name: "BsFillFilePlusFill", library: "bs" },
	{ icon: BsFillFilePostFill, name: "BsFillFilePostFill", library: "bs" },
	{ icon: BsFillFilePptFill, name: "BsFillFilePptFill", library: "bs" },
	{ icon: BsFillFileRichtextFill, name: "BsFillFileRichtextFill", library: "bs" },
	{ icon: BsFillFileRuledFill, name: "BsFillFileRuledFill", library: "bs" },
	{ icon: BsFillFileSlidesFill, name: "BsFillFileSlidesFill", library: "bs" },
	{ icon: BsFillFileSpreadsheetFill, name: "BsFillFileSpreadsheetFill", library: "bs" },
	{ icon: BsFillFileTextFill, name: "BsFillFileTextFill", library: "bs" },
	{ icon: BsFillFileWordFill, name: "BsFillFileWordFill", library: "bs" },
	{ icon: BsFillFileXFill, name: "BsFillFileXFill", library: "bs" },
	{ icon: BsFillFileZipFill, name: "BsFillFileZipFill", library: "bs" },
	{ icon: BsFillFilterCircleFill, name: "BsFillFilterCircleFill", library: "bs" },
	{ icon: BsFillFilterSquareFill, name: "BsFillFilterSquareFill", library: "bs" },
	{ icon: BsFillFlagFill, name: "BsFillFlagFill", library: "bs" },
	{ icon: BsFillFolderFill, name: "BsFillFolderFill", library: "bs" },
	{ icon: BsFillFolderSymlinkFill, name: "BsFillFolderSymlinkFill", library: "bs" },
	{ icon: BsFillForwardFill, name: "BsFillForwardFill", library: "bs" },
	{ icon: BsFillFunnelFill, name: "BsFillFunnelFill", library: "bs" },
	{ icon: BsFillGearFill, name: "BsFillGearFill", library: "bs" },
	{ icon: BsFillGeoAltFill, name: "BsFillGeoAltFill", library: "bs" },
	{ icon: BsFillGeoFill, name: "BsFillGeoFill", library: "bs" },
	{ icon: BsFillGiftFill, name: "BsFillGiftFill", library: "bs" },
	{ icon: BsFillGrid1X2Fill, name: "BsFillGrid1X2Fill", library: "bs" },
	{ icon: BsFillGrid3X2GapFill, name: "BsFillGrid3X2GapFill", library: "bs" },
	{ icon: BsFillGrid3X3GapFill, name: "BsFillGrid3X3GapFill", library: "bs" },
	{ icon: BsFillGridFill, name: "BsFillGridFill", library: "bs" },
	{ icon: BsFillHandIndexFill, name: "BsFillHandIndexFill", library: "bs" },
	{ icon: BsFillHandIndexThumbFill, name: "BsFillHandIndexThumbFill", library: "bs" },
	{ icon: BsFillHandThumbsDownFill, name: "BsFillHandThumbsDownFill", library: "bs" },
	{ icon: BsFillHandThumbsUpFill, name: "BsFillHandThumbsUpFill", library: "bs" },
	{ icon: BsFillHandbagFill, name: "BsFillHandbagFill", library: "bs" },
	{ icon: BsFillHddFill, name: "BsFillHddFill", library: "bs" },
	{ icon: BsFillHddNetworkFill, name: "BsFillHddNetworkFill", library: "bs" },
	{ icon: BsFillHddRackFill, name: "BsFillHddRackFill", library: "bs" },
	{ icon: BsFillHddStackFill, name: "BsFillHddStackFill", library: "bs" },
	{ icon: BsFillHeartFill, name: "BsFillHeartFill", library: "bs" },
	{ icon: BsFillHeptagonFill, name: "BsFillHeptagonFill", library: "bs" },
	{ icon: BsFillHexagonFill, name: "BsFillHexagonFill", library: "bs" },
	{ icon: BsFillHouseDoorFill, name: "BsFillHouseDoorFill", library: "bs" },
	{ icon: BsFillHouseFill, name: "BsFillHouseFill", library: "bs" },
	{ icon: BsFillImageFill, name: "BsFillImageFill", library: "bs" },
	{ icon: BsFillInboxFill, name: "BsFillInboxFill", library: "bs" },
	{ icon: BsFillInboxesFill, name: "BsFillInboxesFill", library: "bs" },
	{ icon: BsFillInfoCircleFill, name: "BsFillInfoCircleFill", library: "bs" },
	{ icon: BsFillInfoSquareFill, name: "BsFillInfoSquareFill", library: "bs" },
	{ icon: BsFillJournalBookmarkFill, name: "BsFillJournalBookmarkFill", library: "bs" },
	{ icon: BsFillKanbanFill, name: "BsFillKanbanFill", library: "bs" },
	{ icon: BsFillKeyFill, name: "BsFillKeyFill", library: "bs" },
	{ icon: BsFillKeyboardFill, name: "BsFillKeyboardFill", library: "bs" },
	{ icon: BsFillLampFill, name: "BsFillLampFill", library: "bs" },
	{ icon: BsFillLaptopFill, name: "BsFillLaptopFill", library: "bs" },
	{ icon: BsFillLayersFill, name: "BsFillLayersFill", library: "bs" },
	{ icon: BsFillLightbulbFill, name: "BsFillLightbulbFill", library: "bs" },
	{ icon: BsFillLightbulbOffFill, name: "BsFillLightbulbOffFill", library: "bs" },
	{ icon: BsFillLightningChargeFill, name: "BsFillLightningChargeFill", library: "bs" },
	{ icon: BsFillLightningFill, name: "BsFillLightningFill", library: "bs" },
	{ icon: BsFillLockFill, name: "BsFillLockFill", library: "bs" },
	{ icon: BsFillMapFill, name: "BsFillMapFill", library: "bs" },
	{ icon: BsFillMarkdownFill, name: "BsFillMarkdownFill", library: "bs" },
	{ icon: BsFillMegaphoneFill, name: "BsFillMegaphoneFill", library: "bs" },
	{ icon: BsFillMenuAppFill, name: "BsFillMenuAppFill", library: "bs" },
	{ icon: BsFillMenuButtonFill, name: "BsFillMenuButtonFill", library: "bs" },
	{ icon: BsFillMenuButtonWideFill, name: "BsFillMenuButtonWideFill", library: "bs" },
	{ icon: BsFillMicFill, name: "BsFillMicFill", library: "bs" },
	{ icon: BsFillMicMuteFill, name: "BsFillMicMuteFill", library: "bs" },
	{ icon: BsFillMoonFill, name: "BsFillMoonFill", library: "bs" },
	{ icon: BsFillMoonStarsFill, name: "BsFillMoonStarsFill", library: "bs" },
	{ icon: BsFillMouseFill, name: "BsFillMouseFill", library: "bs" },
	{ icon: BsFillMouse2Fill, name: "BsFillMouse2Fill", library: "bs" },
	{ icon: BsFillMouse3Fill, name: "BsFillMouse3Fill", library: "bs" },
	{ icon: BsFillMusicPlayerFill, name: "BsFillMusicPlayerFill", library: "bs" },
	{ icon: BsFillNodeMinusFill, name: "BsFillNodeMinusFill", library: "bs" },
	{ icon: BsFillNodePlusFill, name: "BsFillNodePlusFill", library: "bs" },
	{ icon: BsFillNutFill, name: "BsFillNutFill", library: "bs" },
	{ icon: BsFillOctagonFill, name: "BsFillOctagonFill", library: "bs" },
	{ icon: BsFillPaletteFill, name: "BsFillPaletteFill", library: "bs" },
	{ icon: BsFillPatchCheckFill, name: "BsFillPatchCheckFill", library: "bs" },
	{
		icon: BsFillPatchExclamationFill,
		name: "BsFillPatchExclamationFill",
		library: "bs",
	},
	{ icon: BsFillPatchMinusFill, name: "BsFillPatchMinusFill", library: "bs" },
	{ icon: BsFillPatchPlusFill, name: "BsFillPatchPlusFill", library: "bs" },
	{ icon: BsFillPatchQuestionFill, name: "BsFillPatchQuestionFill", library: "bs" },
	{ icon: BsFillPauseBtnFill, name: "BsFillPauseBtnFill", library: "bs" },
	{ icon: BsFillPauseCircleFill, name: "BsFillPauseCircleFill", library: "bs" },
	{ icon: BsFillPauseFill, name: "BsFillPauseFill", library: "bs" },
	{ icon: BsFillPeaceFill, name: "BsFillPeaceFill", library: "bs" },
	{ icon: BsFillPenFill, name: "BsFillPenFill", library: "bs" },
	{ icon: BsFillPencilFill, name: "BsFillPencilFill", library: "bs" },
	{ icon: BsFillPentagonFill, name: "BsFillPentagonFill", library: "bs" },
	{ icon: BsFillPeopleFill, name: "BsFillPeopleFill", library: "bs" },
	{ icon: BsFillPersonBadgeFill, name: "BsFillPersonBadgeFill", library: "bs" },
	{ icon: BsFillPersonCheckFill, name: "BsFillPersonCheckFill", library: "bs" },
	{ icon: BsFillPersonDashFill, name: "BsFillPersonDashFill", library: "bs" },
	{ icon: BsFillPersonFill, name: "BsFillPersonFill", library: "bs" },
	{ icon: BsFillPersonLinesFill, name: "BsFillPersonLinesFill", library: "bs" },
	{ icon: BsFillPersonPlusFill, name: "BsFillPersonPlusFill", library: "bs" },
	{ icon: BsFillPersonXFill, name: "BsFillPersonXFill", library: "bs" },
	{ icon: BsFillPhoneFill, name: "BsFillPhoneFill", library: "bs" },
	{ icon: BsFillPhoneLandscapeFill, name: "BsFillPhoneLandscapeFill", library: "bs" },
	{ icon: BsFillPhoneVibrateFill, name: "BsFillPhoneVibrateFill", library: "bs" },
	{ icon: BsFillPieChartFill, name: "BsFillPieChartFill", library: "bs" },
	{ icon: BsFillPiggyBankFill, name: "BsFillPiggyBankFill", library: "bs" },
	{ icon: BsFillPinAngleFill, name: "BsFillPinAngleFill", library: "bs" },
	{ icon: BsFillPinFill, name: "BsFillPinFill", library: "bs" },
	{ icon: BsFillPinMapFill, name: "BsFillPinMapFill", library: "bs" },
	{ icon: BsFillPipFill, name: "BsFillPipFill", library: "bs" },
	{ icon: BsFillPlayBtnFill, name: "BsFillPlayBtnFill", library: "bs" },
	{ icon: BsFillPlayCircleFill, name: "BsFillPlayCircleFill", library: "bs" },
	{ icon: BsFillPlayFill, name: "BsFillPlayFill", library: "bs" },
	{ icon: BsFillPlugFill, name: "BsFillPlugFill", library: "bs" },
	{ icon: BsFillPlusCircleFill, name: "BsFillPlusCircleFill", library: "bs" },
	{ icon: BsFillPlusSquareFill, name: "BsFillPlusSquareFill", library: "bs" },
	{ icon: BsFillPrinterFill, name: "BsFillPrinterFill", library: "bs" },
	{ icon: BsFillPuzzleFill, name: "BsFillPuzzleFill", library: "bs" },
	{ icon: BsFillQuestionCircleFill, name: "BsFillQuestionCircleFill", library: "bs" },
	{ icon: BsFillQuestionDiamondFill, name: "BsFillQuestionDiamondFill", library: "bs" },
	{ icon: BsFillQuestionOctagonFill, name: "BsFillQuestionOctagonFill", library: "bs" },
	{ icon: BsFillQuestionSquareFill, name: "BsFillQuestionSquareFill", library: "bs" },
	{ icon: BsFillRecordBtnFill, name: "BsFillRecordBtnFill", library: "bs" },
	{ icon: BsFillRecordCircleFill, name: "BsFillRecordCircleFill", library: "bs" },
	{ icon: BsFillRecordFill, name: "BsFillRecordFill", library: "bs" },
	{ icon: BsFillRecord2Fill, name: "BsFillRecord2Fill", library: "bs" },
	{ icon: BsFillReplyAllFill, name: "BsFillReplyAllFill", library: "bs" },
	{ icon: BsFillReplyFill, name: "BsFillReplyFill", library: "bs" },
	{ icon: BsFillRssFill, name: "BsFillRssFill", library: "bs" },
	{ icon: BsFillSafeFill, name: "BsFillSafeFill", library: "bs" },
	{ icon: BsFillSafe2Fill, name: "BsFillSafe2Fill", library: "bs" },
	{ icon: BsFillSaveFill, name: "BsFillSaveFill", library: "bs" },
	{ icon: BsFillSave2Fill, name: "BsFillSave2Fill", library: "bs" },
	{ icon: BsFillSdCardFill, name: "BsFillSdCardFill", library: "bs" },
	{ icon: BsFillShareFill, name: "BsFillShareFill", library: "bs" },
	{ icon: BsFillShieldFill, name: "BsFillShieldFill", library: "bs" },
	{ icon: BsFillShieldLockFill, name: "BsFillShieldLockFill", library: "bs" },
	{ icon: BsFillShieldSlashFill, name: "BsFillShieldSlashFill", library: "bs" },
	{ icon: BsFillShiftFill, name: "BsFillShiftFill", library: "bs" },
	{ icon: BsFillSignpost2Fill, name: "BsFillSignpost2Fill", library: "bs" },
	{ icon: BsFillSignpostFill, name: "BsFillSignpostFill", library: "bs" },
	{ icon: BsFillSignpostSplitFill, name: "BsFillSignpostSplitFill", library: "bs" },
	{ icon: BsFillSimFill, name: "BsFillSimFill", library: "bs" },
	{ icon: BsFillSkipBackwardBtnFill, name: "BsFillSkipBackwardBtnFill", library: "bs" },
	{
		icon: BsFillSkipBackwardCircleFill,
		name: "BsFillSkipBackwardCircleFill",
		library: "bs",
	},
	{ icon: BsFillSkipBackwardFill, name: "BsFillSkipBackwardFill", library: "bs" },
	{ icon: BsFillSkipEndBtnFill, name: "BsFillSkipEndBtnFill", library: "bs" },
	{ icon: BsFillSkipEndCircleFill, name: "BsFillSkipEndCircleFill", library: "bs" },
	{ icon: BsFillSkipEndFill, name: "BsFillSkipEndFill", library: "bs" },
	{ icon: BsFillSkipForwardBtnFill, name: "BsFillSkipForwardBtnFill", library: "bs" },
	{
		icon: BsFillSkipForwardCircleFill,
		name: "BsFillSkipForwardCircleFill",
		library: "bs",
	},
	{ icon: BsFillSkipForwardFill, name: "BsFillSkipForwardFill", library: "bs" },
	{ icon: BsFillSkipStartBtnFill, name: "BsFillSkipStartBtnFill", library: "bs" },
	{ icon: BsFillSkipStartCircleFill, name: "BsFillSkipStartCircleFill", library: "bs" },
	{ icon: BsFillSkipStartFill, name: "BsFillSkipStartFill", library: "bs" },
	{ icon: BsFillSlashCircleFill, name: "BsFillSlashCircleFill", library: "bs" },
	{ icon: BsFillSlashSquareFill, name: "BsFillSlashSquareFill", library: "bs" },
	{ icon: BsFillSpeakerFill, name: "BsFillSpeakerFill", library: "bs" },
	{ icon: BsFillSquareFill, name: "BsFillSquareFill", library: "bs" },
	{ icon: BsFillStarFill, name: "BsFillStarFill", library: "bs" },
	{ icon: BsFillStickiesFill, name: "BsFillStickiesFill", library: "bs" },
	{ icon: BsFillStickyFill, name: "BsFillStickyFill", library: "bs" },
	{ icon: BsFillStopBtnFill, name: "BsFillStopBtnFill", library: "bs" },
	{ icon: BsFillStopCircleFill, name: "BsFillStopCircleFill", library: "bs" },
	{ icon: BsFillStopFill, name: "BsFillStopFill", library: "bs" },
	{ icon: BsFillStoplightsFill, name: "BsFillStoplightsFill", library: "bs" },
	{ icon: BsFillStopwatchFill, name: "BsFillStopwatchFill", library: "bs" },
	{ icon: BsFillSuitClubFill, name: "BsFillSuitClubFill", library: "bs" },
	{ icon: BsFillSuitDiamondFill, name: "BsFillSuitDiamondFill", library: "bs" },
	{ icon: BsFillSuitHeartFill, name: "BsFillSuitHeartFill", library: "bs" },
	{ icon: BsFillSuitSpadeFill, name: "BsFillSuitSpadeFill", library: "bs" },
	{ icon: BsFillSunFill, name: "BsFillSunFill", library: "bs" },
	{ icon: BsFillSunriseFill, name: "BsFillSunriseFill", library: "bs" },
	{ icon: BsFillSunsetFill, name: "BsFillSunsetFill", library: "bs" },
	{ icon: BsFillTabletFill, name: "BsFillTabletFill", library: "bs" },
	{ icon: BsFillTabletLandscapeFill, name: "BsFillTabletLandscapeFill", library: "bs" },
	{ icon: BsFillTagFill, name: "BsFillTagFill", library: "bs" },
	{ icon: BsFillTagsFill, name: "BsFillTagsFill", library: "bs" },
	{ icon: BsFillTelephoneFill, name: "BsFillTelephoneFill", library: "bs" },
	{
		icon: BsFillTelephoneForwardFill,
		name: "BsFillTelephoneForwardFill",
		library: "bs",
	},
	{
		icon: BsFillTelephoneInboundFill,
		name: "BsFillTelephoneInboundFill",
		library: "bs",
	},
	{ icon: BsFillTelephoneMinusFill, name: "BsFillTelephoneMinusFill", library: "bs" },
	{
		icon: BsFillTelephoneOutboundFill,
		name: "BsFillTelephoneOutboundFill",
		library: "bs",
	},
	{ icon: BsFillTelephonePlusFill, name: "BsFillTelephonePlusFill", library: "bs" },
	{ icon: BsFillTelephoneXFill, name: "BsFillTelephoneXFill", library: "bs" },
	{ icon: BsFillTerminalFill, name: "BsFillTerminalFill", library: "bs" },
	{ icon: BsFillTrashFill, name: "BsFillTrashFill", library: "bs" },
	{ icon: BsFillTrash2Fill, name: "BsFillTrash2Fill", library: "bs" },
	{ icon: BsFillTreeFill, name: "BsFillTreeFill", library: "bs" },
	{ icon: BsFillTriangleFill, name: "BsFillTriangleFill", library: "bs" },
	{ icon: BsFillTrophyFill, name: "BsFillTrophyFill", library: "bs" },
	{ icon: BsFillTvFill, name: "BsFillTvFill", library: "bs" },
	{ icon: BsFillUmbrellaFill, name: "BsFillUmbrellaFill", library: "bs" },
	{ icon: BsFillUnlockFill, name: "BsFillUnlockFill", library: "bs" },
	{ icon: BsFillVinylFill, name: "BsFillVinylFill", library: "bs" },
	{ icon: BsFillVolumeDownFill, name: "BsFillVolumeDownFill", library: "bs" },
	{ icon: BsFillVolumeMuteFill, name: "BsFillVolumeMuteFill", library: "bs" },
	{ icon: BsFillVolumeOffFill, name: "BsFillVolumeOffFill", library: "bs" },
	{ icon: BsFillVolumeUpFill, name: "BsFillVolumeUpFill", library: "bs" },
	{ icon: BsFillWalletFill, name: "BsFillWalletFill", library: "bs" },
	{ icon: BsFillXCircleFill, name: "BsFillXCircleFill", library: "bs" },
	{ icon: BsFillXDiamondFill, name: "BsFillXDiamondFill", library: "bs" },
	{ icon: BsFillXOctagonFill, name: "BsFillXOctagonFill", library: "bs" },
	{ icon: BsFillXSquareFill, name: "BsFillXSquareFill", library: "bs" },
	{ icon: BsReverseBackspaceReverse, name: "BsReverseBackspaceReverse", library: "bs" },
	{
		icon: BsReverseLayoutSidebarInsetReverse,
		name: "BsReverseLayoutSidebarInsetReverse",
		library: "bs",
	},
	{
		icon: BsReverseLayoutSidebarReverse,
		name: "BsReverseLayoutSidebarReverse",
		library: "bs",
	},
	{
		icon: BsReverseLayoutTextSidebarReverse,
		name: "BsReverseLayoutTextSidebarReverse",
		library: "bs",
	},
	{
		icon: BsReverseLayoutTextWindowReverse,
		name: "BsReverseLayoutTextWindowReverse",
		library: "bs",
	},
	{ icon: BsAlarmFill, name: "BsAlarmFill", library: "bs" },
	{ icon: BsAlarm, name: "BsAlarm", library: "bs" },
	{ icon: BsAlignBottom, name: "BsAlignBottom", library: "bs" },
	{ icon: BsAlignCenter, name: "BsAlignCenter", library: "bs" },
	{ icon: BsAlignEnd, name: "BsAlignEnd", library: "bs" },
	{ icon: BsAlignMiddle, name: "BsAlignMiddle", library: "bs" },
	{ icon: BsAlignStart, name: "BsAlignStart", library: "bs" },
	{ icon: BsAlignTop, name: "BsAlignTop", library: "bs" },
	{ icon: BsAlt, name: "BsAlt", library: "bs" },
	{ icon: BsAppIndicator, name: "BsAppIndicator", library: "bs" },
	{ icon: BsApp, name: "BsApp", library: "bs" },
	{ icon: BsApple, name: "BsApple", library: "bs" },
	{ icon: BsArchiveFill, name: "BsArchiveFill", library: "bs" },
	{ icon: BsArchive, name: "BsArchive", library: "bs" },
	{ icon: BsArrow90DegDown, name: "BsArrow90DegDown", library: "bs" },
	{ icon: BsArrow90DegLeft, name: "BsArrow90DegLeft", library: "bs" },
	{ icon: BsArrow90DegRight, name: "BsArrow90DegRight", library: "bs" },
	{ icon: BsArrow90DegUp, name: "BsArrow90DegUp", library: "bs" },
	{ icon: BsArrowBarDown, name: "BsArrowBarDown", library: "bs" },
	{ icon: BsArrowBarLeft, name: "BsArrowBarLeft", library: "bs" },
	{ icon: BsArrowBarRight, name: "BsArrowBarRight", library: "bs" },
	{ icon: BsArrowBarUp, name: "BsArrowBarUp", library: "bs" },
	{ icon: BsArrowClockwise, name: "BsArrowClockwise", library: "bs" },
	{ icon: BsArrowCounterclockwise, name: "BsArrowCounterclockwise", library: "bs" },
	{ icon: BsArrowDownCircleFill, name: "BsArrowDownCircleFill", library: "bs" },
	{ icon: BsArrowDownCircle, name: "BsArrowDownCircle", library: "bs" },
	{ icon: BsArrowDownLeftCircleFill, name: "BsArrowDownLeftCircleFill", library: "bs" },
	{ icon: BsArrowDownLeftCircle, name: "BsArrowDownLeftCircle", library: "bs" },
	{ icon: BsArrowDownLeftSquareFill, name: "BsArrowDownLeftSquareFill", library: "bs" },
	{ icon: BsArrowDownLeftSquare, name: "BsArrowDownLeftSquare", library: "bs" },
	{ icon: BsArrowDownLeft, name: "BsArrowDownLeft", library: "bs" },
	{
		icon: BsArrowDownRightCircleFill,
		name: "BsArrowDownRightCircleFill",
		library: "bs",
	},
	{ icon: BsArrowDownRightCircle, name: "BsArrowDownRightCircle", library: "bs" },
	{
		icon: BsArrowDownRightSquareFill,
		name: "BsArrowDownRightSquareFill",
		library: "bs",
	},
	{ icon: BsArrowDownRightSquare, name: "BsArrowDownRightSquare", library: "bs" },
	{ icon: BsArrowDownRight, name: "BsArrowDownRight", library: "bs" },
	{ icon: BsArrowDownShort, name: "BsArrowDownShort", library: "bs" },
	{ icon: BsArrowDownSquareFill, name: "BsArrowDownSquareFill", library: "bs" },
	{ icon: BsArrowDownSquare, name: "BsArrowDownSquare", library: "bs" },
	{ icon: BsArrowDownUp, name: "BsArrowDownUp", library: "bs" },
	{ icon: BsArrowDown, name: "BsArrowDown", library: "bs" },
	{ icon: BsArrowLeftCircleFill, name: "BsArrowLeftCircleFill", library: "bs" },
	{ icon: BsArrowLeftCircle, name: "BsArrowLeftCircle", library: "bs" },
	{ icon: BsArrowLeftRight, name: "BsArrowLeftRight", library: "bs" },
	{ icon: BsArrowLeftShort, name: "BsArrowLeftShort", library: "bs" },
	{ icon: BsArrowLeftSquareFill, name: "BsArrowLeftSquareFill", library: "bs" },
	{ icon: BsArrowLeftSquare, name: "BsArrowLeftSquare", library: "bs" },
	{ icon: BsArrowLeft, name: "BsArrowLeft", library: "bs" },
	{ icon: BsArrowRepeat, name: "BsArrowRepeat", library: "bs" },
	{ icon: BsArrowReturnLeft, name: "BsArrowReturnLeft", library: "bs" },
	{ icon: BsArrowReturnRight, name: "BsArrowReturnRight", library: "bs" },
	{ icon: BsArrowRightCircleFill, name: "BsArrowRightCircleFill", library: "bs" },
	{ icon: BsArrowRightCircle, name: "BsArrowRightCircle", library: "bs" },
	{ icon: BsArrowRightShort, name: "BsArrowRightShort", library: "bs" },
	{ icon: BsArrowRightSquareFill, name: "BsArrowRightSquareFill", library: "bs" },
	{ icon: BsArrowRightSquare, name: "BsArrowRightSquare", library: "bs" },
	{ icon: BsArrowRight, name: "BsArrowRight", library: "bs" },
	{ icon: BsArrowUpCircleFill, name: "BsArrowUpCircleFill", library: "bs" },
	{ icon: BsArrowUpCircle, name: "BsArrowUpCircle", library: "bs" },
	{ icon: BsArrowUpLeftCircleFill, name: "BsArrowUpLeftCircleFill", library: "bs" },
	{ icon: BsArrowUpLeftCircle, name: "BsArrowUpLeftCircle", library: "bs" },
	{ icon: BsArrowUpLeftSquareFill, name: "BsArrowUpLeftSquareFill", library: "bs" },
	{ icon: BsArrowUpLeftSquare, name: "BsArrowUpLeftSquare", library: "bs" },
	{ icon: BsArrowUpLeft, name: "BsArrowUpLeft", library: "bs" },
	{ icon: BsArrowUpRightCircleFill, name: "BsArrowUpRightCircleFill", library: "bs" },
	{ icon: BsArrowUpRightCircle, name: "BsArrowUpRightCircle", library: "bs" },
	{ icon: BsArrowUpRightSquareFill, name: "BsArrowUpRightSquareFill", library: "bs" },
	{ icon: BsArrowUpRightSquare, name: "BsArrowUpRightSquare", library: "bs" },
	{ icon: BsArrowUpRight, name: "BsArrowUpRight", library: "bs" },
	{ icon: BsArrowUpShort, name: "BsArrowUpShort", library: "bs" },
	{ icon: BsArrowUpSquareFill, name: "BsArrowUpSquareFill", library: "bs" },
	{ icon: BsArrowUpSquare, name: "BsArrowUpSquare", library: "bs" },
	{ icon: BsArrowUp, name: "BsArrowUp", library: "bs" },
	{ icon: BsArrowsAngleContract, name: "BsArrowsAngleContract", library: "bs" },
	{ icon: BsArrowsAngleExpand, name: "BsArrowsAngleExpand", library: "bs" },
	{ icon: BsArrowsCollapse, name: "BsArrowsCollapse", library: "bs" },
	{ icon: BsArrowsExpand, name: "BsArrowsExpand", library: "bs" },
	{ icon: BsArrowsFullscreen, name: "BsArrowsFullscreen", library: "bs" },
	{ icon: BsArrowsMove, name: "BsArrowsMove", library: "bs" },
	{ icon: BsAspectRatioFill, name: "BsAspectRatioFill", library: "bs" },
	{ icon: BsAspectRatio, name: "BsAspectRatio", library: "bs" },
	{ icon: BsAsterisk, name: "BsAsterisk", library: "bs" },
	{ icon: BsAt, name: "BsAt", library: "bs" },
	{ icon: BsAwardFill, name: "BsAwardFill", library: "bs" },
	{ icon: BsAward, name: "BsAward", library: "bs" },
	{ icon: BsBack, name: "BsBack", library: "bs" },
	{ icon: BsBackspaceFill, name: "BsBackspaceFill", library: "bs" },
	{ icon: BsBackspaceReverseFill, name: "BsBackspaceReverseFill", library: "bs" },
	{ icon: BsBackspaceReverse, name: "BsBackspaceReverse", library: "bs" },
	{ icon: BsBackspace, name: "BsBackspace", library: "bs" },
	{ icon: BsBadge3DFill, name: "BsBadge3DFill", library: "bs" },
	{ icon: BsBadge3D, name: "BsBadge3D", library: "bs" },
	{ icon: BsBadge4KFill, name: "BsBadge4KFill", library: "bs" },
	{ icon: BsBadge4K, name: "BsBadge4K", library: "bs" },
	{ icon: BsBadge8KFill, name: "BsBadge8KFill", library: "bs" },
	{ icon: BsBadge8K, name: "BsBadge8K", library: "bs" },
	{ icon: BsBadgeAdFill, name: "BsBadgeAdFill", library: "bs" },
	{ icon: BsBadgeAd, name: "BsBadgeAd", library: "bs" },
	{ icon: BsBadgeArFill, name: "BsBadgeArFill", library: "bs" },
	{ icon: BsBadgeAr, name: "BsBadgeAr", library: "bs" },
	{ icon: BsBadgeCcFill, name: "BsBadgeCcFill", library: "bs" },
	{ icon: BsBadgeCc, name: "BsBadgeCc", library: "bs" },
	{ icon: BsBadgeHdFill, name: "BsBadgeHdFill", library: "bs" },
	{ icon: BsBadgeHd, name: "BsBadgeHd", library: "bs" },
	{ icon: BsBadgeTmFill, name: "BsBadgeTmFill", library: "bs" },
	{ icon: BsBadgeTm, name: "BsBadgeTm", library: "bs" },
	{ icon: BsBadgeVoFill, name: "BsBadgeVoFill", library: "bs" },
	{ icon: BsBadgeVo, name: "BsBadgeVo", library: "bs" },
	{ icon: BsBadgeVrFill, name: "BsBadgeVrFill", library: "bs" },
	{ icon: BsBadgeVr, name: "BsBadgeVr", library: "bs" },
	{ icon: BsBadgeWcFill, name: "BsBadgeWcFill", library: "bs" },
	{ icon: BsBadgeWc, name: "BsBadgeWc", library: "bs" },
	{ icon: BsBagCheckFill, name: "BsBagCheckFill", library: "bs" },
	{ icon: BsBagCheck, name: "BsBagCheck", library: "bs" },
	{ icon: BsBagDashFill, name: "BsBagDashFill", library: "bs" },
	{ icon: BsBagDash, name: "BsBagDash", library: "bs" },
	{ icon: BsBagFill, name: "BsBagFill", library: "bs" },
	{ icon: BsBagPlusFill, name: "BsBagPlusFill", library: "bs" },
	{ icon: BsBagPlus, name: "BsBagPlus", library: "bs" },
	{ icon: BsBagXFill, name: "BsBagXFill", library: "bs" },
	{ icon: BsBagX, name: "BsBagX", library: "bs" },
	{ icon: BsBag, name: "BsBag", library: "bs" },
	{ icon: BsBank, name: "BsBank", library: "bs" },
	{ icon: BsBank2, name: "BsBank2", library: "bs" },
	{ icon: BsBarChartFill, name: "BsBarChartFill", library: "bs" },
	{ icon: BsBarChartLineFill, name: "BsBarChartLineFill", library: "bs" },
	{ icon: BsBarChartLine, name: "BsBarChartLine", library: "bs" },
	{ icon: BsBarChartSteps, name: "BsBarChartSteps", library: "bs" },
	{ icon: BsBarChart, name: "BsBarChart", library: "bs" },
	{ icon: BsBasketFill, name: "BsBasketFill", library: "bs" },
	{ icon: BsBasket, name: "BsBasket", library: "bs" },
	{ icon: BsBasket2Fill, name: "BsBasket2Fill", library: "bs" },
	{ icon: BsBasket2, name: "BsBasket2", library: "bs" },
	{ icon: BsBasket3Fill, name: "BsBasket3Fill", library: "bs" },
	{ icon: BsBasket3, name: "BsBasket3", library: "bs" },
	{ icon: BsBatteryCharging, name: "BsBatteryCharging", library: "bs" },
	{ icon: BsBatteryFull, name: "BsBatteryFull", library: "bs" },
	{ icon: BsBatteryHalf, name: "BsBatteryHalf", library: "bs" },
	{ icon: BsBattery, name: "BsBattery", library: "bs" },
	{ icon: BsBehance, name: "BsBehance", library: "bs" },
	{ icon: BsBellFill, name: "BsBellFill", library: "bs" },
	{ icon: BsBellSlashFill, name: "BsBellSlashFill", library: "bs" },
	{ icon: BsBellSlash, name: "BsBellSlash", library: "bs" },
	{ icon: BsBell, name: "BsBell", library: "bs" },
	{ icon: BsBezier, name: "BsBezier", library: "bs" },
	{ icon: BsBezier2, name: "BsBezier2", library: "bs" },
	{ icon: BsBicycle, name: "BsBicycle", library: "bs" },
	{ icon: BsBinocularsFill, name: "BsBinocularsFill", library: "bs" },
	{ icon: BsBinoculars, name: "BsBinoculars", library: "bs" },
	{ icon: BsBlockquoteLeft, name: "BsBlockquoteLeft", library: "bs" },
	{ icon: BsBlockquoteRight, name: "BsBlockquoteRight", library: "bs" },
	{ icon: BsBookFill, name: "BsBookFill", library: "bs" },
	{ icon: BsBookHalf, name: "BsBookHalf", library: "bs" },
	{ icon: BsBook, name: "BsBook", library: "bs" },
	{ icon: BsBookmarkCheckFill, name: "BsBookmarkCheckFill", library: "bs" },
	{ icon: BsBookmarkCheck, name: "BsBookmarkCheck", library: "bs" },
	{ icon: BsBookmarkDashFill, name: "BsBookmarkDashFill", library: "bs" },
	{ icon: BsBookmarkDash, name: "BsBookmarkDash", library: "bs" },
	{ icon: BsBookmarkFill, name: "BsBookmarkFill", library: "bs" },
	{ icon: BsBookmarkHeartFill, name: "BsBookmarkHeartFill", library: "bs" },
	{ icon: BsBookmarkHeart, name: "BsBookmarkHeart", library: "bs" },
	{ icon: BsBookmarkPlusFill, name: "BsBookmarkPlusFill", library: "bs" },
	{ icon: BsBookmarkPlus, name: "BsBookmarkPlus", library: "bs" },
	{ icon: BsBookmarkStarFill, name: "BsBookmarkStarFill", library: "bs" },
	{ icon: BsBookmarkStar, name: "BsBookmarkStar", library: "bs" },
	{ icon: BsBookmarkXFill, name: "BsBookmarkXFill", library: "bs" },
	{ icon: BsBookmarkX, name: "BsBookmarkX", library: "bs" },
	{ icon: BsBookmark, name: "BsBookmark", library: "bs" },
	{ icon: BsBookmarksFill, name: "BsBookmarksFill", library: "bs" },
	{ icon: BsBookmarks, name: "BsBookmarks", library: "bs" },
	{ icon: BsBookshelf, name: "BsBookshelf", library: "bs" },
	{ icon: BsBootstrapFill, name: "BsBootstrapFill", library: "bs" },
	{ icon: BsBootstrapReboot, name: "BsBootstrapReboot", library: "bs" },
	{ icon: BsBootstrap, name: "BsBootstrap", library: "bs" },
	{ icon: BsBorderAll, name: "BsBorderAll", library: "bs" },
	{ icon: BsBorderBottom, name: "BsBorderBottom", library: "bs" },
	{ icon: BsBorderCenter, name: "BsBorderCenter", library: "bs" },
	{ icon: BsBorderInner, name: "BsBorderInner", library: "bs" },
	{ icon: BsBorderLeft, name: "BsBorderLeft", library: "bs" },
	{ icon: BsBorderMiddle, name: "BsBorderMiddle", library: "bs" },
	{ icon: BsBorderOuter, name: "BsBorderOuter", library: "bs" },
	{ icon: BsBorderRight, name: "BsBorderRight", library: "bs" },
	{ icon: BsBorderStyle, name: "BsBorderStyle", library: "bs" },
	{ icon: BsBorderTop, name: "BsBorderTop", library: "bs" },
	{ icon: BsBorderWidth, name: "BsBorderWidth", library: "bs" },
	{ icon: BsBorder, name: "BsBorder", library: "bs" },
	{ icon: BsBoundingBoxCircles, name: "BsBoundingBoxCircles", library: "bs" },
	{ icon: BsBoundingBox, name: "BsBoundingBox", library: "bs" },
	{ icon: BsBoxArrowDownLeft, name: "BsBoxArrowDownLeft", library: "bs" },
	{ icon: BsBoxArrowDownRight, name: "BsBoxArrowDownRight", library: "bs" },
	{ icon: BsBoxArrowDown, name: "BsBoxArrowDown", library: "bs" },
	{ icon: BsBoxArrowInDownLeft, name: "BsBoxArrowInDownLeft", library: "bs" },
	{ icon: BsBoxArrowInDownRight, name: "BsBoxArrowInDownRight", library: "bs" },
	{ icon: BsBoxArrowInDown, name: "BsBoxArrowInDown", library: "bs" },
	{ icon: BsBoxArrowInLeft, name: "BsBoxArrowInLeft", library: "bs" },
	{ icon: BsBoxArrowInRight, name: "BsBoxArrowInRight", library: "bs" },
	{ icon: BsBoxArrowInUpLeft, name: "BsBoxArrowInUpLeft", library: "bs" },
	{ icon: BsBoxArrowInUpRight, name: "BsBoxArrowInUpRight", library: "bs" },
	{ icon: BsBoxArrowInUp, name: "BsBoxArrowInUp", library: "bs" },
	{ icon: BsBoxArrowLeft, name: "BsBoxArrowLeft", library: "bs" },
	{ icon: BsBoxArrowRight, name: "BsBoxArrowRight", library: "bs" },
	{ icon: BsBoxArrowUpLeft, name: "BsBoxArrowUpLeft", library: "bs" },
	{ icon: BsBoxArrowUpRight, name: "BsBoxArrowUpRight", library: "bs" },
	{ icon: BsBoxArrowUp, name: "BsBoxArrowUp", library: "bs" },
	{ icon: BsBoxSeam, name: "BsBoxSeam", library: "bs" },
	{ icon: BsBox, name: "BsBox", library: "bs" },
	{ icon: BsBraces, name: "BsBraces", library: "bs" },
	{ icon: BsBricks, name: "BsBricks", library: "bs" },
	{ icon: BsBriefcaseFill, name: "BsBriefcaseFill", library: "bs" },
	{ icon: BsBriefcase, name: "BsBriefcase", library: "bs" },
	{ icon: BsBrightnessAltHighFill, name: "BsBrightnessAltHighFill", library: "bs" },
	{ icon: BsBrightnessAltHigh, name: "BsBrightnessAltHigh", library: "bs" },
	{ icon: BsBrightnessAltLowFill, name: "BsBrightnessAltLowFill", library: "bs" },
	{ icon: BsBrightnessAltLow, name: "BsBrightnessAltLow", library: "bs" },
	{ icon: BsBrightnessHighFill, name: "BsBrightnessHighFill", library: "bs" },
	{ icon: BsBrightnessHigh, name: "BsBrightnessHigh", library: "bs" },
	{ icon: BsBrightnessLowFill, name: "BsBrightnessLowFill", library: "bs" },
	{ icon: BsBrightnessLow, name: "BsBrightnessLow", library: "bs" },
	{ icon: BsBroadcastPin, name: "BsBroadcastPin", library: "bs" },
	{ icon: BsBroadcast, name: "BsBroadcast", library: "bs" },
	{ icon: BsBrushFill, name: "BsBrushFill", library: "bs" },
	{ icon: BsBrush, name: "BsBrush", library: "bs" },
	{ icon: BsBucketFill, name: "BsBucketFill", library: "bs" },
	{ icon: BsBucket, name: "BsBucket", library: "bs" },
	{ icon: BsBugFill, name: "BsBugFill", library: "bs" },
	{ icon: BsBug, name: "BsBug", library: "bs" },
	{ icon: BsBuilding, name: "BsBuilding", library: "bs" },
	{ icon: BsBullseye, name: "BsBullseye", library: "bs" },
	{ icon: BsCalculatorFill, name: "BsCalculatorFill", library: "bs" },
	{ icon: BsCalculator, name: "BsCalculator", library: "bs" },
	{ icon: BsCalendarCheckFill, name: "BsCalendarCheckFill", library: "bs" },
	{ icon: BsCalendarCheck, name: "BsCalendarCheck", library: "bs" },
	{ icon: BsCalendarDateFill, name: "BsCalendarDateFill", library: "bs" },
	{ icon: BsCalendarDate, name: "BsCalendarDate", library: "bs" },
	{ icon: BsCalendarDayFill, name: "BsCalendarDayFill", library: "bs" },
	{ icon: BsCalendarDay, name: "BsCalendarDay", library: "bs" },
	{ icon: BsCalendarEventFill, name: "BsCalendarEventFill", library: "bs" },
	{ icon: BsCalendarEvent, name: "BsCalendarEvent", library: "bs" },
	{ icon: BsCalendarFill, name: "BsCalendarFill", library: "bs" },
	{ icon: BsCalendarMinusFill, name: "BsCalendarMinusFill", library: "bs" },
	{ icon: BsCalendarMinus, name: "BsCalendarMinus", library: "bs" },
	{ icon: BsCalendarMonthFill, name: "BsCalendarMonthFill", library: "bs" },
	{ icon: BsCalendarMonth, name: "BsCalendarMonth", library: "bs" },
	{ icon: BsCalendarPlusFill, name: "BsCalendarPlusFill", library: "bs" },
	{ icon: BsCalendarPlus, name: "BsCalendarPlus", library: "bs" },
	{ icon: BsCalendarRangeFill, name: "BsCalendarRangeFill", library: "bs" },
	{ icon: BsCalendarRange, name: "BsCalendarRange", library: "bs" },
	{ icon: BsCalendarWeekFill, name: "BsCalendarWeekFill", library: "bs" },
	{ icon: BsCalendarWeek, name: "BsCalendarWeek", library: "bs" },
	{ icon: BsCalendarXFill, name: "BsCalendarXFill", library: "bs" },
	{ icon: BsCalendarX, name: "BsCalendarX", library: "bs" },
	{ icon: BsCalendar, name: "BsCalendar", library: "bs" },
	{ icon: BsCalendar2CheckFill, name: "BsCalendar2CheckFill", library: "bs" },
	{ icon: BsCalendar2Check, name: "BsCalendar2Check", library: "bs" },
	{ icon: BsCalendar2DateFill, name: "BsCalendar2DateFill", library: "bs" },
	{ icon: BsCalendar2Date, name: "BsCalendar2Date", library: "bs" },
	{ icon: BsCalendar2DayFill, name: "BsCalendar2DayFill", library: "bs" },
	{ icon: BsCalendar2Day, name: "BsCalendar2Day", library: "bs" },
	{ icon: BsCalendar2EventFill, name: "BsCalendar2EventFill", library: "bs" },
	{ icon: BsCalendar2Event, name: "BsCalendar2Event", library: "bs" },
	{ icon: BsCalendar2Fill, name: "BsCalendar2Fill", library: "bs" },
	{ icon: BsCalendar2MinusFill, name: "BsCalendar2MinusFill", library: "bs" },
	{ icon: BsCalendar2Minus, name: "BsCalendar2Minus", library: "bs" },
	{ icon: BsCalendar2MonthFill, name: "BsCalendar2MonthFill", library: "bs" },
	{ icon: BsCalendar2Month, name: "BsCalendar2Month", library: "bs" },
	{ icon: BsCalendar2PlusFill, name: "BsCalendar2PlusFill", library: "bs" },
	{ icon: BsCalendar2Plus, name: "BsCalendar2Plus", library: "bs" },
	{ icon: BsCalendar2RangeFill, name: "BsCalendar2RangeFill", library: "bs" },
	{ icon: BsCalendar2Range, name: "BsCalendar2Range", library: "bs" },
	{ icon: BsCalendar2WeekFill, name: "BsCalendar2WeekFill", library: "bs" },
	{ icon: BsCalendar2Week, name: "BsCalendar2Week", library: "bs" },
	{ icon: BsCalendar2XFill, name: "BsCalendar2XFill", library: "bs" },
	{ icon: BsCalendar2X, name: "BsCalendar2X", library: "bs" },
	{ icon: BsCalendar2, name: "BsCalendar2", library: "bs" },
	{ icon: BsCalendar3EventFill, name: "BsCalendar3EventFill", library: "bs" },
	{ icon: BsCalendar3Event, name: "BsCalendar3Event", library: "bs" },
	{ icon: BsCalendar3Fill, name: "BsCalendar3Fill", library: "bs" },
	{ icon: BsCalendar3RangeFill, name: "BsCalendar3RangeFill", library: "bs" },
	{ icon: BsCalendar3Range, name: "BsCalendar3Range", library: "bs" },
	{ icon: BsCalendar3WeekFill, name: "BsCalendar3WeekFill", library: "bs" },
	{ icon: BsCalendar3Week, name: "BsCalendar3Week", library: "bs" },
	{ icon: BsCalendar3, name: "BsCalendar3", library: "bs" },
	{ icon: BsCalendar4Event, name: "BsCalendar4Event", library: "bs" },
	{ icon: BsCalendar4Range, name: "BsCalendar4Range", library: "bs" },
	{ icon: BsCalendar4Week, name: "BsCalendar4Week", library: "bs" },
	{ icon: BsCalendar4, name: "BsCalendar4", library: "bs" },
	{ icon: BsCameraFill, name: "BsCameraFill", library: "bs" },
	{ icon: BsCameraReelsFill, name: "BsCameraReelsFill", library: "bs" },
	{ icon: BsCameraReels, name: "BsCameraReels", library: "bs" },
	{ icon: BsCameraVideoFill, name: "BsCameraVideoFill", library: "bs" },
	{ icon: BsCameraVideoOffFill, name: "BsCameraVideoOffFill", library: "bs" },
	{ icon: BsCameraVideoOff, name: "BsCameraVideoOff", library: "bs" },
	{ icon: BsCameraVideo, name: "BsCameraVideo", library: "bs" },
	{ icon: BsCamera, name: "BsCamera", library: "bs" },
	{ icon: BsCamera2, name: "BsCamera2", library: "bs" },
	{ icon: BsCapslockFill, name: "BsCapslockFill", library: "bs" },
	{ icon: BsCapslock, name: "BsCapslock", library: "bs" },
	{ icon: BsCardChecklist, name: "BsCardChecklist", library: "bs" },
	{ icon: BsCardHeading, name: "BsCardHeading", library: "bs" },
	{ icon: BsCardImage, name: "BsCardImage", library: "bs" },
	{ icon: BsCardList, name: "BsCardList", library: "bs" },
	{ icon: BsCardText, name: "BsCardText", library: "bs" },
	{ icon: BsCaretDownFill, name: "BsCaretDownFill", library: "bs" },
	{ icon: BsCaretDownSquareFill, name: "BsCaretDownSquareFill", library: "bs" },
	{ icon: BsCaretDownSquare, name: "BsCaretDownSquare", library: "bs" },
	{ icon: BsCaretDown, name: "BsCaretDown", library: "bs" },
	{ icon: BsCaretLeftFill, name: "BsCaretLeftFill", library: "bs" },
	{ icon: BsCaretLeftSquareFill, name: "BsCaretLeftSquareFill", library: "bs" },
	{ icon: BsCaretLeftSquare, name: "BsCaretLeftSquare", library: "bs" },
	{ icon: BsCaretLeft, name: "BsCaretLeft", library: "bs" },
	{ icon: BsCaretRightFill, name: "BsCaretRightFill", library: "bs" },
	{ icon: BsCaretRightSquareFill, name: "BsCaretRightSquareFill", library: "bs" },
	{ icon: BsCaretRightSquare, name: "BsCaretRightSquare", library: "bs" },
	{ icon: BsCaretRight, name: "BsCaretRight", library: "bs" },
	{ icon: BsCaretUpFill, name: "BsCaretUpFill", library: "bs" },
	{ icon: BsCaretUpSquareFill, name: "BsCaretUpSquareFill", library: "bs" },
	{ icon: BsCaretUpSquare, name: "BsCaretUpSquare", library: "bs" },
	{ icon: BsCaretUp, name: "BsCaretUp", library: "bs" },
	{ icon: BsCartCheckFill, name: "BsCartCheckFill", library: "bs" },
	{ icon: BsCartCheck, name: "BsCartCheck", library: "bs" },
	{ icon: BsCartDashFill, name: "BsCartDashFill", library: "bs" },
	{ icon: BsCartDash, name: "BsCartDash", library: "bs" },
	{ icon: BsCartFill, name: "BsCartFill", library: "bs" },
	{ icon: BsCartPlusFill, name: "BsCartPlusFill", library: "bs" },
	{ icon: BsCartPlus, name: "BsCartPlus", library: "bs" },
	{ icon: BsCartXFill, name: "BsCartXFill", library: "bs" },
	{ icon: BsCartX, name: "BsCartX", library: "bs" },
	{ icon: BsCart, name: "BsCart", library: "bs" },
	{ icon: BsCart2, name: "BsCart2", library: "bs" },
	{ icon: BsCart3, name: "BsCart3", library: "bs" },
	{ icon: BsCart4, name: "BsCart4", library: "bs" },
	{ icon: BsCashCoin, name: "BsCashCoin", library: "bs" },
	{ icon: BsCashStack, name: "BsCashStack", library: "bs" },
	{ icon: BsCash, name: "BsCash", library: "bs" },
	{ icon: BsCast, name: "BsCast", library: "bs" },
	{ icon: BsChatDotsFill, name: "BsChatDotsFill", library: "bs" },
	{ icon: BsChatDots, name: "BsChatDots", library: "bs" },
	{ icon: BsChatFill, name: "BsChatFill", library: "bs" },
	{ icon: BsChatLeftDotsFill, name: "BsChatLeftDotsFill", library: "bs" },
	{ icon: BsChatLeftDots, name: "BsChatLeftDots", library: "bs" },
	{ icon: BsChatLeftFill, name: "BsChatLeftFill", library: "bs" },
	{ icon: BsChatLeftQuoteFill, name: "BsChatLeftQuoteFill", library: "bs" },
	{ icon: BsChatLeftQuote, name: "BsChatLeftQuote", library: "bs" },
	{ icon: BsChatLeftTextFill, name: "BsChatLeftTextFill", library: "bs" },
	{ icon: BsChatLeftText, name: "BsChatLeftText", library: "bs" },
	{ icon: BsChatLeft, name: "BsChatLeft", library: "bs" },
	{ icon: BsChatQuoteFill, name: "BsChatQuoteFill", library: "bs" },
	{ icon: BsChatQuote, name: "BsChatQuote", library: "bs" },
	{ icon: BsChatRightDotsFill, name: "BsChatRightDotsFill", library: "bs" },
	{ icon: BsChatRightDots, name: "BsChatRightDots", library: "bs" },
	{ icon: BsChatRightFill, name: "BsChatRightFill", library: "bs" },
	{ icon: BsChatRightQuoteFill, name: "BsChatRightQuoteFill", library: "bs" },
	{ icon: BsChatRightQuote, name: "BsChatRightQuote", library: "bs" },
	{ icon: BsChatRightTextFill, name: "BsChatRightTextFill", library: "bs" },
	{ icon: BsChatRightText, name: "BsChatRightText", library: "bs" },
	{ icon: BsChatRight, name: "BsChatRight", library: "bs" },
	{ icon: BsChatSquareDotsFill, name: "BsChatSquareDotsFill", library: "bs" },
	{ icon: BsChatSquareDots, name: "BsChatSquareDots", library: "bs" },
	{ icon: BsChatSquareFill, name: "BsChatSquareFill", library: "bs" },
	{ icon: BsChatSquareQuoteFill, name: "BsChatSquareQuoteFill", library: "bs" },
	{ icon: BsChatSquareQuote, name: "BsChatSquareQuote", library: "bs" },
	{ icon: BsChatSquareTextFill, name: "BsChatSquareTextFill", library: "bs" },
	{ icon: BsChatSquareText, name: "BsChatSquareText", library: "bs" },
	{ icon: BsChatSquare, name: "BsChatSquare", library: "bs" },
	{ icon: BsChatTextFill, name: "BsChatTextFill", library: "bs" },
	{ icon: BsChatText, name: "BsChatText", library: "bs" },
	{ icon: BsChat, name: "BsChat", library: "bs" },
	{ icon: BsCheckAll, name: "BsCheckAll", library: "bs" },
	{ icon: BsCheckCircleFill, name: "BsCheckCircleFill", library: "bs" },
	{ icon: BsCheckCircle, name: "BsCheckCircle", library: "bs" },
	{ icon: BsCheckLg, name: "BsCheckLg", library: "bs" },
	{ icon: BsCheckSquareFill, name: "BsCheckSquareFill", library: "bs" },
	{ icon: BsCheckSquare, name: "BsCheckSquare", library: "bs" },
	{ icon: BsCheck, name: "BsCheck", library: "bs" },
	{ icon: BsCheck2All, name: "BsCheck2All", library: "bs" },
	{ icon: BsCheck2Circle, name: "BsCheck2Circle", library: "bs" },
	{ icon: BsCheck2Square, name: "BsCheck2Square", library: "bs" },
	{ icon: BsCheck2, name: "BsCheck2", library: "bs" },
	{ icon: BsChevronBarContract, name: "BsChevronBarContract", library: "bs" },
	{ icon: BsChevronBarDown, name: "BsChevronBarDown", library: "bs" },
	{ icon: BsChevronBarExpand, name: "BsChevronBarExpand", library: "bs" },
	{ icon: BsChevronBarLeft, name: "BsChevronBarLeft", library: "bs" },
	{ icon: BsChevronBarRight, name: "BsChevronBarRight", library: "bs" },
	{ icon: BsChevronBarUp, name: "BsChevronBarUp", library: "bs" },
	{ icon: BsChevronCompactDown, name: "BsChevronCompactDown", library: "bs" },
	{ icon: BsChevronCompactLeft, name: "BsChevronCompactLeft", library: "bs" },
	{ icon: BsChevronCompactRight, name: "BsChevronCompactRight", library: "bs" },
	{ icon: BsChevronCompactUp, name: "BsChevronCompactUp", library: "bs" },
	{ icon: BsChevronContract, name: "BsChevronContract", library: "bs" },
	{ icon: BsChevronDoubleDown, name: "BsChevronDoubleDown", library: "bs" },
	{ icon: BsChevronDoubleLeft, name: "BsChevronDoubleLeft", library: "bs" },
	{ icon: BsChevronDoubleRight, name: "BsChevronDoubleRight", library: "bs" },
	{ icon: BsChevronDoubleUp, name: "BsChevronDoubleUp", library: "bs" },
	{ icon: BsChevronDown, name: "BsChevronDown", library: "bs" },
	{ icon: BsChevronExpand, name: "BsChevronExpand", library: "bs" },
	{ icon: BsChevronLeft, name: "BsChevronLeft", library: "bs" },
	{ icon: BsChevronRight, name: "BsChevronRight", library: "bs" },
	{ icon: BsChevronUp, name: "BsChevronUp", library: "bs" },
	{ icon: BsCircleFill, name: "BsCircleFill", library: "bs" },
	{ icon: BsCircleHalf, name: "BsCircleHalf", library: "bs" },
	{ icon: BsCircleSquare, name: "BsCircleSquare", library: "bs" },
	{ icon: BsCircle, name: "BsCircle", library: "bs" },
	{ icon: BsClipboardCheck, name: "BsClipboardCheck", library: "bs" },
	{ icon: BsClipboardData, name: "BsClipboardData", library: "bs" },
	{ icon: BsClipboardMinus, name: "BsClipboardMinus", library: "bs" },
	{ icon: BsClipboardPlus, name: "BsClipboardPlus", library: "bs" },
	{ icon: BsClipboardX, name: "BsClipboardX", library: "bs" },
	{ icon: BsClipboard, name: "BsClipboard", library: "bs" },
	{ icon: BsClockFill, name: "BsClockFill", library: "bs" },
	{ icon: BsClockHistory, name: "BsClockHistory", library: "bs" },
	{ icon: BsClock, name: "BsClock", library: "bs" },
	{ icon: BsCloudArrowDownFill, name: "BsCloudArrowDownFill", library: "bs" },
	{ icon: BsCloudArrowDown, name: "BsCloudArrowDown", library: "bs" },
	{ icon: BsCloudArrowUpFill, name: "BsCloudArrowUpFill", library: "bs" },
	{ icon: BsCloudArrowUp, name: "BsCloudArrowUp", library: "bs" },
	{ icon: BsCloudCheckFill, name: "BsCloudCheckFill", library: "bs" },
	{ icon: BsCloudCheck, name: "BsCloudCheck", library: "bs" },
	{ icon: BsCloudDownloadFill, name: "BsCloudDownloadFill", library: "bs" },
	{ icon: BsCloudDownload, name: "BsCloudDownload", library: "bs" },
	{ icon: BsCloudDrizzleFill, name: "BsCloudDrizzleFill", library: "bs" },
	{ icon: BsCloudDrizzle, name: "BsCloudDrizzle", library: "bs" },
	{ icon: BsCloudFill, name: "BsCloudFill", library: "bs" },
	{ icon: BsCloudFogFill, name: "BsCloudFogFill", library: "bs" },
	{ icon: BsCloudFog, name: "BsCloudFog", library: "bs" },
	{ icon: BsCloudFog2Fill, name: "BsCloudFog2Fill", library: "bs" },
	{ icon: BsCloudFog2, name: "BsCloudFog2", library: "bs" },
	{ icon: BsCloudHailFill, name: "BsCloudHailFill", library: "bs" },
	{ icon: BsCloudHail, name: "BsCloudHail", library: "bs" },
	{ icon: BsCloudHaze1, name: "BsCloudHaze1", library: "bs" },
	{ icon: BsCloudHazeFill, name: "BsCloudHazeFill", library: "bs" },
	{ icon: BsCloudHaze, name: "BsCloudHaze", library: "bs" },
	{ icon: BsCloudHaze2Fill, name: "BsCloudHaze2Fill", library: "bs" },
	{ icon: BsCloudLightningFill, name: "BsCloudLightningFill", library: "bs" },
	{ icon: BsCloudLightningRainFill, name: "BsCloudLightningRainFill", library: "bs" },
	{ icon: BsCloudLightningRain, name: "BsCloudLightningRain", library: "bs" },
	{ icon: BsCloudLightning, name: "BsCloudLightning", library: "bs" },
	{ icon: BsCloudMinusFill, name: "BsCloudMinusFill", library: "bs" },
	{ icon: BsCloudMinus, name: "BsCloudMinus", library: "bs" },
	{ icon: BsCloudMoonFill, name: "BsCloudMoonFill", library: "bs" },
	{ icon: BsCloudMoon, name: "BsCloudMoon", library: "bs" },
	{ icon: BsCloudPlusFill, name: "BsCloudPlusFill", library: "bs" },
	{ icon: BsCloudPlus, name: "BsCloudPlus", library: "bs" },
	{ icon: BsCloudRainFill, name: "BsCloudRainFill", library: "bs" },
	{ icon: BsCloudRainHeavyFill, name: "BsCloudRainHeavyFill", library: "bs" },
	{ icon: BsCloudRainHeavy, name: "BsCloudRainHeavy", library: "bs" },
	{ icon: BsCloudRain, name: "BsCloudRain", library: "bs" },
	{ icon: BsCloudSlashFill, name: "BsCloudSlashFill", library: "bs" },
	{ icon: BsCloudSlash, name: "BsCloudSlash", library: "bs" },
	{ icon: BsCloudSleetFill, name: "BsCloudSleetFill", library: "bs" },
	{ icon: BsCloudSleet, name: "BsCloudSleet", library: "bs" },
	{ icon: BsCloudSnowFill, name: "BsCloudSnowFill", library: "bs" },
	{ icon: BsCloudSnow, name: "BsCloudSnow", library: "bs" },
	{ icon: BsCloudSunFill, name: "BsCloudSunFill", library: "bs" },
	{ icon: BsCloudSun, name: "BsCloudSun", library: "bs" },
	{ icon: BsCloudUploadFill, name: "BsCloudUploadFill", library: "bs" },
	{ icon: BsCloudUpload, name: "BsCloudUpload", library: "bs" },
	{ icon: BsCloud, name: "BsCloud", library: "bs" },
	{ icon: BsCloudsFill, name: "BsCloudsFill", library: "bs" },
	{ icon: BsClouds, name: "BsClouds", library: "bs" },
	{ icon: BsCloudyFill, name: "BsCloudyFill", library: "bs" },
	{ icon: BsCloudy, name: "BsCloudy", library: "bs" },
	{ icon: BsCodeSlash, name: "BsCodeSlash", library: "bs" },
	{ icon: BsCodeSquare, name: "BsCodeSquare", library: "bs" },
	{ icon: BsCode, name: "BsCode", library: "bs" },
	{ icon: BsCoin, name: "BsCoin", library: "bs" },
	{ icon: BsCollectionFill, name: "BsCollectionFill", library: "bs" },
	{ icon: BsCollectionPlayFill, name: "BsCollectionPlayFill", library: "bs" },
	{ icon: BsCollectionPlay, name: "BsCollectionPlay", library: "bs" },
	{ icon: BsCollection, name: "BsCollection", library: "bs" },
	{ icon: BsColumnsGap, name: "BsColumnsGap", library: "bs" },
	{ icon: BsColumns, name: "BsColumns", library: "bs" },
	{ icon: BsCommand, name: "BsCommand", library: "bs" },
	{ icon: BsCompassFill, name: "BsCompassFill", library: "bs" },
	{ icon: BsCompass, name: "BsCompass", library: "bs" },
	{ icon: BsConeStriped, name: "BsConeStriped", library: "bs" },
	{ icon: BsCone, name: "BsCone", library: "bs" },
	{ icon: BsController, name: "BsController", library: "bs" },
	{ icon: BsCpuFill, name: "BsCpuFill", library: "bs" },
	{ icon: BsCpu, name: "BsCpu", library: "bs" },
	{ icon: BsCreditCard2BackFill, name: "BsCreditCard2BackFill", library: "bs" },
	{ icon: BsCreditCard2Back, name: "BsCreditCard2Back", library: "bs" },
	{ icon: BsCreditCard2FrontFill, name: "BsCreditCard2FrontFill", library: "bs" },
	{ icon: BsCreditCard2Front, name: "BsCreditCard2Front", library: "bs" },
	{ icon: BsCreditCardFill, name: "BsCreditCardFill", library: "bs" },
	{ icon: BsCreditCard, name: "BsCreditCard", library: "bs" },
	{ icon: BsCrop, name: "BsCrop", library: "bs" },
	{ icon: BsCupFill, name: "BsCupFill", library: "bs" },
	{ icon: BsCupStraw, name: "BsCupStraw", library: "bs" },
	{ icon: BsCup, name: "BsCup", library: "bs" },
	{ icon: BsCurrencyBitcoin, name: "BsCurrencyBitcoin", library: "bs" },
	{ icon: BsCurrencyDollar, name: "BsCurrencyDollar", library: "bs" },
	{ icon: BsCurrencyEuro, name: "BsCurrencyEuro", library: "bs" },
	{ icon: BsCurrencyExchange, name: "BsCurrencyExchange", library: "bs" },
	{ icon: BsCurrencyPound, name: "BsCurrencyPound", library: "bs" },
	{ icon: BsCurrencyYen, name: "BsCurrencyYen", library: "bs" },
	{ icon: BsCursorFill, name: "BsCursorFill", library: "bs" },
	{ icon: BsCursorText, name: "BsCursorText", library: "bs" },
	{ icon: BsCursor, name: "BsCursor", library: "bs" },
	{ icon: BsDashCircleDotted, name: "BsDashCircleDotted", library: "bs" },
	{ icon: BsDashCircleFill, name: "BsDashCircleFill", library: "bs" },
	{ icon: BsDashCircle, name: "BsDashCircle", library: "bs" },
	{ icon: BsDashLg, name: "BsDashLg", library: "bs" },
	{ icon: BsDashSquareDotted, name: "BsDashSquareDotted", library: "bs" },
	{ icon: BsDashSquareFill, name: "BsDashSquareFill", library: "bs" },
	{ icon: BsDashSquare, name: "BsDashSquare", library: "bs" },
	{ icon: BsDash, name: "BsDash", library: "bs" },
	{ icon: BsDiagram2Fill, name: "BsDiagram2Fill", library: "bs" },
	{ icon: BsDiagram2, name: "BsDiagram2", library: "bs" },
	{ icon: BsDiagram3Fill, name: "BsDiagram3Fill", library: "bs" },
	{ icon: BsDiagram3, name: "BsDiagram3", library: "bs" },
	{ icon: BsDiamondFill, name: "BsDiamondFill", library: "bs" },
	{ icon: BsDiamondHalf, name: "BsDiamondHalf", library: "bs" },
	{ icon: BsDiamond, name: "BsDiamond", library: "bs" },
	{ icon: BsDice1Fill, name: "BsDice1Fill", library: "bs" },
	{ icon: BsDice1, name: "BsDice1", library: "bs" },
	{ icon: BsDice2Fill, name: "BsDice2Fill", library: "bs" },
	{ icon: BsDice2, name: "BsDice2", library: "bs" },
	{ icon: BsDice3Fill, name: "BsDice3Fill", library: "bs" },
	{ icon: BsDice3, name: "BsDice3", library: "bs" },
	{ icon: BsDice4Fill, name: "BsDice4Fill", library: "bs" },
	{ icon: BsDice4, name: "BsDice4", library: "bs" },
	{ icon: BsDice5Fill, name: "BsDice5Fill", library: "bs" },
	{ icon: BsDice5, name: "BsDice5", library: "bs" },
	{ icon: BsDice6Fill, name: "BsDice6Fill", library: "bs" },
	{ icon: BsDice6, name: "BsDice6", library: "bs" },
	{ icon: BsDiscFill, name: "BsDiscFill", library: "bs" },
	{ icon: BsDisc, name: "BsDisc", library: "bs" },
	{ icon: BsDiscord, name: "BsDiscord", library: "bs" },
	{ icon: BsDisplayFill, name: "BsDisplayFill", library: "bs" },
	{ icon: BsDisplay, name: "BsDisplay", library: "bs" },
	{ icon: BsDistributeHorizontal, name: "BsDistributeHorizontal", library: "bs" },
	{ icon: BsDistributeVertical, name: "BsDistributeVertical", library: "bs" },
	{ icon: BsDoorClosedFill, name: "BsDoorClosedFill", library: "bs" },
	{ icon: BsDoorClosed, name: "BsDoorClosed", library: "bs" },
	{ icon: BsDoorOpenFill, name: "BsDoorOpenFill", library: "bs" },
	{ icon: BsDoorOpen, name: "BsDoorOpen", library: "bs" },
	{ icon: BsDot, name: "BsDot", library: "bs" },
	{ icon: BsDownload, name: "BsDownload", library: "bs" },
	{ icon: BsDribbble, name: "BsDribbble", library: "bs" },
	{ icon: BsDropletFill, name: "BsDropletFill", library: "bs" },
	{ icon: BsDropletHalf, name: "BsDropletHalf", library: "bs" },
	{ icon: BsDroplet, name: "BsDroplet", library: "bs" },
	{ icon: BsEarbuds, name: "BsEarbuds", library: "bs" },
	{ icon: BsEaselFill, name: "BsEaselFill", library: "bs" },
	{ icon: BsEasel, name: "BsEasel", library: "bs" },
	{ icon: BsEggFill, name: "BsEggFill", library: "bs" },
	{ icon: BsEggFried, name: "BsEggFried", library: "bs" },
	{ icon: BsEgg, name: "BsEgg", library: "bs" },
	{ icon: BsEjectFill, name: "BsEjectFill", library: "bs" },
	{ icon: BsEject, name: "BsEject", library: "bs" },
	{ icon: BsEmojiAngryFill, name: "BsEmojiAngryFill", library: "bs" },
	{ icon: BsEmojiAngry, name: "BsEmojiAngry", library: "bs" },
	{ icon: BsEmojiDizzyFill, name: "BsEmojiDizzyFill", library: "bs" },
	{ icon: BsEmojiDizzy, name: "BsEmojiDizzy", library: "bs" },
	{ icon: BsEmojiExpressionlessFill, name: "BsEmojiExpressionlessFill", library: "bs" },
	{ icon: BsEmojiExpressionless, name: "BsEmojiExpressionless", library: "bs" },
	{ icon: BsEmojiFrownFill, name: "BsEmojiFrownFill", library: "bs" },
	{ icon: BsEmojiFrown, name: "BsEmojiFrown", library: "bs" },
	{ icon: BsEmojiHeartEyesFill, name: "BsEmojiHeartEyesFill", library: "bs" },
	{ icon: BsEmojiHeartEyes, name: "BsEmojiHeartEyes", library: "bs" },
	{ icon: BsEmojiLaughingFill, name: "BsEmojiLaughingFill", library: "bs" },
	{ icon: BsEmojiLaughing, name: "BsEmojiLaughing", library: "bs" },
	{ icon: BsEmojiNeutralFill, name: "BsEmojiNeutralFill", library: "bs" },
	{ icon: BsEmojiNeutral, name: "BsEmojiNeutral", library: "bs" },
	{ icon: BsEmojiSmileFill, name: "BsEmojiSmileFill", library: "bs" },
	{
		icon: BsEmojiSmileUpsideDownFill,
		name: "BsEmojiSmileUpsideDownFill",
		library: "bs",
	},
	{ icon: BsEmojiSmileUpsideDown, name: "BsEmojiSmileUpsideDown", library: "bs" },
	{ icon: BsEmojiSmile, name: "BsEmojiSmile", library: "bs" },
	{ icon: BsEmojiSunglassesFill, name: "BsEmojiSunglassesFill", library: "bs" },
	{ icon: BsEmojiSunglasses, name: "BsEmojiSunglasses", library: "bs" },
	{ icon: BsEmojiWinkFill, name: "BsEmojiWinkFill", library: "bs" },
	{ icon: BsEmojiWink, name: "BsEmojiWink", library: "bs" },
	{ icon: BsEnvelopeFill, name: "BsEnvelopeFill", library: "bs" },
	{ icon: BsEnvelopeOpenFill, name: "BsEnvelopeOpenFill", library: "bs" },
	{ icon: BsEnvelopeOpen, name: "BsEnvelopeOpen", library: "bs" },
	{ icon: BsEnvelope, name: "BsEnvelope", library: "bs" },
	{ icon: BsEraserFill, name: "BsEraserFill", library: "bs" },
	{ icon: BsEraser, name: "BsEraser", library: "bs" },
	{ icon: BsExclamationCircleFill, name: "BsExclamationCircleFill", library: "bs" },
	{ icon: BsExclamationCircle, name: "BsExclamationCircle", library: "bs" },
	{ icon: BsExclamationDiamondFill, name: "BsExclamationDiamondFill", library: "bs" },
	{ icon: BsExclamationDiamond, name: "BsExclamationDiamond", library: "bs" },
	{ icon: BsExclamationLg, name: "BsExclamationLg", library: "bs" },
	{ icon: BsExclamationOctagonFill, name: "BsExclamationOctagonFill", library: "bs" },
	{ icon: BsExclamationOctagon, name: "BsExclamationOctagon", library: "bs" },
	{ icon: BsExclamationSquareFill, name: "BsExclamationSquareFill", library: "bs" },
	{ icon: BsExclamationSquare, name: "BsExclamationSquare", library: "bs" },
	{ icon: BsExclamationTriangleFill, name: "BsExclamationTriangleFill", library: "bs" },
	{ icon: BsExclamationTriangle, name: "BsExclamationTriangle", library: "bs" },
	{ icon: BsExclamation, name: "BsExclamation", library: "bs" },
	{ icon: BsExclude, name: "BsExclude", library: "bs" },
	{ icon: BsEyeFill, name: "BsEyeFill", library: "bs" },
	{ icon: BsEyeSlashFill, name: "BsEyeSlashFill", library: "bs" },
	{ icon: BsEyeSlash, name: "BsEyeSlash", library: "bs" },
	{ icon: BsEye, name: "BsEye", library: "bs" },
	{ icon: BsEyedropper, name: "BsEyedropper", library: "bs" },
	{ icon: BsEyeglasses, name: "BsEyeglasses", library: "bs" },
	{ icon: BsFacebook, name: "BsFacebook", library: "bs" },
	{ icon: BsFileArrowDownFill, name: "BsFileArrowDownFill", library: "bs" },
	{ icon: BsFileArrowDown, name: "BsFileArrowDown", library: "bs" },
	{ icon: BsFileArrowUpFill, name: "BsFileArrowUpFill", library: "bs" },
	{ icon: BsFileArrowUp, name: "BsFileArrowUp", library: "bs" },
	{ icon: BsFileBarGraphFill, name: "BsFileBarGraphFill", library: "bs" },
	{ icon: BsFileBarGraph, name: "BsFileBarGraph", library: "bs" },
	{ icon: BsFileBinaryFill, name: "BsFileBinaryFill", library: "bs" },
	{ icon: BsFileBinary, name: "BsFileBinary", library: "bs" },
	{ icon: BsFileBreakFill, name: "BsFileBreakFill", library: "bs" },
	{ icon: BsFileBreak, name: "BsFileBreak", library: "bs" },
	{ icon: BsFileCheckFill, name: "BsFileCheckFill", library: "bs" },
	{ icon: BsFileCheck, name: "BsFileCheck", library: "bs" },
	{ icon: BsFileCodeFill, name: "BsFileCodeFill", library: "bs" },
	{ icon: BsFileCode, name: "BsFileCode", library: "bs" },
	{ icon: BsFileDiffFill, name: "BsFileDiffFill", library: "bs" },
	{ icon: BsFileDiff, name: "BsFileDiff", library: "bs" },
	{
		icon: BsFileEarmarkArrowDownFill,
		name: "BsFileEarmarkArrowDownFill",
		library: "bs",
	},
	{ icon: BsFileEarmarkArrowDown, name: "BsFileEarmarkArrowDown", library: "bs" },
	{ icon: BsFileEarmarkArrowUpFill, name: "BsFileEarmarkArrowUpFill", library: "bs" },
	{ icon: BsFileEarmarkArrowUp, name: "BsFileEarmarkArrowUp", library: "bs" },
	{ icon: BsFileEarmarkBarGraphFill, name: "BsFileEarmarkBarGraphFill", library: "bs" },
	{ icon: BsFileEarmarkBarGraph, name: "BsFileEarmarkBarGraph", library: "bs" },
	{ icon: BsFileEarmarkBinaryFill, name: "BsFileEarmarkBinaryFill", library: "bs" },
	{ icon: BsFileEarmarkBinary, name: "BsFileEarmarkBinary", library: "bs" },
	{ icon: BsFileEarmarkBreakFill, name: "BsFileEarmarkBreakFill", library: "bs" },
	{ icon: BsFileEarmarkBreak, name: "BsFileEarmarkBreak", library: "bs" },
	{ icon: BsFileEarmarkCheckFill, name: "BsFileEarmarkCheckFill", library: "bs" },
	{ icon: BsFileEarmarkCheck, name: "BsFileEarmarkCheck", library: "bs" },
	{ icon: BsFileEarmarkCodeFill, name: "BsFileEarmarkCodeFill", library: "bs" },
	{ icon: BsFileEarmarkCode, name: "BsFileEarmarkCode", library: "bs" },
	{ icon: BsFileEarmarkDiffFill, name: "BsFileEarmarkDiffFill", library: "bs" },
	{ icon: BsFileEarmarkDiff, name: "BsFileEarmarkDiff", library: "bs" },
	{ icon: BsFileEarmarkEaselFill, name: "BsFileEarmarkEaselFill", library: "bs" },
	{ icon: BsFileEarmarkEasel, name: "BsFileEarmarkEasel", library: "bs" },
	{ icon: BsFileEarmarkExcelFill, name: "BsFileEarmarkExcelFill", library: "bs" },
	{ icon: BsFileEarmarkExcel, name: "BsFileEarmarkExcel", library: "bs" },
	{ icon: BsFileEarmarkFill, name: "BsFileEarmarkFill", library: "bs" },
	{ icon: BsFileEarmarkFontFill, name: "BsFileEarmarkFontFill", library: "bs" },
	{ icon: BsFileEarmarkFont, name: "BsFileEarmarkFont", library: "bs" },
	{ icon: BsFileEarmarkImageFill, name: "BsFileEarmarkImageFill", library: "bs" },
	{ icon: BsFileEarmarkImage, name: "BsFileEarmarkImage", library: "bs" },
	{ icon: BsFileEarmarkLockFill, name: "BsFileEarmarkLockFill", library: "bs" },
	{ icon: BsFileEarmarkLock, name: "BsFileEarmarkLock", library: "bs" },
	{ icon: BsFileEarmarkLock2Fill, name: "BsFileEarmarkLock2Fill", library: "bs" },
	{ icon: BsFileEarmarkLock2, name: "BsFileEarmarkLock2", library: "bs" },
	{ icon: BsFileEarmarkMedicalFill, name: "BsFileEarmarkMedicalFill", library: "bs" },
	{ icon: BsFileEarmarkMedical, name: "BsFileEarmarkMedical", library: "bs" },
	{ icon: BsFileEarmarkMinusFill, name: "BsFileEarmarkMinusFill", library: "bs" },
	{ icon: BsFileEarmarkMinus, name: "BsFileEarmarkMinus", library: "bs" },
	{ icon: BsFileEarmarkMusicFill, name: "BsFileEarmarkMusicFill", library: "bs" },
	{ icon: BsFileEarmarkMusic, name: "BsFileEarmarkMusic", library: "bs" },
	{ icon: BsFileEarmarkPdfFill, name: "BsFileEarmarkPdfFill", library: "bs" },
	{ icon: BsFileEarmarkPdf, name: "BsFileEarmarkPdf", library: "bs" },
	{ icon: BsFileEarmarkPersonFill, name: "BsFileEarmarkPersonFill", library: "bs" },
	{ icon: BsFileEarmarkPerson, name: "BsFileEarmarkPerson", library: "bs" },
	{ icon: BsFileEarmarkPlayFill, name: "BsFileEarmarkPlayFill", library: "bs" },
	{ icon: BsFileEarmarkPlay, name: "BsFileEarmarkPlay", library: "bs" },
	{ icon: BsFileEarmarkPlusFill, name: "BsFileEarmarkPlusFill", library: "bs" },
	{ icon: BsFileEarmarkPlus, name: "BsFileEarmarkPlus", library: "bs" },
	{ icon: BsFileEarmarkPostFill, name: "BsFileEarmarkPostFill", library: "bs" },
	{ icon: BsFileEarmarkPost, name: "BsFileEarmarkPost", library: "bs" },
	{ icon: BsFileEarmarkPptFill, name: "BsFileEarmarkPptFill", library: "bs" },
	{ icon: BsFileEarmarkPpt, name: "BsFileEarmarkPpt", library: "bs" },
	{ icon: BsFileEarmarkRichtextFill, name: "BsFileEarmarkRichtextFill", library: "bs" },
	{ icon: BsFileEarmarkRichtext, name: "BsFileEarmarkRichtext", library: "bs" },
	{ icon: BsFileEarmarkRuledFill, name: "BsFileEarmarkRuledFill", library: "bs" },
	{ icon: BsFileEarmarkRuled, name: "BsFileEarmarkRuled", library: "bs" },
	{ icon: BsFileEarmarkSlidesFill, name: "BsFileEarmarkSlidesFill", library: "bs" },
	{ icon: BsFileEarmarkSlides, name: "BsFileEarmarkSlides", library: "bs" },
	{
		icon: BsFileEarmarkSpreadsheetFill,
		name: "BsFileEarmarkSpreadsheetFill",
		library: "bs",
	},
	{ icon: BsFileEarmarkSpreadsheet, name: "BsFileEarmarkSpreadsheet", library: "bs" },
	{ icon: BsFileEarmarkTextFill, name: "BsFileEarmarkTextFill", library: "bs" },
	{ icon: BsFileEarmarkText, name: "BsFileEarmarkText", library: "bs" },
	{ icon: BsFileEarmarkWordFill, name: "BsFileEarmarkWordFill", library: "bs" },
	{ icon: BsFileEarmarkWord, name: "BsFileEarmarkWord", library: "bs" },
	{ icon: BsFileEarmarkXFill, name: "BsFileEarmarkXFill", library: "bs" },
	{ icon: BsFileEarmarkX, name: "BsFileEarmarkX", library: "bs" },
	{ icon: BsFileEarmarkZipFill, name: "BsFileEarmarkZipFill", library: "bs" },
	{ icon: BsFileEarmarkZip, name: "BsFileEarmarkZip", library: "bs" },
	{ icon: BsFileEarmark, name: "BsFileEarmark", library: "bs" },
	{ icon: BsFileEaselFill, name: "BsFileEaselFill", library: "bs" },
	{ icon: BsFileEasel, name: "BsFileEasel", library: "bs" },
	{ icon: BsFileExcelFill, name: "BsFileExcelFill", library: "bs" },
	{ icon: BsFileExcel, name: "BsFileExcel", library: "bs" },
	{ icon: BsFileFill, name: "BsFileFill", library: "bs" },
	{ icon: BsFileFontFill, name: "BsFileFontFill", library: "bs" },
	{ icon: BsFileFont, name: "BsFileFont", library: "bs" },
	{ icon: BsFileImageFill, name: "BsFileImageFill", library: "bs" },
	{ icon: BsFileImage, name: "BsFileImage", library: "bs" },
	{ icon: BsFileLockFill, name: "BsFileLockFill", library: "bs" },
	{ icon: BsFileLock, name: "BsFileLock", library: "bs" },
	{ icon: BsFileLock2Fill, name: "BsFileLock2Fill", library: "bs" },
	{ icon: BsFileLock2, name: "BsFileLock2", library: "bs" },
	{ icon: BsFileMedicalFill, name: "BsFileMedicalFill", library: "bs" },
	{ icon: BsFileMedical, name: "BsFileMedical", library: "bs" },
	{ icon: BsFileMinusFill, name: "BsFileMinusFill", library: "bs" },
	{ icon: BsFileMinus, name: "BsFileMinus", library: "bs" },
	{ icon: BsFileMusicFill, name: "BsFileMusicFill", library: "bs" },
	{ icon: BsFileMusic, name: "BsFileMusic", library: "bs" },
	{ icon: BsFilePdfFill, name: "BsFilePdfFill", library: "bs" },
	{ icon: BsFilePdf, name: "BsFilePdf", library: "bs" },
	{ icon: BsFilePersonFill, name: "BsFilePersonFill", library: "bs" },
	{ icon: BsFilePerson, name: "BsFilePerson", library: "bs" },
	{ icon: BsFilePlayFill, name: "BsFilePlayFill", library: "bs" },
	{ icon: BsFilePlay, name: "BsFilePlay", library: "bs" },
	{ icon: BsFilePlusFill, name: "BsFilePlusFill", library: "bs" },
	{ icon: BsFilePlus, name: "BsFilePlus", library: "bs" },
	{ icon: BsFilePostFill, name: "BsFilePostFill", library: "bs" },
	{ icon: BsFilePost, name: "BsFilePost", library: "bs" },
	{ icon: BsFilePptFill, name: "BsFilePptFill", library: "bs" },
	{ icon: BsFilePpt, name: "BsFilePpt", library: "bs" },
	{ icon: BsFileRichtextFill, name: "BsFileRichtextFill", library: "bs" },
	{ icon: BsFileRichtext, name: "BsFileRichtext", library: "bs" },
	{ icon: BsFileRuledFill, name: "BsFileRuledFill", library: "bs" },
	{ icon: BsFileRuled, name: "BsFileRuled", library: "bs" },
	{ icon: BsFileSlidesFill, name: "BsFileSlidesFill", library: "bs" },
	{ icon: BsFileSlides, name: "BsFileSlides", library: "bs" },
	{ icon: BsFileSpreadsheetFill, name: "BsFileSpreadsheetFill", library: "bs" },
	{ icon: BsFileSpreadsheet, name: "BsFileSpreadsheet", library: "bs" },
	{ icon: BsFileTextFill, name: "BsFileTextFill", library: "bs" },
	{ icon: BsFileText, name: "BsFileText", library: "bs" },
	{ icon: BsFileWordFill, name: "BsFileWordFill", library: "bs" },
	{ icon: BsFileWord, name: "BsFileWord", library: "bs" },
	{ icon: BsFileXFill, name: "BsFileXFill", library: "bs" },
	{ icon: BsFileX, name: "BsFileX", library: "bs" },
	{ icon: BsFileZipFill, name: "BsFileZipFill", library: "bs" },
	{ icon: BsFileZip, name: "BsFileZip", library: "bs" },
	{ icon: BsFile, name: "BsFile", library: "bs" },
	{ icon: BsFilesAlt, name: "BsFilesAlt", library: "bs" },
	{ icon: BsFiles, name: "BsFiles", library: "bs" },
	{ icon: BsFilm, name: "BsFilm", library: "bs" },
	{ icon: BsFilterCircleFill, name: "BsFilterCircleFill", library: "bs" },
	{ icon: BsFilterCircle, name: "BsFilterCircle", library: "bs" },
	{ icon: BsFilterLeft, name: "BsFilterLeft", library: "bs" },
	{ icon: BsFilterRight, name: "BsFilterRight", library: "bs" },
	{ icon: BsFilterSquareFill, name: "BsFilterSquareFill", library: "bs" },
	{ icon: BsFilterSquare, name: "BsFilterSquare", library: "bs" },
	{ icon: BsFilter, name: "BsFilter", library: "bs" },
	{ icon: BsFlagFill, name: "BsFlagFill", library: "bs" },
	{ icon: BsFlag, name: "BsFlag", library: "bs" },
	{ icon: BsFlower1, name: "BsFlower1", library: "bs" },
	{ icon: BsFlower2, name: "BsFlower2", library: "bs" },
	{ icon: BsFlower3, name: "BsFlower3", library: "bs" },
	{ icon: BsFolderCheck, name: "BsFolderCheck", library: "bs" },
	{ icon: BsFolderFill, name: "BsFolderFill", library: "bs" },
	{ icon: BsFolderMinus, name: "BsFolderMinus", library: "bs" },
	{ icon: BsFolderPlus, name: "BsFolderPlus", library: "bs" },
	{ icon: BsFolderSymlinkFill, name: "BsFolderSymlinkFill", library: "bs" },
	{ icon: BsFolderSymlink, name: "BsFolderSymlink", library: "bs" },
	{ icon: BsFolderX, name: "BsFolderX", library: "bs" },
	{ icon: BsFolder, name: "BsFolder", library: "bs" },
	{ icon: BsFolder2Open, name: "BsFolder2Open", library: "bs" },
	{ icon: BsFolder2, name: "BsFolder2", library: "bs" },
	{ icon: BsFonts, name: "BsFonts", library: "bs" },
	{ icon: BsForwardFill, name: "BsForwardFill", library: "bs" },
	{ icon: BsForward, name: "BsForward", library: "bs" },
	{ icon: BsFront, name: "BsFront", library: "bs" },
	{ icon: BsFullscreenExit, name: "BsFullscreenExit", library: "bs" },
	{ icon: BsFullscreen, name: "BsFullscreen", library: "bs" },
	{ icon: BsFunnelFill, name: "BsFunnelFill", library: "bs" },
	{ icon: BsFunnel, name: "BsFunnel", library: "bs" },
	{ icon: BsGearFill, name: "BsGearFill", library: "bs" },
	{ icon: BsGearWideConnected, name: "BsGearWideConnected", library: "bs" },
	{ icon: BsGearWide, name: "BsGearWide", library: "bs" },
	{ icon: BsGear, name: "BsGear", library: "bs" },
	{ icon: BsGem, name: "BsGem", library: "bs" },
	{ icon: BsGenderAmbiguous, name: "BsGenderAmbiguous", library: "bs" },
	{ icon: BsGenderFemale, name: "BsGenderFemale", library: "bs" },
	{ icon: BsGenderMale, name: "BsGenderMale", library: "bs" },
	{ icon: BsGenderTrans, name: "BsGenderTrans", library: "bs" },
	{ icon: BsGeoAltFill, name: "BsGeoAltFill", library: "bs" },
	{ icon: BsGeoAlt, name: "BsGeoAlt", library: "bs" },
	{ icon: BsGeoFill, name: "BsGeoFill", library: "bs" },
	{ icon: BsGeo, name: "BsGeo", library: "bs" },
	{ icon: BsGiftFill, name: "BsGiftFill", library: "bs" },
	{ icon: BsGift, name: "BsGift", library: "bs" },
	{ icon: BsGithub, name: "BsGithub", library: "bs" },
	{ icon: BsGlobe, name: "BsGlobe", library: "bs" },
	{ icon: BsGlobe2, name: "BsGlobe2", library: "bs" },
	{ icon: BsGoogle, name: "BsGoogle", library: "bs" },
	{ icon: BsGraphDown, name: "BsGraphDown", library: "bs" },
	{ icon: BsGraphUp, name: "BsGraphUp", library: "bs" },
	{ icon: BsGrid1X2Fill, name: "BsGrid1X2Fill", library: "bs" },
	{ icon: BsGrid1X2, name: "BsGrid1X2", library: "bs" },
	{ icon: BsGrid3X2GapFill, name: "BsGrid3X2GapFill", library: "bs" },
	{ icon: BsGrid3X2Gap, name: "BsGrid3X2Gap", library: "bs" },
	{ icon: BsGrid3X2, name: "BsGrid3X2", library: "bs" },
	{ icon: BsGrid3X3GapFill, name: "BsGrid3X3GapFill", library: "bs" },
	{ icon: BsGrid3X3Gap, name: "BsGrid3X3Gap", library: "bs" },
	{ icon: BsGrid3X3, name: "BsGrid3X3", library: "bs" },
	{ icon: BsGridFill, name: "BsGridFill", library: "bs" },
	{ icon: BsGrid, name: "BsGrid", library: "bs" },
	{ icon: BsGripHorizontal, name: "BsGripHorizontal", library: "bs" },
	{ icon: BsGripVertical, name: "BsGripVertical", library: "bs" },
	{ icon: BsHammer, name: "BsHammer", library: "bs" },
	{ icon: BsHandIndexFill, name: "BsHandIndexFill", library: "bs" },
	{ icon: BsHandIndexThumbFill, name: "BsHandIndexThumbFill", library: "bs" },
	{ icon: BsHandIndexThumb, name: "BsHandIndexThumb", library: "bs" },
	{ icon: BsHandIndex, name: "BsHandIndex", library: "bs" },
	{ icon: BsHandThumbsDownFill, name: "BsHandThumbsDownFill", library: "bs" },
	{ icon: BsHandThumbsDown, name: "BsHandThumbsDown", library: "bs" },
	{ icon: BsHandThumbsUpFill, name: "BsHandThumbsUpFill", library: "bs" },
	{ icon: BsHandThumbsUp, name: "BsHandThumbsUp", library: "bs" },
	{ icon: BsHandbagFill, name: "BsHandbagFill", library: "bs" },
	{ icon: BsHandbag, name: "BsHandbag", library: "bs" },
	{ icon: BsHash, name: "BsHash", library: "bs" },
	{ icon: BsHddFill, name: "BsHddFill", library: "bs" },
	{ icon: BsHddNetworkFill, name: "BsHddNetworkFill", library: "bs" },
	{ icon: BsHddNetwork, name: "BsHddNetwork", library: "bs" },
	{ icon: BsHddRackFill, name: "BsHddRackFill", library: "bs" },
	{ icon: BsHddRack, name: "BsHddRack", library: "bs" },
	{ icon: BsHddStackFill, name: "BsHddStackFill", library: "bs" },
	{ icon: BsHddStack, name: "BsHddStack", library: "bs" },
	{ icon: BsHdd, name: "BsHdd", library: "bs" },
	{ icon: BsHeadphones, name: "BsHeadphones", library: "bs" },
	{ icon: BsHeadsetVr, name: "BsHeadsetVr", library: "bs" },
	{ icon: BsHeadset, name: "BsHeadset", library: "bs" },
	{ icon: BsHeartFill, name: "BsHeartFill", library: "bs" },
	{ icon: BsHeartHalf, name: "BsHeartHalf", library: "bs" },
	{ icon: BsHeart, name: "BsHeart", library: "bs" },
	{ icon: BsHeptagonFill, name: "BsHeptagonFill", library: "bs" },
	{ icon: BsHeptagonHalf, name: "BsHeptagonHalf", library: "bs" },
	{ icon: BsHeptagon, name: "BsHeptagon", library: "bs" },
	{ icon: BsHexagonFill, name: "BsHexagonFill", library: "bs" },
	{ icon: BsHexagonHalf, name: "BsHexagonHalf", library: "bs" },
	{ icon: BsHexagon, name: "BsHexagon", library: "bs" },
	{ icon: BsHourglassBottom, name: "BsHourglassBottom", library: "bs" },
	{ icon: BsHourglassSplit, name: "BsHourglassSplit", library: "bs" },
	{ icon: BsHourglassTop, name: "BsHourglassTop", library: "bs" },
	{ icon: BsHourglass, name: "BsHourglass", library: "bs" },
	{ icon: BsHouseDoorFill, name: "BsHouseDoorFill", library: "bs" },
	{ icon: BsHouseDoor, name: "BsHouseDoor", library: "bs" },
	{ icon: BsHouseFill, name: "BsHouseFill", library: "bs" },
	{ icon: BsHouse, name: "BsHouse", library: "bs" },
	{ icon: BsHr, name: "BsHr", library: "bs" },
	{ icon: BsHurricane, name: "BsHurricane", library: "bs" },
	{ icon: BsImageAlt, name: "BsImageAlt", library: "bs" },
	{ icon: BsImageFill, name: "BsImageFill", library: "bs" },
	{ icon: BsImage, name: "BsImage", library: "bs" },
	{ icon: BsImages, name: "BsImages", library: "bs" },
	{ icon: BsInboxFill, name: "BsInboxFill", library: "bs" },
	{ icon: BsInbox, name: "BsInbox", library: "bs" },
	{ icon: BsInboxesFill, name: "BsInboxesFill", library: "bs" },
	{ icon: BsInboxes, name: "BsInboxes", library: "bs" },
	{ icon: BsInfoCircleFill, name: "BsInfoCircleFill", library: "bs" },
	{ icon: BsInfoCircle, name: "BsInfoCircle", library: "bs" },
	{ icon: BsInfoLg, name: "BsInfoLg", library: "bs" },
	{ icon: BsInfoSquareFill, name: "BsInfoSquareFill", library: "bs" },
	{ icon: BsInfoSquare, name: "BsInfoSquare", library: "bs" },
	{ icon: BsInfo, name: "BsInfo", library: "bs" },
	{ icon: BsInputCursorText, name: "BsInputCursorText", library: "bs" },
	{ icon: BsInputCursor, name: "BsInputCursor", library: "bs" },
	{ icon: BsInstagram, name: "BsInstagram", library: "bs" },
	{ icon: BsIntersect, name: "BsIntersect", library: "bs" },
	{ icon: BsJournalAlbum, name: "BsJournalAlbum", library: "bs" },
	{ icon: BsJournalArrowDown, name: "BsJournalArrowDown", library: "bs" },
	{ icon: BsJournalArrowUp, name: "BsJournalArrowUp", library: "bs" },
	{ icon: BsJournalBookmarkFill, name: "BsJournalBookmarkFill", library: "bs" },
	{ icon: BsJournalBookmark, name: "BsJournalBookmark", library: "bs" },
	{ icon: BsJournalCheck, name: "BsJournalCheck", library: "bs" },
	{ icon: BsJournalCode, name: "BsJournalCode", library: "bs" },
	{ icon: BsJournalMedical, name: "BsJournalMedical", library: "bs" },
	{ icon: BsJournalMinus, name: "BsJournalMinus", library: "bs" },
	{ icon: BsJournalPlus, name: "BsJournalPlus", library: "bs" },
	{ icon: BsJournalRichtext, name: "BsJournalRichtext", library: "bs" },
	{ icon: BsJournalText, name: "BsJournalText", library: "bs" },
	{ icon: BsJournalX, name: "BsJournalX", library: "bs" },
	{ icon: BsJournal, name: "BsJournal", library: "bs" },
	{ icon: BsJournals, name: "BsJournals", library: "bs" },
	{ icon: BsJoystick, name: "BsJoystick", library: "bs" },
	{ icon: BsJustifyLeft, name: "BsJustifyLeft", library: "bs" },
	{ icon: BsJustifyRight, name: "BsJustifyRight", library: "bs" },
	{ icon: BsJustify, name: "BsJustify", library: "bs" },
	{ icon: BsKanbanFill, name: "BsKanbanFill", library: "bs" },
	{ icon: BsKanban, name: "BsKanban", library: "bs" },
	{ icon: BsKeyFill, name: "BsKeyFill", library: "bs" },
	{ icon: BsKey, name: "BsKey", library: "bs" },
	{ icon: BsKeyboardFill, name: "BsKeyboardFill", library: "bs" },
	{ icon: BsKeyboard, name: "BsKeyboard", library: "bs" },
	{ icon: BsLadder, name: "BsLadder", library: "bs" },
	{ icon: BsLampFill, name: "BsLampFill", library: "bs" },
	{ icon: BsLamp, name: "BsLamp", library: "bs" },
	{ icon: BsLaptopFill, name: "BsLaptopFill", library: "bs" },
	{ icon: BsLaptop, name: "BsLaptop", library: "bs" },
	{ icon: BsLayerBackward, name: "BsLayerBackward", library: "bs" },
	{ icon: BsLayerForward, name: "BsLayerForward", library: "bs" },
	{ icon: BsLayersFill, name: "BsLayersFill", library: "bs" },
	{ icon: BsLayersHalf, name: "BsLayersHalf", library: "bs" },
	{ icon: BsLayers, name: "BsLayers", library: "bs" },
	{
		icon: BsLayoutSidebarInsetReverse,
		name: "BsLayoutSidebarInsetReverse",
		library: "bs",
	},
	{ icon: BsLayoutSidebarInset, name: "BsLayoutSidebarInset", library: "bs" },
	{ icon: BsLayoutSidebarReverse, name: "BsLayoutSidebarReverse", library: "bs" },
	{ icon: BsLayoutSidebar, name: "BsLayoutSidebar", library: "bs" },
	{ icon: BsLayoutSplit, name: "BsLayoutSplit", library: "bs" },
	{
		icon: BsLayoutTextSidebarReverse,
		name: "BsLayoutTextSidebarReverse",
		library: "bs",
	},
	{ icon: BsLayoutTextSidebar, name: "BsLayoutTextSidebar", library: "bs" },
	{ icon: BsLayoutTextWindowReverse, name: "BsLayoutTextWindowReverse", library: "bs" },
	{ icon: BsLayoutTextWindow, name: "BsLayoutTextWindow", library: "bs" },
	{ icon: BsLayoutThreeColumns, name: "BsLayoutThreeColumns", library: "bs" },
	{ icon: BsLayoutWtf, name: "BsLayoutWtf", library: "bs" },
	{ icon: BsLifePreserver, name: "BsLifePreserver", library: "bs" },
	{ icon: BsLightbulbFill, name: "BsLightbulbFill", library: "bs" },
	{ icon: BsLightbulbOffFill, name: "BsLightbulbOffFill", library: "bs" },
	{ icon: BsLightbulbOff, name: "BsLightbulbOff", library: "bs" },
	{ icon: BsLightbulb, name: "BsLightbulb", library: "bs" },
	{ icon: BsLightningChargeFill, name: "BsLightningChargeFill", library: "bs" },
	{ icon: BsLightningCharge, name: "BsLightningCharge", library: "bs" },
	{ icon: BsLightningFill, name: "BsLightningFill", library: "bs" },
	{ icon: BsLightning, name: "BsLightning", library: "bs" },
	{ icon: BsLine, name: "BsLine", library: "bs" },
	{ icon: BsLink45Deg, name: "BsLink45Deg", library: "bs" },
	{ icon: BsLink, name: "BsLink", library: "bs" },
	{ icon: BsLinkedin, name: "BsLinkedin", library: "bs" },
	{ icon: BsListCheck, name: "BsListCheck", library: "bs" },
	{ icon: BsListNested, name: "BsListNested", library: "bs" },
	{ icon: BsListOl, name: "BsListOl", library: "bs" },
	{ icon: BsListStars, name: "BsListStars", library: "bs" },
	{ icon: BsListTask, name: "BsListTask", library: "bs" },
	{ icon: BsListUl, name: "BsListUl", library: "bs" },
	{ icon: BsList, name: "BsList", library: "bs" },
	{ icon: BsLockFill, name: "BsLockFill", library: "bs" },
	{ icon: BsLock, name: "BsLock", library: "bs" },
	{ icon: BsMailbox, name: "BsMailbox", library: "bs" },
	{ icon: BsMailbox2, name: "BsMailbox2", library: "bs" },
	{ icon: BsMapFill, name: "BsMapFill", library: "bs" },
	{ icon: BsMap, name: "BsMap", library: "bs" },
	{ icon: BsMarkdownFill, name: "BsMarkdownFill", library: "bs" },
	{ icon: BsMarkdown, name: "BsMarkdown", library: "bs" },
	{ icon: BsMask, name: "BsMask", library: "bs" },
	{ icon: BsMastodon, name: "BsMastodon", library: "bs" },
	{ icon: BsMedium, name: "BsMedium", library: "bs" },
	{ icon: BsMegaphoneFill, name: "BsMegaphoneFill", library: "bs" },
	{ icon: BsMegaphone, name: "BsMegaphone", library: "bs" },
	{ icon: BsMenuAppFill, name: "BsMenuAppFill", library: "bs" },
	{ icon: BsMenuApp, name: "BsMenuApp", library: "bs" },
	{ icon: BsMenuButtonFill, name: "BsMenuButtonFill", library: "bs" },
	{ icon: BsMenuButtonWideFill, name: "BsMenuButtonWideFill", library: "bs" },
	{ icon: BsMenuButtonWide, name: "BsMenuButtonWide", library: "bs" },
	{ icon: BsMenuButton, name: "BsMenuButton", library: "bs" },
	{ icon: BsMenuDown, name: "BsMenuDown", library: "bs" },
	{ icon: BsMenuUp, name: "BsMenuUp", library: "bs" },
	{ icon: BsMessenger, name: "BsMessenger", library: "bs" },
	{ icon: BsMicFill, name: "BsMicFill", library: "bs" },
	{ icon: BsMicMuteFill, name: "BsMicMuteFill", library: "bs" },
	{ icon: BsMicMute, name: "BsMicMute", library: "bs" },
	{ icon: BsMic, name: "BsMic", library: "bs" },
	{ icon: BsMicrosoft, name: "BsMicrosoft", library: "bs" },
	{ icon: BsMinecartLoaded, name: "BsMinecartLoaded", library: "bs" },
	{ icon: BsMinecart, name: "BsMinecart", library: "bs" },
	{ icon: BsMoisture, name: "BsMoisture", library: "bs" },
	{ icon: BsMoonFill, name: "BsMoonFill", library: "bs" },
	{ icon: BsMoonStarsFill, name: "BsMoonStarsFill", library: "bs" },
	{ icon: BsMoonStars, name: "BsMoonStars", library: "bs" },
	{ icon: BsMoon, name: "BsMoon", library: "bs" },
	{ icon: BsMouseFill, name: "BsMouseFill", library: "bs" },
	{ icon: BsMouse, name: "BsMouse", library: "bs" },
	{ icon: BsMouse2Fill, name: "BsMouse2Fill", library: "bs" },
	{ icon: BsMouse2, name: "BsMouse2", library: "bs" },
	{ icon: BsMouse3Fill, name: "BsMouse3Fill", library: "bs" },
	{ icon: BsMouse3, name: "BsMouse3", library: "bs" },
	{ icon: BsMusicNoteBeamed, name: "BsMusicNoteBeamed", library: "bs" },
	{ icon: BsMusicNoteList, name: "BsMusicNoteList", library: "bs" },
	{ icon: BsMusicNote, name: "BsMusicNote", library: "bs" },
	{ icon: BsMusicPlayerFill, name: "BsMusicPlayerFill", library: "bs" },
	{ icon: BsMusicPlayer, name: "BsMusicPlayer", library: "bs" },
	{ icon: BsNewspaper, name: "BsNewspaper", library: "bs" },
	{ icon: BsNodeMinusFill, name: "BsNodeMinusFill", library: "bs" },
	{ icon: BsNodeMinus, name: "BsNodeMinus", library: "bs" },
	{ icon: BsNodePlusFill, name: "BsNodePlusFill", library: "bs" },
	{ icon: BsNodePlus, name: "BsNodePlus", library: "bs" },
	{ icon: BsNutFill, name: "BsNutFill", library: "bs" },
	{ icon: BsNut, name: "BsNut", library: "bs" },
	{ icon: BsOctagonFill, name: "BsOctagonFill", library: "bs" },
	{ icon: BsOctagonHalf, name: "BsOctagonHalf", library: "bs" },
	{ icon: BsOctagon, name: "BsOctagon", library: "bs" },
	{ icon: BsOption, name: "BsOption", library: "bs" },
	{ icon: BsOutlet, name: "BsOutlet", library: "bs" },
	{ icon: BsPaintBucket, name: "BsPaintBucket", library: "bs" },
	{ icon: BsPaletteFill, name: "BsPaletteFill", library: "bs" },
	{ icon: BsPalette, name: "BsPalette", library: "bs" },
	{ icon: BsPalette2, name: "BsPalette2", library: "bs" },
	{ icon: BsPaperclip, name: "BsPaperclip", library: "bs" },
	{ icon: BsParagraph, name: "BsParagraph", library: "bs" },
	{ icon: BsPatchCheckFill, name: "BsPatchCheckFill", library: "bs" },
	{ icon: BsPatchCheck, name: "BsPatchCheck", library: "bs" },
	{ icon: BsPatchExclamationFill, name: "BsPatchExclamationFill", library: "bs" },
	{ icon: BsPatchExclamation, name: "BsPatchExclamation", library: "bs" },
	{ icon: BsPatchMinusFill, name: "BsPatchMinusFill", library: "bs" },
	{ icon: BsPatchMinus, name: "BsPatchMinus", library: "bs" },
	{ icon: BsPatchPlusFill, name: "BsPatchPlusFill", library: "bs" },
	{ icon: BsPatchPlus, name: "BsPatchPlus", library: "bs" },
	{ icon: BsPatchQuestionFill, name: "BsPatchQuestionFill", library: "bs" },
	{ icon: BsPatchQuestion, name: "BsPatchQuestion", library: "bs" },
	{ icon: BsPauseBtnFill, name: "BsPauseBtnFill", library: "bs" },
	{ icon: BsPauseBtn, name: "BsPauseBtn", library: "bs" },
	{ icon: BsPauseCircleFill, name: "BsPauseCircleFill", library: "bs" },
	{ icon: BsPauseCircle, name: "BsPauseCircle", library: "bs" },
	{ icon: BsPauseFill, name: "BsPauseFill", library: "bs" },
	{ icon: BsPause, name: "BsPause", library: "bs" },
	{ icon: BsPaypal, name: "BsPaypal", library: "bs" },
	{ icon: BsPeaceFill, name: "BsPeaceFill", library: "bs" },
	{ icon: BsPeace, name: "BsPeace", library: "bs" },
	{ icon: BsPenFill, name: "BsPenFill", library: "bs" },
	{ icon: BsPen, name: "BsPen", library: "bs" },
	{ icon: BsPencilFill, name: "BsPencilFill", library: "bs" },
	{ icon: BsPencilSquare, name: "BsPencilSquare", library: "bs" },
	{ icon: BsPencil, name: "BsPencil", library: "bs" },
	{ icon: BsPentagonFill, name: "BsPentagonFill", library: "bs" },
	{ icon: BsPentagonHalf, name: "BsPentagonHalf", library: "bs" },
	{ icon: BsPentagon, name: "BsPentagon", library: "bs" },
	{ icon: BsPeopleFill, name: "BsPeopleFill", library: "bs" },
	{ icon: BsPeople, name: "BsPeople", library: "bs" },
	{ icon: BsPercent, name: "BsPercent", library: "bs" },
	{ icon: BsPersonBadgeFill, name: "BsPersonBadgeFill", library: "bs" },
	{ icon: BsPersonBadge, name: "BsPersonBadge", library: "bs" },
	{ icon: BsPersonBoundingBox, name: "BsPersonBoundingBox", library: "bs" },
	{ icon: BsPersonCheckFill, name: "BsPersonCheckFill", library: "bs" },
	{ icon: BsPersonCheck, name: "BsPersonCheck", library: "bs" },
	{ icon: BsPersonCircle, name: "BsPersonCircle", library: "bs" },
	{ icon: BsPersonDashFill, name: "BsPersonDashFill", library: "bs" },
	{ icon: BsPersonDash, name: "BsPersonDash", library: "bs" },
	{ icon: BsPersonFill, name: "BsPersonFill", library: "bs" },
	{ icon: BsPersonLinesFill, name: "BsPersonLinesFill", library: "bs" },
	{ icon: BsPersonPlusFill, name: "BsPersonPlusFill", library: "bs" },
	{ icon: BsPersonPlus, name: "BsPersonPlus", library: "bs" },
	{ icon: BsPersonSquare, name: "BsPersonSquare", library: "bs" },
	{ icon: BsPersonXFill, name: "BsPersonXFill", library: "bs" },
	{ icon: BsPersonX, name: "BsPersonX", library: "bs" },
	{ icon: BsPerson, name: "BsPerson", library: "bs" },
	{ icon: BsPhoneFill, name: "BsPhoneFill", library: "bs" },
	{ icon: BsPhoneLandscapeFill, name: "BsPhoneLandscapeFill", library: "bs" },
	{ icon: BsPhoneLandscape, name: "BsPhoneLandscape", library: "bs" },
	{ icon: BsPhoneVibrateFill, name: "BsPhoneVibrateFill", library: "bs" },
	{ icon: BsPhoneVibrate, name: "BsPhoneVibrate", library: "bs" },
	{ icon: BsPhone, name: "BsPhone", library: "bs" },
	{ icon: BsPieChartFill, name: "BsPieChartFill", library: "bs" },
	{ icon: BsPieChart, name: "BsPieChart", library: "bs" },
	{ icon: BsPiggyBankFill, name: "BsPiggyBankFill", library: "bs" },
	{ icon: BsPiggyBank, name: "BsPiggyBank", library: "bs" },
	{ icon: BsPinAngleFill, name: "BsPinAngleFill", library: "bs" },
	{ icon: BsPinAngle, name: "BsPinAngle", library: "bs" },
	{ icon: BsPinFill, name: "BsPinFill", library: "bs" },
	{ icon: BsPinMapFill, name: "BsPinMapFill", library: "bs" },
	{ icon: BsPinMap, name: "BsPinMap", library: "bs" },
	{ icon: BsPin, name: "BsPin", library: "bs" },
	{ icon: BsPinterest, name: "BsPinterest", library: "bs" },
	{ icon: BsPipFill, name: "BsPipFill", library: "bs" },
	{ icon: BsPip, name: "BsPip", library: "bs" },
	{ icon: BsPlayBtnFill, name: "BsPlayBtnFill", library: "bs" },
	{ icon: BsPlayBtn, name: "BsPlayBtn", library: "bs" },
	{ icon: BsPlayCircleFill, name: "BsPlayCircleFill", library: "bs" },
	{ icon: BsPlayCircle, name: "BsPlayCircle", library: "bs" },
	{ icon: BsPlayFill, name: "BsPlayFill", library: "bs" },
	{ icon: BsPlay, name: "BsPlay", library: "bs" },
	{ icon: BsPlugFill, name: "BsPlugFill", library: "bs" },
	{ icon: BsPlug, name: "BsPlug", library: "bs" },
	{ icon: BsPlusCircleDotted, name: "BsPlusCircleDotted", library: "bs" },
	{ icon: BsPlusCircleFill, name: "BsPlusCircleFill", library: "bs" },
	{ icon: BsPlusCircle, name: "BsPlusCircle", library: "bs" },
	{ icon: BsPlusLg, name: "BsPlusLg", library: "bs" },
	{ icon: BsPlusSquareDotted, name: "BsPlusSquareDotted", library: "bs" },
	{ icon: BsPlusSquareFill, name: "BsPlusSquareFill", library: "bs" },
	{ icon: BsPlusSquare, name: "BsPlusSquare", library: "bs" },
	{ icon: BsPlus, name: "BsPlus", library: "bs" },
	{ icon: BsPower, name: "BsPower", library: "bs" },
	{ icon: BsPrinterFill, name: "BsPrinterFill", library: "bs" },
	{ icon: BsPrinter, name: "BsPrinter", library: "bs" },
	{ icon: BsPuzzleFill, name: "BsPuzzleFill", library: "bs" },
	{ icon: BsPuzzle, name: "BsPuzzle", library: "bs" },
	{ icon: BsQuestionCircleFill, name: "BsQuestionCircleFill", library: "bs" },
	{ icon: BsQuestionCircle, name: "BsQuestionCircle", library: "bs" },
	{ icon: BsQuestionDiamondFill, name: "BsQuestionDiamondFill", library: "bs" },
	{ icon: BsQuestionDiamond, name: "BsQuestionDiamond", library: "bs" },
	{ icon: BsQuestionLg, name: "BsQuestionLg", library: "bs" },
	{ icon: BsQuestionOctagonFill, name: "BsQuestionOctagonFill", library: "bs" },
	{ icon: BsQuestionOctagon, name: "BsQuestionOctagon", library: "bs" },
	{ icon: BsQuestionSquareFill, name: "BsQuestionSquareFill", library: "bs" },
	{ icon: BsQuestionSquare, name: "BsQuestionSquare", library: "bs" },
	{ icon: BsQuestion, name: "BsQuestion", library: "bs" },
	{ icon: BsRainbow, name: "BsRainbow", library: "bs" },
	{ icon: BsReceiptCutoff, name: "BsReceiptCutoff", library: "bs" },
	{ icon: BsReceipt, name: "BsReceipt", library: "bs" },
	{ icon: BsReception0, name: "BsReception0", library: "bs" },
	{ icon: BsReception1, name: "BsReception1", library: "bs" },
	{ icon: BsReception2, name: "BsReception2", library: "bs" },
	{ icon: BsReception3, name: "BsReception3", library: "bs" },
	{ icon: BsReception4, name: "BsReception4", library: "bs" },
	{ icon: BsRecordBtnFill, name: "BsRecordBtnFill", library: "bs" },
	{ icon: BsRecordBtn, name: "BsRecordBtn", library: "bs" },
	{ icon: BsRecordCircleFill, name: "BsRecordCircleFill", library: "bs" },
	{ icon: BsRecordCircle, name: "BsRecordCircle", library: "bs" },
	{ icon: BsRecordFill, name: "BsRecordFill", library: "bs" },
	{ icon: BsRecord, name: "BsRecord", library: "bs" },
	{ icon: BsRecord2Fill, name: "BsRecord2Fill", library: "bs" },
	{ icon: BsRecord2, name: "BsRecord2", library: "bs" },
	{ icon: BsRecycle, name: "BsRecycle", library: "bs" },
	{ icon: BsReddit, name: "BsReddit", library: "bs" },
	{ icon: BsReplyAllFill, name: "BsReplyAllFill", library: "bs" },
	{ icon: BsReplyAll, name: "BsReplyAll", library: "bs" },
	{ icon: BsReplyFill, name: "BsReplyFill", library: "bs" },
	{ icon: BsReply, name: "BsReply", library: "bs" },
	{ icon: BsRssFill, name: "BsRssFill", library: "bs" },
	{ icon: BsRss, name: "BsRss", library: "bs" },
	{ icon: BsRulers, name: "BsRulers", library: "bs" },
	{ icon: BsSafeFill, name: "BsSafeFill", library: "bs" },
	{ icon: BsSafe, name: "BsSafe", library: "bs" },
	{ icon: BsSafe2Fill, name: "BsSafe2Fill", library: "bs" },
	{ icon: BsSafe2, name: "BsSafe2", library: "bs" },
	{ icon: BsSaveFill, name: "BsSaveFill", library: "bs" },
	{ icon: BsSave, name: "BsSave", library: "bs" },
	{ icon: BsSave2Fill, name: "BsSave2Fill", library: "bs" },
	{ icon: BsSave2, name: "BsSave2", library: "bs" },
	{ icon: BsScissors, name: "BsScissors", library: "bs" },
	{ icon: BsScrewdriver, name: "BsScrewdriver", library: "bs" },
	{ icon: BsSdCardFill, name: "BsSdCardFill", library: "bs" },
	{ icon: BsSdCard, name: "BsSdCard", library: "bs" },
	{ icon: BsSearch, name: "BsSearch", library: "bs" },
	{ icon: BsSegmentedNav, name: "BsSegmentedNav", library: "bs" },
	{ icon: BsServer, name: "BsServer", library: "bs" },
	{ icon: BsShareFill, name: "BsShareFill", library: "bs" },
	{ icon: BsShare, name: "BsShare", library: "bs" },
	{ icon: BsShieldCheck, name: "BsShieldCheck", library: "bs" },
	{ icon: BsShieldExclamation, name: "BsShieldExclamation", library: "bs" },
	{ icon: BsShieldFillCheck, name: "BsShieldFillCheck", library: "bs" },
	{ icon: BsShieldFillExclamation, name: "BsShieldFillExclamation", library: "bs" },
	{ icon: BsShieldFillMinus, name: "BsShieldFillMinus", library: "bs" },
	{ icon: BsShieldFillPlus, name: "BsShieldFillPlus", library: "bs" },
	{ icon: BsShieldFillX, name: "BsShieldFillX", library: "bs" },
	{ icon: BsShieldFill, name: "BsShieldFill", library: "bs" },
	{ icon: BsShieldLockFill, name: "BsShieldLockFill", library: "bs" },
	{ icon: BsShieldLock, name: "BsShieldLock", library: "bs" },
	{ icon: BsShieldMinus, name: "BsShieldMinus", library: "bs" },
	{ icon: BsShieldPlus, name: "BsShieldPlus", library: "bs" },
	{ icon: BsShieldShaded, name: "BsShieldShaded", library: "bs" },
	{ icon: BsShieldSlashFill, name: "BsShieldSlashFill", library: "bs" },
	{ icon: BsShieldSlash, name: "BsShieldSlash", library: "bs" },
	{ icon: BsShieldX, name: "BsShieldX", library: "bs" },
	{ icon: BsShield, name: "BsShield", library: "bs" },
	{ icon: BsShiftFill, name: "BsShiftFill", library: "bs" },
	{ icon: BsShift, name: "BsShift", library: "bs" },
	{ icon: BsShopWindow, name: "BsShopWindow", library: "bs" },
	{ icon: BsShop, name: "BsShop", library: "bs" },
	{ icon: BsShuffle, name: "BsShuffle", library: "bs" },
	{ icon: BsSignal, name: "BsSignal", library: "bs" },
	{ icon: BsSignpost2Fill, name: "BsSignpost2Fill", library: "bs" },
	{ icon: BsSignpost2, name: "BsSignpost2", library: "bs" },
	{ icon: BsSignpostFill, name: "BsSignpostFill", library: "bs" },
	{ icon: BsSignpostSplitFill, name: "BsSignpostSplitFill", library: "bs" },
	{ icon: BsSignpostSplit, name: "BsSignpostSplit", library: "bs" },
	{ icon: BsSignpost, name: "BsSignpost", library: "bs" },
	{ icon: BsSimFill, name: "BsSimFill", library: "bs" },
	{ icon: BsSim, name: "BsSim", library: "bs" },
	{ icon: BsSkipBackwardBtnFill, name: "BsSkipBackwardBtnFill", library: "bs" },
	{ icon: BsSkipBackwardBtn, name: "BsSkipBackwardBtn", library: "bs" },
	{ icon: BsSkipBackwardCircleFill, name: "BsSkipBackwardCircleFill", library: "bs" },
	{ icon: BsSkipBackwardCircle, name: "BsSkipBackwardCircle", library: "bs" },
	{ icon: BsSkipBackwardFill, name: "BsSkipBackwardFill", library: "bs" },
	{ icon: BsSkipBackward, name: "BsSkipBackward", library: "bs" },
	{ icon: BsSkipEndBtnFill, name: "BsSkipEndBtnFill", library: "bs" },
	{ icon: BsSkipEndBtn, name: "BsSkipEndBtn", library: "bs" },
	{ icon: BsSkipEndCircleFill, name: "BsSkipEndCircleFill", library: "bs" },
	{ icon: BsSkipEndCircle, name: "BsSkipEndCircle", library: "bs" },
	{ icon: BsSkipEndFill, name: "BsSkipEndFill", library: "bs" },
	{ icon: BsSkipEnd, name: "BsSkipEnd", library: "bs" },
	{ icon: BsSkipForwardBtnFill, name: "BsSkipForwardBtnFill", library: "bs" },
	{ icon: BsSkipForwardBtn, name: "BsSkipForwardBtn", library: "bs" },
	{ icon: BsSkipForwardCircleFill, name: "BsSkipForwardCircleFill", library: "bs" },
	{ icon: BsSkipForwardCircle, name: "BsSkipForwardCircle", library: "bs" },
	{ icon: BsSkipForwardFill, name: "BsSkipForwardFill", library: "bs" },
	{ icon: BsSkipForward, name: "BsSkipForward", library: "bs" },
	{ icon: BsSkipStartBtnFill, name: "BsSkipStartBtnFill", library: "bs" },
	{ icon: BsSkipStartBtn, name: "BsSkipStartBtn", library: "bs" },
	{ icon: BsSkipStartCircleFill, name: "BsSkipStartCircleFill", library: "bs" },
	{ icon: BsSkipStartCircle, name: "BsSkipStartCircle", library: "bs" },
	{ icon: BsSkipStartFill, name: "BsSkipStartFill", library: "bs" },
	{ icon: BsSkipStart, name: "BsSkipStart", library: "bs" },
	{ icon: BsSkype, name: "BsSkype", library: "bs" },
	{ icon: BsSlack, name: "BsSlack", library: "bs" },
	{ icon: BsSlashCircleFill, name: "BsSlashCircleFill", library: "bs" },
	{ icon: BsSlashCircle, name: "BsSlashCircle", library: "bs" },
	{ icon: BsSlashLg, name: "BsSlashLg", library: "bs" },
	{ icon: BsSlashSquareFill, name: "BsSlashSquareFill", library: "bs" },
	{ icon: BsSlashSquare, name: "BsSlashSquare", library: "bs" },
	{ icon: BsSlash, name: "BsSlash", library: "bs" },
	{ icon: BsSliders, name: "BsSliders", library: "bs" },
	{ icon: BsSmartwatch, name: "BsSmartwatch", library: "bs" },
	{ icon: BsSnapchat, name: "BsSnapchat", library: "bs" },
	{ icon: BsSnow, name: "BsSnow", library: "bs" },
	{ icon: BsSnow2, name: "BsSnow2", library: "bs" },
	{ icon: BsSnow3, name: "BsSnow3", library: "bs" },
	{ icon: BsSortAlphaDownAlt, name: "BsSortAlphaDownAlt", library: "bs" },
	{ icon: BsSortAlphaDown, name: "BsSortAlphaDown", library: "bs" },
	{ icon: BsSortAlphaUpAlt, name: "BsSortAlphaUpAlt", library: "bs" },
	{ icon: BsSortAlphaUp, name: "BsSortAlphaUp", library: "bs" },
	{ icon: BsSortDownAlt, name: "BsSortDownAlt", library: "bs" },
	{ icon: BsSortDown, name: "BsSortDown", library: "bs" },
	{ icon: BsSortNumericDownAlt, name: "BsSortNumericDownAlt", library: "bs" },
	{ icon: BsSortNumericDown, name: "BsSortNumericDown", library: "bs" },
	{ icon: BsSortNumericUpAlt, name: "BsSortNumericUpAlt", library: "bs" },
	{ icon: BsSortNumericUp, name: "BsSortNumericUp", library: "bs" },
	{ icon: BsSortUpAlt, name: "BsSortUpAlt", library: "bs" },
	{ icon: BsSortUp, name: "BsSortUp", library: "bs" },
	{ icon: BsSoundwave, name: "BsSoundwave", library: "bs" },
	{ icon: BsSpeakerFill, name: "BsSpeakerFill", library: "bs" },
	{ icon: BsSpeaker, name: "BsSpeaker", library: "bs" },
	{ icon: BsSpeedometer, name: "BsSpeedometer", library: "bs" },
	{ icon: BsSpeedometer2, name: "BsSpeedometer2", library: "bs" },
	{ icon: BsSpellcheck, name: "BsSpellcheck", library: "bs" },
	{ icon: BsSpotify, name: "BsSpotify", library: "bs" },
	{ icon: BsSquareFill, name: "BsSquareFill", library: "bs" },
	{ icon: BsSquareHalf, name: "BsSquareHalf", library: "bs" },
	{ icon: BsSquare, name: "BsSquare", library: "bs" },
	{ icon: BsStackOverflow, name: "BsStackOverflow", library: "bs" },
	{ icon: BsStack, name: "BsStack", library: "bs" },
	{ icon: BsStarFill, name: "BsStarFill", library: "bs" },
	{ icon: BsStarHalf, name: "BsStarHalf", library: "bs" },
	{ icon: BsStar, name: "BsStar", library: "bs" },
	{ icon: BsStars, name: "BsStars", library: "bs" },
	{ icon: BsStickiesFill, name: "BsStickiesFill", library: "bs" },
	{ icon: BsStickies, name: "BsStickies", library: "bs" },
	{ icon: BsStickyFill, name: "BsStickyFill", library: "bs" },
	{ icon: BsSticky, name: "BsSticky", library: "bs" },
	{ icon: BsStopBtnFill, name: "BsStopBtnFill", library: "bs" },
	{ icon: BsStopBtn, name: "BsStopBtn", library: "bs" },
	{ icon: BsStopCircleFill, name: "BsStopCircleFill", library: "bs" },
	{ icon: BsStopCircle, name: "BsStopCircle", library: "bs" },
	{ icon: BsStopFill, name: "BsStopFill", library: "bs" },
	{ icon: BsStop, name: "BsStop", library: "bs" },
	{ icon: BsStoplightsFill, name: "BsStoplightsFill", library: "bs" },
	{ icon: BsStoplights, name: "BsStoplights", library: "bs" },
	{ icon: BsStopwatchFill, name: "BsStopwatchFill", library: "bs" },
	{ icon: BsStopwatch, name: "BsStopwatch", library: "bs" },
	{ icon: BsStrava, name: "BsStrava", library: "bs" },
	{ icon: BsSubtract, name: "BsSubtract", library: "bs" },
	{ icon: BsSuitClubFill, name: "BsSuitClubFill", library: "bs" },
	{ icon: BsSuitClub, name: "BsSuitClub", library: "bs" },
	{ icon: BsSuitDiamondFill, name: "BsSuitDiamondFill", library: "bs" },
	{ icon: BsSuitDiamond, name: "BsSuitDiamond", library: "bs" },
	{ icon: BsSuitHeartFill, name: "BsSuitHeartFill", library: "bs" },
	{ icon: BsSuitHeart, name: "BsSuitHeart", library: "bs" },
	{ icon: BsSuitSpadeFill, name: "BsSuitSpadeFill", library: "bs" },
	{ icon: BsSuitSpade, name: "BsSuitSpade", library: "bs" },
	{ icon: BsSunFill, name: "BsSunFill", library: "bs" },
	{ icon: BsSun, name: "BsSun", library: "bs" },
	{ icon: BsSunglasses, name: "BsSunglasses", library: "bs" },
	{ icon: BsSunriseFill, name: "BsSunriseFill", library: "bs" },
	{ icon: BsSunrise, name: "BsSunrise", library: "bs" },
	{ icon: BsSunsetFill, name: "BsSunsetFill", library: "bs" },
	{ icon: BsSunset, name: "BsSunset", library: "bs" },
	{ icon: BsSymmetryHorizontal, name: "BsSymmetryHorizontal", library: "bs" },
	{ icon: BsSymmetryVertical, name: "BsSymmetryVertical", library: "bs" },
	{ icon: BsTable, name: "BsTable", library: "bs" },
	{ icon: BsTabletFill, name: "BsTabletFill", library: "bs" },
	{ icon: BsTabletLandscapeFill, name: "BsTabletLandscapeFill", library: "bs" },
	{ icon: BsTabletLandscape, name: "BsTabletLandscape", library: "bs" },
	{ icon: BsTablet, name: "BsTablet", library: "bs" },
	{ icon: BsTagFill, name: "BsTagFill", library: "bs" },
	{ icon: BsTag, name: "BsTag", library: "bs" },
	{ icon: BsTagsFill, name: "BsTagsFill", library: "bs" },
	{ icon: BsTags, name: "BsTags", library: "bs" },
	{ icon: BsTelegram, name: "BsTelegram", library: "bs" },
	{ icon: BsTelephoneFill, name: "BsTelephoneFill", library: "bs" },
	{ icon: BsTelephoneForwardFill, name: "BsTelephoneForwardFill", library: "bs" },
	{ icon: BsTelephoneForward, name: "BsTelephoneForward", library: "bs" },
	{ icon: BsTelephoneInboundFill, name: "BsTelephoneInboundFill", library: "bs" },
	{ icon: BsTelephoneInbound, name: "BsTelephoneInbound", library: "bs" },
	{ icon: BsTelephoneMinusFill, name: "BsTelephoneMinusFill", library: "bs" },
	{ icon: BsTelephoneMinus, name: "BsTelephoneMinus", library: "bs" },
	{ icon: BsTelephoneOutboundFill, name: "BsTelephoneOutboundFill", library: "bs" },
	{ icon: BsTelephoneOutbound, name: "BsTelephoneOutbound", library: "bs" },
	{ icon: BsTelephonePlusFill, name: "BsTelephonePlusFill", library: "bs" },
	{ icon: BsTelephonePlus, name: "BsTelephonePlus", library: "bs" },
	{ icon: BsTelephoneXFill, name: "BsTelephoneXFill", library: "bs" },
	{ icon: BsTelephoneX, name: "BsTelephoneX", library: "bs" },
	{ icon: BsTelephone, name: "BsTelephone", library: "bs" },
	{ icon: BsTerminalFill, name: "BsTerminalFill", library: "bs" },
	{ icon: BsTerminal, name: "BsTerminal", library: "bs" },
	{ icon: BsTextCenter, name: "BsTextCenter", library: "bs" },
	{ icon: BsTextIndentLeft, name: "BsTextIndentLeft", library: "bs" },
	{ icon: BsTextIndentRight, name: "BsTextIndentRight", library: "bs" },
	{ icon: BsTextLeft, name: "BsTextLeft", library: "bs" },
	{ icon: BsTextParagraph, name: "BsTextParagraph", library: "bs" },
	{ icon: BsTextRight, name: "BsTextRight", library: "bs" },
	{ icon: BsTextareaResize, name: "BsTextareaResize", library: "bs" },
	{ icon: BsTextareaT, name: "BsTextareaT", library: "bs" },
	{ icon: BsTextarea, name: "BsTextarea", library: "bs" },
	{ icon: BsThermometerHalf, name: "BsThermometerHalf", library: "bs" },
	{ icon: BsThermometerHigh, name: "BsThermometerHigh", library: "bs" },
	{ icon: BsThermometerLow, name: "BsThermometerLow", library: "bs" },
	{ icon: BsThermometerSnow, name: "BsThermometerSnow", library: "bs" },
	{ icon: BsThermometerSun, name: "BsThermometerSun", library: "bs" },
	{ icon: BsThermometer, name: "BsThermometer", library: "bs" },
	{ icon: BsThreeDotsVertical, name: "BsThreeDotsVertical", library: "bs" },
	{ icon: BsThreeDots, name: "BsThreeDots", library: "bs" },
	{ icon: BsToggleOff, name: "BsToggleOff", library: "bs" },
	{ icon: BsToggleOn, name: "BsToggleOn", library: "bs" },
	{ icon: BsToggle2Off, name: "BsToggle2Off", library: "bs" },
	{ icon: BsToggle2On, name: "BsToggle2On", library: "bs" },
	{ icon: BsToggles, name: "BsToggles", library: "bs" },
	{ icon: BsToggles2, name: "BsToggles2", library: "bs" },
	{ icon: BsTools, name: "BsTools", library: "bs" },
	{ icon: BsTornado, name: "BsTornado", library: "bs" },
	{ icon: BsTranslate, name: "BsTranslate", library: "bs" },
	{ icon: BsTrashFill, name: "BsTrashFill", library: "bs" },
	{ icon: BsTrash, name: "BsTrash", library: "bs" },
	{ icon: BsTrash2Fill, name: "BsTrash2Fill", library: "bs" },
	{ icon: BsTrash2, name: "BsTrash2", library: "bs" },
	{ icon: BsTreeFill, name: "BsTreeFill", library: "bs" },
	{ icon: BsTree, name: "BsTree", library: "bs" },
	{ icon: BsTriangleFill, name: "BsTriangleFill", library: "bs" },
	{ icon: BsTriangleHalf, name: "BsTriangleHalf", library: "bs" },
	{ icon: BsTriangle, name: "BsTriangle", library: "bs" },
	{ icon: BsTrophyFill, name: "BsTrophyFill", library: "bs" },
	{ icon: BsTrophy, name: "BsTrophy", library: "bs" },
	{ icon: BsTropicalStorm, name: "BsTropicalStorm", library: "bs" },
	{ icon: BsTruckFlatbed, name: "BsTruckFlatbed", library: "bs" },
	{ icon: BsTruck, name: "BsTruck", library: "bs" },
	{ icon: BsTsunami, name: "BsTsunami", library: "bs" },
	{ icon: BsTvFill, name: "BsTvFill", library: "bs" },
	{ icon: BsTv, name: "BsTv", library: "bs" },
	{ icon: BsTwitch, name: "BsTwitch", library: "bs" },
	{ icon: BsTwitter, name: "BsTwitter", library: "bs" },
	{ icon: BsTypeBold, name: "BsTypeBold", library: "bs" },
	{ icon: BsTypeH1, name: "BsTypeH1", library: "bs" },
	{ icon: BsTypeH2, name: "BsTypeH2", library: "bs" },
	{ icon: BsTypeH3, name: "BsTypeH3", library: "bs" },
	{ icon: BsTypeItalic, name: "BsTypeItalic", library: "bs" },
	{ icon: BsTypeStrikethrough, name: "BsTypeStrikethrough", library: "bs" },
	{ icon: BsTypeUnderline, name: "BsTypeUnderline", library: "bs" },
	{ icon: BsType, name: "BsType", library: "bs" },
	{ icon: BsUiChecksGrid, name: "BsUiChecksGrid", library: "bs" },
	{ icon: BsUiChecks, name: "BsUiChecks", library: "bs" },
	{ icon: BsUiRadiosGrid, name: "BsUiRadiosGrid", library: "bs" },
	{ icon: BsUiRadios, name: "BsUiRadios", library: "bs" },
	{ icon: BsUmbrellaFill, name: "BsUmbrellaFill", library: "bs" },
	{ icon: BsUmbrella, name: "BsUmbrella", library: "bs" },
	{ icon: BsUnion, name: "BsUnion", library: "bs" },
	{ icon: BsUnlockFill, name: "BsUnlockFill", library: "bs" },
	{ icon: BsUnlock, name: "BsUnlock", library: "bs" },
	{ icon: BsUpcScan, name: "BsUpcScan", library: "bs" },
	{ icon: BsUpc, name: "BsUpc", library: "bs" },
	{ icon: BsUpload, name: "BsUpload", library: "bs" },
	{ icon: BsVectorPen, name: "BsVectorPen", library: "bs" },
	{ icon: BsViewList, name: "BsViewList", library: "bs" },
	{ icon: BsViewStacked, name: "BsViewStacked", library: "bs" },
	{ icon: BsVimeo, name: "BsVimeo", library: "bs" },
	{ icon: BsVinylFill, name: "BsVinylFill", library: "bs" },
	{ icon: BsVinyl, name: "BsVinyl", library: "bs" },
	{ icon: BsVoicemail, name: "BsVoicemail", library: "bs" },
	{ icon: BsVolumeDownFill, name: "BsVolumeDownFill", library: "bs" },
	{ icon: BsVolumeDown, name: "BsVolumeDown", library: "bs" },
	{ icon: BsVolumeMuteFill, name: "BsVolumeMuteFill", library: "bs" },
	{ icon: BsVolumeMute, name: "BsVolumeMute", library: "bs" },
	{ icon: BsVolumeOffFill, name: "BsVolumeOffFill", library: "bs" },
	{ icon: BsVolumeOff, name: "BsVolumeOff", library: "bs" },
	{ icon: BsVolumeUpFill, name: "BsVolumeUpFill", library: "bs" },
	{ icon: BsVolumeUp, name: "BsVolumeUp", library: "bs" },
	{ icon: BsVr, name: "BsVr", library: "bs" },
	{ icon: BsWalletFill, name: "BsWalletFill", library: "bs" },
	{ icon: BsWallet, name: "BsWallet", library: "bs" },
	{ icon: BsWallet2, name: "BsWallet2", library: "bs" },
	{ icon: BsWatch, name: "BsWatch", library: "bs" },
	{ icon: BsWater, name: "BsWater", library: "bs" },
	{ icon: BsWhatsapp, name: "BsWhatsapp", library: "bs" },
	{ icon: BsWifi1, name: "BsWifi1", library: "bs" },
	{ icon: BsWifi2, name: "BsWifi2", library: "bs" },
	{ icon: BsWifiOff, name: "BsWifiOff", library: "bs" },
	{ icon: BsWifi, name: "BsWifi", library: "bs" },
	{ icon: BsWind, name: "BsWind", library: "bs" },
	{ icon: BsWindowDock, name: "BsWindowDock", library: "bs" },
	{ icon: BsWindowSidebar, name: "BsWindowSidebar", library: "bs" },
	{ icon: BsWindow, name: "BsWindow", library: "bs" },
	{ icon: BsWindows, name: "BsWindows", library: "bs" },
	{ icon: BsWordpress, name: "BsWordpress", library: "bs" },
	{ icon: BsWrench, name: "BsWrench", library: "bs" },
	{ icon: BsXCircleFill, name: "BsXCircleFill", library: "bs" },
	{ icon: BsXCircle, name: "BsXCircle", library: "bs" },
	{ icon: BsXDiamondFill, name: "BsXDiamondFill", library: "bs" },
	{ icon: BsXDiamond, name: "BsXDiamond", library: "bs" },
	{ icon: BsXLg, name: "BsXLg", library: "bs" },
	{ icon: BsXOctagonFill, name: "BsXOctagonFill", library: "bs" },
	{ icon: BsXOctagon, name: "BsXOctagon", library: "bs" },
	{ icon: BsXSquareFill, name: "BsXSquareFill", library: "bs" },
	{ icon: BsXSquare, name: "BsXSquare", library: "bs" },
	{ icon: BsX, name: "BsX", library: "bs" },
	{ icon: BsYoutube, name: "BsYoutube", library: "bs" },
	{ icon: BsZoomIn, name: "BsZoomIn", library: "bs" },
	{ icon: BsZoomOut, name: "BsZoomOut", library: "bs" },
];

export default result;
